var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _path, _path2, _symbol0, _symbol1, _path3, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _path4, _path5, _path6, _path7, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _path8, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _path9, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _path0, _path1, _symbol50;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgSprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flower",
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#98b8e9",
    style: {
      fill: "var(--color1, #98b8e9)"
    },
    d: "M23.459 6.018c-5.061-5.921-9.621 3.696-8.355 4.511s3.202 2.665 3.5 3.701c0.298 1.036 9.916-2.29 4.855-8.211z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f7581",
    style: {
      fill: "var(--color2, #8f7581)"
    },
    d: "M17.329 30.531c7.097-1.826 0.854-9.549-0.418-8.789s-3.639 1.132-4.689 0.945-2.007 9.674 5.107 7.844z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6634e",
    style: {
      fill: "var(--color3, #b6634e)"
    },
    d: "M27.195 20.981c2.871-6.179-6.817-6.662-7.291-5.848s-2.046 3.224-2.477 4.081c-0.431 0.857 6.768 8.224 9.768 1.768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7d6a3c",
    style: {
      fill: "var(--color4, #7d6a3c)"
    },
    d: "M7.409 2.778c7.767-3.237 7.771 6.935 6.348 7.433s-4.623 1.222-5.156 2.16c-0.533 0.939-7.273-7.059-1.192-9.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7ab52",
    style: {
      fill: "var(--color5, #c7ab52)"
    },
    d: "M1.489 14.087c1.689-5.659 7.904-0.427 7.538 0.698s-1.397 2.37-1.059 3.151c0.338 0.781-8.169 1.81-6.479-3.849z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#779153",
    style: {
      fill: "var(--color6, #779153)"
    },
    d: "M2.903 26.003c-4.745-4.494 4.478-7.521 5.213-6.439s1.404 2.443 2.309 2.665-2.178 8.837-7.522 3.775z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9ff64",
    style: {
      fill: "var(--color7, #e9ff64)"
    },
    d: "M23.895 15.21c0 0-1.962 3.925-3.644 5.564-1.196 1.167-1.851 1.887-3.471 2.509-2.276 0.873-4.516 0.634-6.037-0.557-2.010-1.265-3.284-3.396-3.444-5.725-0.186-2.638 0.902-4.962 2.972-6.35 3.432-2.29 8.279-1.094 9.483 2.897 0.849 2.813-0.558 5.622-3.221 6.36-2.109 0.587-4.293-0.313-5.083-2.355-0.457-1.409-0.258-2.853 0.832-3.833 1.113-0.991 2.823-1.075 3.89-0.179 1.143 0.957 1.276 2.786 0.038 3.723-0.962 0.686-2.33 0.462-2.792-0.568-0.296-0.667-0.093-1.489 0.547-1.788 0.293-0.141 0.633-0.135 0.882 0.001-0.283 0.016-0.52 0.136-0.673 0.302-0.304 0.331-0.268 0.794-0.045 1.112 0.276 0.418 0.961 0.528 1.45 0.124 0.631-0.585 0.379-1.516-0.195-1.925-0.537-0.383-1.483-0.35-2.091 0.266-0.559 0.578-0.613 1.434-0.31 2.167 0.537 1.188 1.826 1.6 3.043 1.222 1.751-0.553 2.213-2.118 1.683-3.826-0.856-2.788-3.407-2.918-5.769-1.429-1.526 0.934-2.494 2.774-1.766 4.831 0.756 2.137 2.009 2.871 3.954 3.731 4.679 2.068 9.767-6.273 9.767-6.273z"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ai-models",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.674 2.778c-7.552 0-13.674 6.094-13.674 13.61 0 7.518 6.12 13.612 13.674 13.612 7.552 0 13.674-6.094 13.674-13.612 0-0.6-0.49-1.088-1.094-1.088-0.001 0-0.001 0-0.002 0-0.602 0-1.090 0.487-1.092 1.088v0c0 6.316-5.142 11.434-11.486 11.434s-11.486-5.12-11.486-11.434c0-6.314 5.142-11.432 11.486-11.432 0.001 0 0.001 0 0.002 0 0.602 0 1.091-0.488 1.092-1.090v-0c0-0.6-0.49-1.088-1.094-1.088zM20.754 6.044c0-0.46 0.374-0.832 0.836-0.832h2.39v-2.38c0-0.462 0.374-0.836 0.836-0.836s0.836 0.374 0.836 0.836v0 2.38h2.39c0.017-0.001 0.037-0.002 0.058-0.002 0.461 0 0.834 0.373 0.834 0.834s-0.373 0.834-0.834 0.834c-0.020 0-0.040-0.001-0.060-0.002l0.003 0h-2.39v2.38c0 0.462-0.375 0.837-0.837 0.837s-0.837-0.375-0.837-0.837v0-2.38h-2.388c-0.001 0-0.001 0-0.002 0-0.46 0-0.833-0.372-0.834-0.832v-0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.020 17h-2.286l-1.114-0.74 0.872-1.264c0.36-0.506 0.544-1.1 0.544-1.72 0-0.050 0-0.094-0.008-0.148-0.784-0.274-1.73-0.952-2.464-2.030-1.006 1.316-2.032 2.084-3.36 2.634 0.066 0.454 0.234 0.886 0.506 1.264l0.872 1.266-1.276 0.84c-1.22 0.81-2.067 2.097-2.277 3.589l-0.003 0.027h4.678c0.456 0 0.596 0.168 0.612 0.7 0.018 0.556-0.134 0.788-0.61 0.788h-5.472c-0.406-0.003-0.734-0.333-0.734-0.74 0-0.001 0-0.003 0-0.004v0c0-0.252 0.016-0.498 0.044-0.744 0.226-2.040 1.339-3.781 2.94-4.851l0.024-0.015c-0.072-0.099-0.145-0.214-0.211-0.332l-0.009-0.018c-0.68 0.008-1.372-0.044-2.054-0.736 0.734 0 1.468-0.744 1.468-1.488 0-2.464 1.974-4.464 4.4-4.464 2.43 0 4.402 2 4.402 4.464 0 0.744 0.734 1.488 1.468 1.488-0.682 0.692-1.372 0.744-2.054 0.736-0.066 0.12-0.14 0.24-0.22 0.35 0.484 0.328 0.932 0.708 1.32 1.146z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ai-photoshooting",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.93 8.125h-3.757l-0.437-1.313c-0.211-0.637-0.617-1.192-1.162-1.585s-1.199-0.604-1.87-0.603h-5.406c-0.671-0.001-1.325 0.211-1.869 0.603s-0.951 0.947-1.162 1.584l-0.438 1.313h-3.757c-0.847 0.001-1.659 0.338-2.259 0.937s-0.936 1.411-0.937 2.259v12.863c0.002 0.847 0.339 1.658 0.938 2.256s1.411 0.935 2.257 0.936h19.863c0.847-0.002 1.658-0.339 2.256-0.938s0.935-1.411 0.936-2.257v-12.863c-0.002-0.847-0.339-1.658-0.938-2.256s-1.411-0.935-2.257-0.936zM27.375 24.18c-0 0.383-0.153 0.751-0.424 1.022s-0.638 0.423-1.022 0.424h-19.859c-0.383-0-0.751-0.153-1.022-0.424s-0.423-0.638-0.424-1.022v-12.863c0.001-0.383 0.154-0.749 0.425-1.019s0.638-0.422 1.020-0.423h4.388c0.184-0 0.362-0.058 0.511-0.165s0.26-0.259 0.318-0.433l0.638-1.914c0.096-0.288 0.28-0.538 0.526-0.716s0.542-0.273 0.845-0.272h5.406c0.303-0 0.599 0.095 0.846 0.273s0.43 0.428 0.526 0.716l0.638 1.913c0.058 0.174 0.169 0.326 0.318 0.433s0.328 0.165 0.511 0.165h4.388c0.383 0 0.751 0.153 1.022 0.424s0.423 0.638 0.424 1.022v12.859z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.75c-1.298 0-2.567 0.385-3.646 1.106s-1.92 1.746-2.417 2.945c-0.497 1.199-0.627 2.519-0.373 3.792s0.878 2.442 1.796 3.36c0.918 0.918 2.087 1.543 3.36 1.796s2.593 0.123 3.792-0.374c1.199-0.497 2.224-1.338 2.945-2.417s1.106-2.348 1.106-3.646c-0.002-1.74-0.694-3.408-1.924-4.638s-2.898-1.922-4.638-1.924zM16 22.125c-0.952 0-1.882-0.282-2.674-0.811s-1.408-1.28-1.772-2.16c-0.364-0.879-0.46-1.847-0.274-2.781s0.644-1.791 1.317-2.464c0.673-0.673 1.531-1.131 2.464-1.317s1.901-0.090 2.781 0.274c0.879 0.364 1.631 0.981 2.16 1.772s0.811 1.722 0.811 2.674c-0.001 1.276-0.509 2.499-1.411 3.401s-2.125 1.41-3.401 1.411z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.75 13.375c0.483 0 0.875-0.392 0.875-0.875s-0.392-0.875-0.875-0.875c-0.483 0-0.875 0.392-0.875 0.875s0.392 0.875 0.875 0.875z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.325 10.713c-0.089-0.089-0.213-0.145-0.349-0.145-0.114 0-0.22 0.039-0.304 0.104l0.001-0.001-0.047 0.041-4.938 4.938c-0.089 0.089-0.145 0.213-0.145 0.349 0 0.114 0.039 0.22 0.104 0.304l-0.001-0.001 0.041 0.047 4.938 4.938c0.090 0.097 0.218 0.157 0.361 0.157 0.272 0 0.493-0.221 0.493-0.493 0-0.12-0.043-0.23-0.115-0.316l0.001 0.001-0.041-0.047-4.589-4.589 4.589-4.589c0.089-0.089 0.144-0.213 0.144-0.349 0-0.114-0.039-0.22-0.104-0.304l0.001 0.001-0.041-0.047z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.401 15.94c0-0.372 0.142-0.744 0.426-1.027l5.148-5.149c0.568-0.567 1.488-0.567 2.055 0s0.568 1.488 0 2.055l-2.668 2.668h11.205c0.803 0 1.453 0.651 1.453 1.453s-0.651 1.453-1.453 1.453h-11.205l2.668 2.668c0.568 0.568 0.568 1.488 0 2.055s-1.488 0.567-2.055 0l-5.148-5.149c-0.284-0.284-0.426-0.656-0.426-1.027z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.675 10.713c0.089-0.089 0.213-0.145 0.349-0.145 0.114 0 0.22 0.039 0.304 0.104l-0.001-0.001 0.047 0.041 4.938 4.938c0.089 0.089 0.145 0.213 0.145 0.349 0 0.114-0.039 0.22-0.104 0.304l0.001-0.001-0.041 0.047-4.938 4.938c-0.090 0.097-0.218 0.157-0.361 0.157-0.272 0-0.493-0.221-0.493-0.493 0-0.12 0.043-0.23 0.115-0.316l-0.001 0.001 0.041-0.047 4.589-4.589-4.589-4.589c-0.089-0.089-0.144-0.213-0.144-0.349 0-0.114 0.039-0.22 0.104-0.304l-0.001 0.001 0.041-0.047z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-cards",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.746 7.478c-0.287-0.287-0.738-0.309-1.051-0.066l-0.075 0.066-7.959 7.959c-0.287 0.287-0.309 0.739-0.066 1.051l0.066 0.075 7.959 7.959c0.311 0.311 0.815 0.311 1.125 0 0.287-0.287 0.309-0.738 0.066-1.051l-0.066-0.075-7.396-7.396 7.396-7.396c0.287-0.287 0.309-0.738 0.066-1.051l-0.066-0.075z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-double_arrow",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 16l6-6v12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 16l-6-6v12z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow_medium",
    viewBox: "0 0 16 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.866 0.426c0.451-0.524 1.16-0.564 1.65-0.121l0.118 0.121 12.5 14.545c0.45 0.524 0.485 1.35 0.104 1.92l-0.104 0.137-12.5 14.545c-0.488 0.568-1.28 0.568-1.768 0-0.451-0.524-0.485-1.349-0.104-1.92l0.104-0.137 11.615-13.517-11.615-13.517c-0.451-0.524-0.485-1.35-0.104-1.92l0.104-0.137z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bell",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.090 30.888c1.461 0 2.646-1.185 2.646-2.646v0h-5.292c0 1.461 1.185 2.646 2.646 2.646v0zM27.9 24.78c0.064-0.149 0.101-0.323 0.101-0.506 0-0.366-0.149-0.697-0.389-0.936l-2.26-2.26v-7.392c-0.007-4.644-3.429-8.486-7.889-9.15l-0.051-0.006v-1.43c-0.040-0.699-0.616-1.251-1.322-1.251s-1.282 0.552-1.322 1.248l-0 0.003v1.43c-4.511 0.669-7.934 4.512-7.94 9.155v7.393l-2.26 2.26c-0.24 0.239-0.388 0.57-0.388 0.936 0 0.73 0.592 1.322 1.322 1.322 0.001 0 0.002 0 0.003 0h21.172c0.001 0 0.002 0 0.003 0 0.548 0 1.017-0.333 1.218-0.807l0.003-0.009zM8.7 22.95l0.386-0.388c0.24-0.24 0.388-0.57 0.388-0.936v-7.94c0-3.654 2.962-6.616 6.616-6.616s6.616 2.962 6.616 6.616v7.94c0 0.352 0.14 0.688 0.388 0.936l0.388 0.388h-14.782z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-burger-menu-dropdown",
    viewBox: "0 0 34 32"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h34.286v32h-34.286v-32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-5211.429-3929.143v-11.429h-11.429v11.429h11.429zM2219.429-3929.143h11.429v-11.429h-11.429v11.429zM2219.429 12345.143v11.429h11.429v-11.429h-11.429zM-5211.429 12345.143h-11.429v11.429h11.429v-11.429zM-5211.429-3917.714h7430.857v-22.857h-7430.857v22.857zM2208-3929.143v16274.286h22.857v-16274.286h-22.857zM2219.429 12333.714h-7430.857v22.857h7430.857v-22.857zM-5200 12345.143v-16274.286h-22.857v16274.286h22.857z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9747ff",
    style: {
      stroke: "var(--color3, #9747ff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.2857,
    d: "M-272-28.571h322.286c5.681 0 10.286 4.605 10.286 10.286v68.571c0 5.681-4.605 10.286-10.286 10.286h-322.286c-5.681 0-10.286-4.605-10.286-10.286v-68.571c0-5.681 4.605-10.286 10.286-10.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#151515",
    style: {
      stroke: "var(--color2, #151515)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.6292,
    d: "M27.429 11.429l-10.286 9.143-10.286-9.143"
  })), _symbol0 || (_symbol0 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check",
    viewBox: "0 0 45 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.526 2.301c0.538 0.52 0.871 1.248 0.871 2.054 0 0.769-0.304 1.468-0.799 1.982l0.001-0.001-23.402 24.288c-0.521 0.54-1.25 0.875-2.058 0.875s-1.537-0.335-2.057-0.874l-10.884-11.297c-0.495-0.513-0.801-1.213-0.801-1.984 0-1.579 1.28-2.858 2.858-2.858 0.808 0 1.537 0.335 2.057 0.873l8.826 9.162 21.344-22.15c0.52-0.538 1.248-0.871 2.054-0.871 0.773 0 1.474 0.307 1.988 0.805l-0.001-0.001z"
  }))), _symbol1 || (_symbol1 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check-box",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.734 0.853c1.212 1.168 1.248 3.097 0.080 4.309l-24.962 25.905c-0.574 0.596-1.367 0.933-2.195 0.933s-1.62-0.337-2.194-0.933l-11.61-12.049c-1.168-1.212-1.132-3.141 0.080-4.309s3.141-1.132 4.309 0.080l9.415 9.771 22.767-23.627c1.168-1.212 3.098-1.248 4.309-0.080z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check-green",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4bae4f",
    style: {
      fill: "var(--color1, #4bae4f)"
    },
    d: "M16 0c-8.825 0-16 7.175-16 16s7.175 16 16 16 16-7.175 16-16-7.175-16-16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M23.737 10.606c0.18 0.181 0.291 0.431 0.291 0.707s-0.111 0.525-0.291 0.707l-9.374 9.375c-0.194 0.194-0.45 0.294-0.706 0.294s-0.512-0.1-0.706-0.294l-4.687-4.687c-0.18-0.181-0.291-0.431-0.291-0.706s0.111-0.525 0.291-0.706l-0 0c0.181-0.18 0.431-0.291 0.706-0.291s0.525 0.111 0.706 0.291l3.981 3.981 8.669-8.669c0.18-0.183 0.43-0.296 0.707-0.296s0.527 0.113 0.706 0.296l0 0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check-monochrome",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#151515",
    style: {
      stroke: "var(--color3, #151515)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.6,
    d: "M16 0.8c8.395 0 15.2 6.805 15.2 15.2s-6.805 15.2-15.2 15.2c-8.395 0-15.2-6.805-15.2-15.2s6.805-15.2 15.2-15.2z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.563 9.15c0.269 0.26 0.436 0.624 0.436 1.027 0 0.385-0.152 0.734-0.399 0.991l0-0-11.701 12.144c-0.26 0.27-0.625 0.437-1.029 0.437s-0.769-0.168-1.028-0.437l-0-0-5.442-5.648c-0.248-0.257-0.4-0.607-0.4-0.992 0-0.789 0.64-1.429 1.429-1.429 0.404 0 0.768 0.167 1.028 0.437l0 0 4.413 4.581 10.672-11.075c0.26-0.27 0.625-0.437 1.029-0.437 0.386 0 0.735 0.153 0.992 0.401l-0-0z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check-round",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2cad9",
    style: {
      fill: "var(--color1, #f2cad9)"
    },
    d: "M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151515",
    style: {
      fill: "var(--color2, #151515)"
    },
    opacity: 0.7,
    d: "M25.563 9.15c0.568 0.547 0.585 1.452 0.037 2.020l-11.701 12.143c-0.269 0.28-0.641 0.437-1.029 0.437s-0.759-0.158-1.029-0.437l-5.442-5.648c-0.547-0.568-0.531-1.472 0.037-2.020s1.473-0.531 2.020 0.037l4.413 4.58 10.672-11.075c0.548-0.568 1.452-0.585 2.020-0.037z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-dislike",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ed5c76",
    style: {
      stroke: "var(--color4, #ed5c76)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.1429,
    d: "M0.571 16c0-8.497 6.931-15.429 15.429-15.429s15.429 6.931 15.429 15.429-6.931 15.429-15.429 15.429-15.429-6.931-15.429-15.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed5c76",
    style: {
      fill: "var(--color4, #ed5c76)"
    },
    d: "M24.105 19.097h-3.544v-10.19c0.1-0.499 0.562-0.873 1.083-0.873h2.461c0.597 0 1.082 0.486 1.082 1.083v8.897c0 0.597-0.486 1.083-1.082 1.083zM7.253 17.91c0.554 0.71 1.549 1.186 2.476 1.186h5.221c0 0 0 0 0 0 0.147 0 0.266 0.119 0.266 0.266 0 0.025-0.004 0.050-0.010 0.073l0-0.002-0.66 2.367c-0.635 2.277 0.203 2.913 2.131 3.733 0.18 0.077 0.355 0.078 0.537 0.004 0.181-0.074 0.305-0.197 0.38-0.378l2.437-5.85v-10.253l-2.455-1.023h-6.502c-1.923 0-2.643 2.042-2.863 2.92l-1.345 5.353c-0.174 0.693 0.114 1.255 0.387 1.604z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-dislike-checked",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed5c76",
    style: {
      fill: "var(--color1, #ed5c76)"
    },
    d: "M16 0c-8.812 0-16 7.188-16 16s7.188 16 16 16 16-7.188 16-16c0-8.812-7.188-16-16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M24.105 19.096h-3.544v-10.191c0.1-0.499 0.561-0.872 1.083-0.872h2.461c0.597 0 1.082 0.486 1.082 1.083v8.898c0 0.597-0.486 1.082-1.082 1.082zM7.253 17.91c0.553 0.71 1.549 1.186 2.476 1.186h5.221c0.083 0 0.161 0.039 0.211 0.105s0.067 0.152 0.044 0.232l-0.66 2.366c-0.635 2.277 0.203 2.913 2.131 3.733 0.18 0.077 0.356 0.078 0.537 0.004s0.305-0.197 0.38-0.378l2.436-5.85v-10.253l-2.455-1.023h-6.502c-1.923 0-2.643 2.042-2.863 2.92l-1.344 5.353c-0.174 0.693 0.115 1.255 0.387 1.604z"
  })), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-download",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 26.5c0 0.828-0.672 1.5-1.5 1.5v0h-21c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5v0h21c0.828 0 1.5 0.672 1.5 1.5v0zM14.94 21.748c0.271 0.273 0.646 0.441 1.060 0.441s0.789-0.169 1.060-0.441l5.316-5.314c0.26-0.269 0.421-0.637 0.421-1.042 0-0.828-0.672-1.5-1.5-1.5-0.405 0-0.773 0.161-1.043 0.422l0-0-2.754 2.75v-11.564c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5v0 11.566l-2.754-2.754c-0.275-0.294-0.665-0.477-1.097-0.477-0.828 0-1.5 0.672-1.5 1.5 0 0.433 0.183 0.823 0.477 1.097l0.001 0.001 5.314 5.316z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-like",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#475aff",
    style: {
      stroke: "var(--color5, #475aff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.1429,
    d: "M31.429 16c0 8.497-6.931 15.429-15.429 15.429s-15.429-6.931-15.429-15.429 6.931-15.429 15.429-15.429 15.429 6.931 15.429 15.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#475aff",
    style: {
      fill: "var(--color5, #475aff)"
    },
    d: "M7.895 12.903h3.544v10.19c-0.1 0.499-0.562 0.873-1.083 0.873h-2.461c-0.598-0.001-1.082-0.485-1.082-1.083v-8.897c0-0.597 0.486-1.083 1.082-1.083zM24.747 14.090c-0.554-0.71-1.549-1.186-2.476-1.186h-5.221c-0 0-0 0-0 0-0.147 0-0.266-0.119-0.266-0.266 0-0.025 0.004-0.050 0.010-0.073l-0 0.002 0.66-2.367c0.635-2.277-0.203-2.913-2.131-3.733-0.080-0.037-0.174-0.059-0.273-0.059-0.095 0-0.186 0.020-0.268 0.056l0.004-0.002c-0.175 0.069-0.311 0.204-0.378 0.374l-0.002 0.004-2.437 5.849v10.253l2.455 1.023h6.502c1.923 0 2.643-2.042 2.863-2.92l1.345-5.353c0.174-0.693-0.114-1.255-0.387-1.604z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-like-checked",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#475aff",
    style: {
      fill: "var(--color3, #475aff)",
      stroke: "var(--color3, #475aff)"
    },
    stroke: "#475aff",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.1429,
    d: "M31.429 16c0 8.497-6.932 15.429-15.429 15.429s-15.429-6.932-15.429-15.429c0-8.497 6.932-15.429 15.429-15.429s15.429 6.932 15.429 15.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M7.895 12.903h3.544v10.191c-0.1 0.499-0.562 0.872-1.083 0.872h-2.461c-0.597 0-1.082-0.486-1.082-1.083v-8.898c0-0.597 0.486-1.082 1.082-1.082zM24.747 14.090c-0.553-0.71-1.549-1.186-2.476-1.186h-5.221c-0.083 0-0.161-0.039-0.211-0.105s-0.067-0.152-0.044-0.232l0.66-2.366c0.635-2.277-0.203-2.913-2.131-3.733-0.18-0.077-0.356-0.078-0.537-0.004s-0.305 0.197-0.38 0.378l-2.437 5.85v10.253l2.455 1.023h6.502c1.923 0 2.643-2.042 2.863-2.92l1.344-5.353c0.174-0.693-0.115-1.255-0.387-1.604z"
  })), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-lock",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.751 28h-13.5c-1.242-0.002-2.249-1.008-2.251-2.251v-10.5c0-1.24 1.011-2.249 2.251-2.249h13.5c1.24 0 2.249 1.009 2.249 2.251v10.499c-0.002 1.242-1.008 2.249-2.251 2.251h-0zM9.251 14.5c-0.415 0-0.751 0.336-0.751 0.751v0 10.499c0 0.415 0.337 0.751 0.751 0.751h13.5c0.413 0 0.749-0.336 0.749-0.751v-10.5c-0.001-0.414-0.337-0.749-0.751-0.749 0 0 0 0 0 0h-13.499z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.251 14.5c-0.415 0-0.751-0.336-0.751-0.751v0-3.749c-0.003-2.484-2.016-4.497-4.5-4.5h-0c-2.484 0.003-4.497 2.016-4.5 4.5v3.751c-0.017 0.401-0.347 0.719-0.75 0.719s-0.733-0.318-0.75-0.717l-0-0.002v-3.751c0-3.309 2.691-6 6-6s6 2.691 6 6v3.751c0 0.413-0.336 0.749-0.751 0.749z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo",
    viewBox: "0 0 94 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color6, #000)"
    },
    d: "M56.439 11.121c0.859 0 2.219 0.18 2.471 0.427 0.326 0.32 1.616 1.708 2.69 3.415 0.718 1.14 0.571 2.329 0.426 3.501-0.072 0.583-0.144 1.162-0.108 1.729 0.077 1.217-0.61 1.513-1.401 1.852-0.318 0.137-0.654 0.281-0.962 0.496-1.074 0.747-3.116 0.534-5.158 0s-2.794-2.028-3.761-4.056c-0.68-1.426-0.138-2.060 0.393-2.682 0.224-0.263 0.447-0.524 0.575-0.841 0.343-0.854 3.367-2.918 4.836-3.842zM56.367 13.204c-0.948 0.601-2.9 1.943-3.122 2.498-0.082 0.206-0.226 0.375-0.37 0.546-0.343 0.404-0.693 0.817-0.254 1.743 0.624 1.318 1.11 2.289 2.428 2.636s2.636 0.486 3.33 0c0.199-0.14 0.415-0.233 0.622-0.322 0.51-0.222 0.954-0.414 0.905-1.204-0.023-0.369 0.023-0.745 0.070-1.124 0.094-0.762 0.188-1.534-0.275-2.275-0.694-1.11-1.526-2.012-1.737-2.22-0.162-0.161-1.040-0.278-1.596-0.278z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color6, #000)"
    },
    d: "M34.198 22.693c0.074 0.087 0.299 0.446 0.524 0.446s0.749-0.491 0.749-0.67c0-0.223 0.468-0.784 0.543-1.007s0.749-1.711 0.749-1.934 0.973-1.116 1.048-1.265c0.074-0.148 0.574-0.984 0.674-1.265 0.094-0.263 0.524-0.778 0.674-0.927s0.318-0.972 0.449-1.081c0.081-0.068 0.224 0.297 0.224 0.521s0.594 2.010 0.674 2.232c0.094 0.258 1.030 1.528 1.254 1.677 0.18 0.119 0.743-0.313 0.842-0.412 0 0 1.797-2.839 1.871-3.274 0.075-0.433 0.15-1.487 0.15-1.487 0.15 0.174 0.075 0.486 0.225 0.635s0.131 0.67 0.206 0.744c0.075 0.074 0.3 0.967 0.449 1.19s0.243 1.076 0.318 1.151c0.075 0.074 0.73 1.454 0.73 1.826s0.094 1.076 0.243 1.225c0.15 0.149 1.18 1.007 1.404 1.156s0.299 0.148 0.524 0c0.225-0.149 0-0.372 0-0.596s-0.15-1.265-0.225-1.785c-0.075-0.521-1.273-3.572-1.497-4.167s-1.722-4.092-1.946-4.316c-0.18-0.178-0.974-0.236-1.123-0.148-0.15 0.086-0.446 0.361-0.505 0.48-0.075 0.15 0.008 1.297-0.169 1.454-0.206 0.183-0.431 1.448-0.505 1.522s-0.243 1.082-0.468 1.454c-0.18 0.298-0.331 0.431-0.356 0.481-0.075-0.074-0.169-0.243-0.169-0.481s-0.306-1.478-0.505-2.049l-0.974-2.191c0-0.050-0.243-0.178-0.543-0.298s-0.574 0.149-0.674 0.298c0 0-0.13 1.138-0.281 1.374s-1.695 3.016-1.815 3.016-1.048 1.29-1.497 1.935c0 0-1.198 2.219-1.273 2.604s-0.075 1.848 0 1.935z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color6, #000)"
    },
    d: "M64.905 11.090c-0.435 0.181 0.129 1.194 0.578 1.147 0.449-0.049 0.478 0.217 0.521 0.615 0.034 0.319-0.422 1.701-0.654 2.353l0.1 0.929-0.412 1.79c-0.145 1.001-0.389 3.13-0.212 3.648 0.145 0.423 0.128 0.642 0.118 0.789-0.003 0.034-0.005 0.063-0.005 0.091l0.075 0.224c0.010 0.098 0.022 0.108 0.076 0.154l0.002 0.001c0.025 0.021 0.049 0.044 0.072 0.067 0.075 0.074 1.332 0.106 1.903-0.223s1.74-0.722 2.324-0.919c0.585-0.197 1.29-0.675 1.546-1.105 0.148-0.25 0.604-0.486 1.012-0.699 0.297-0.155 0.57-0.297 0.684-0.422 0.038-0.041 0.105-0.097 0.193-0.17 0.537-0.448 1.869-1.558 2.358-4.265 0.406-2.251-3.601-3.071-5.938-3.549-0.933-0.191-1.6-0.327-1.617-0.478-0.046-0.425-0.766-0.545-1.119-0.552l-0.706 0.478-0.898 0.096zM67.879 13.934c0.646-0.038 2.044-0.070 2.474 0.105 0.202 0.083 0.487 0.13 0.766 0.177 0.463 0.078 0.911 0.152 0.935 0.38 0.020 0.18 0.13 0.282 0.228 0.374 0.102 0.095 0.191 0.178 0.155 0.323-0.057 0.228 0.138 0.324 0.242 0.343-0.089 0.132-0.294 0.511-0.409 0.966-0.085 0.337-0.486 0.74-0.796 1.050-0.214 0.214-0.383 0.385-0.375 0.459 0.002 0.020 0.006 0.041 0.009 0.061 0.028 0.161 0.055 0.322-0.558 0.551-0.456 0.171-0.518 0.259-0.59 0.361-0.037 0.053-0.076 0.109-0.173 0.182-0.284 0.215-0.478 0.328-0.873 0.463s-0.791 0.269-0.985 0.382c-0.154 0.090-0.592 0.217-0.792 0.27l-0.13-0.263c0.127-0.721 0.355-2.215 0.25-2.426-0.131-0.263-0.049-0.455 0.033-0.649 0.065-0.154 0.362-1.392 0.503-1.991l0.084-1.116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color6, #000)"
    },
    d: "M92.135 13.914c0.225-0.434 0.587-1.638 0.674-1.847s0.039-1.049-0.3-1.116c-0.374-0.074-0.218-0.2-0.674-0.074-0.262 0.072-0.413 0.034-0.599 0.223-0.266 0.271-0.277 0.22-0.463 0.558-0.215 0.39-0.286 1.163-0.286 1.163s-0.374 0.598-0.374 0.958c0 0.492-0.425 0.82-0.547 1.249-0.245 0.858-0.875 2.098-0.875 2.098-0.235-0.148-0.065-0.507-0.235-0.794-0.135-0.228-0.228-0.412-0.342-0.412l-0.598-0.892c-0.086-0.274-0.256-0.851-0.256-0.961 0-0.137-0.512-0.618-0.512-0.824 0-0.164-0.174-0.923-0.231-1.175l-0.865-0.272c-0.17-0.473-1.363 0.586-1.295 1.026 0.085 0.55 0.939 0.971 0.939 1.589 0 0.443 0.512 1.305 0.769 1.51s0.93 1.482 1.102 1.825c0.17 0.343 0.094 1.333 0.094 1.608s-1.319 0.921-1.319 1.264c0 0.343-1.735 1.368-1.583 2.1 0.085 0.412 1.281 0.55 1.708 0s0.342-0.412 1.195-1.098c0.854-0.686 0.807-0.562 1.276-0.932 0.433-0.342 1.2-0.784 1.285-1.058s0.854-0.961 1.281-2.128c0.427-1.167 0.427-1.394 0.598-1.806s0.068-1.073 0.434-1.778zM79.149 15.563c-0.486-0.074-1.75-0.034-1.977-0.050s-1.013 0.295-0.97 0.635c0.047 0.377-0.122 0.27 0.142 0.659 0.152 0.224 0.163 0.378 0.402 0.494 0.343 0.165 0.297 0.191 0.679 0.26 0.44 0.079 1.2-0.1 1.2-0.1s0.69 0.164 1.033 0.049c0.47-0.155 0.917 0.142 1.365 0.121 0.897-0.041 1.354 0.045 1.873-0.471 0.572-0.57 1.249-1.727 0-1.76s-1.465 0.039-1.913 0.009-1.046 0.275-1.834 0.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98b8e9",
    style: {
      fill: "var(--color7, #98b8e9)"
    },
    d: "M23.945 6.252c-5.017-5.869-9.537 3.663-8.282 4.471s3.174 2.641 3.47 3.668c0.295 1.028 9.829-2.27 4.812-8.138z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f7581",
    style: {
      fill: "var(--color8, #8f7581)"
    },
    d: "M17.868 30.548c7.035-1.809 0.847-9.465-0.414-8.711s-3.607 1.122-4.648 0.937-1.989 9.589 5.062 7.775z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6634e",
    style: {
      fill: "var(--color9, #b6634e)"
    },
    d: "M27.648 21.083c2.846-6.124-6.757-6.603-7.227-5.797-0.47 0.807-2.028 3.196-2.455 4.045s6.709 8.152 9.682 1.752z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7d6a3c",
    style: {
      fill: "var(--color10, #7d6a3c)"
    },
    d: "M8.037 3.040c7.697-3.209 7.701 6.874 6.292 7.367s-4.583 1.211-5.111 2.142c-0.528 0.93-7.209-6.997-1.182-9.509z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7ab52",
    style: {
      fill: "var(--color11, #c7ab52)"
    },
    d: "M2.168 14.25c1.674-5.609 7.834-0.423 7.472 0.692s-1.385 2.349-1.050 3.123-8.097 1.794-6.422-3.815z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#779153",
    style: {
      fill: "var(--color12, #779153)"
    },
    d: "M3.57 26.060c-4.703-4.455 4.439-7.455 5.167-6.382s1.392 2.421 2.288 2.641c0.897 0.22-2.158 8.759-7.455 3.742z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9ff64",
    style: {
      fill: "var(--color13, #e9ff64)"
    },
    d: "M24.377 15.363s-1.945 3.89-3.611 5.515c-1.186 1.157-1.835 1.871-3.44 2.487-2.257 0.865-4.477 0.629-5.984-0.552-1.993-1.254-3.255-3.366-3.414-5.674-0.185-2.615 0.894-4.919 2.946-6.295 3.402-2.27 8.206-1.084 9.4 2.872 0.841 2.788-0.553 5.573-3.193 6.304-2.090 0.582-4.255-0.31-5.038-2.335-0.454-1.396-0.256-2.828 0.825-3.799 1.103-0.982 2.798-1.066 3.855-0.177 1.133 0.948 1.265 2.761 0.037 3.69-0.954 0.68-2.31 0.458-2.767-0.563-0.294-0.661-0.092-1.476 0.542-1.772 0.29-0.14 0.628-0.134 0.874 0.001-0.263 0.011-0.498 0.123-0.667 0.299l-0 0c-0.302 0.327-0.265 0.786-0.045 1.103 0.274 0.414 0.954 0.523 1.438 0.123 0.626-0.58 0.376-1.503-0.193-1.908-0.532-0.38-1.47-0.348-2.073 0.263-0.554 0.574-0.608 1.422-0.307 2.148 0.532 1.177 1.81 1.585 3.017 1.212 1.735-0.548 2.194-2.1 1.668-3.793-0.849-2.763-3.377-2.892-5.718-1.416-1.513 0.926-2.472 2.749-1.751 4.788 0.75 2.118 1.991 2.846 3.92 3.698 4.637 2.049 9.68-6.218 9.68-6.218z"
  })), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-preloader",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.75 7.486c2.067 0 3.743-1.676 3.743-3.743s-1.676-3.743-3.743-3.743v0c-2.067 0-3.743 1.676-3.743 3.743s1.676 3.743 3.743 3.743v0zM16.75 32.001c1.24 0 2.245-1.005 2.245-2.245s-1.005-2.245-2.245-2.245v0c-1.24 0-2.245 1.005-2.245 2.245s1.005 2.245 2.245 2.245v0zM7.553 10.921c1.861 0 3.369-1.508 3.369-3.369s-1.508-3.369-3.369-3.369v0c-1.861 0-3.369 1.508-3.369 3.369s1.508 3.369 3.369 3.369v0zM25.947 27.816c1.034 0 1.871-0.838 1.871-1.871s-0.838-1.871-1.871-1.871v0c-1.034 0-1.871 0.838-1.871 1.871s0.838 1.871 1.871 1.871v0zM3.743 19.744c1.653 0 2.994-1.34 2.994-2.994s-1.34-2.994-2.994-2.994v0c-1.653 0-2.994 1.34-2.994 2.994s1.34 2.994 2.994 2.994v0zM29.756 18.245c0.826 0 1.497-0.67 1.497-1.497s-0.67-1.497-1.497-1.497v0c-0.814 0.016-1.468 0.68-1.468 1.496s0.654 1.48 1.467 1.496l0.001 0zM5.701 24.095c-0.474 0.474-0.768 1.129-0.768 1.852s0.293 1.378 0.768 1.852l0 0c0.474 0.474 1.129 0.768 1.852 0.768s1.378-0.293 1.852-0.768l0-0c0.474-0.474 0.768-1.129 0.768-1.852s-0.293-1.378-0.768-1.852l-0-0c-1.022-1.025-2.681-1.035-3.704 0zM25.946 8.674c0.62 0 1.122-0.502 1.122-1.122s-0.502-1.122-1.122-1.122v0c-0.62 0-1.122 0.502-1.122 1.122s0.502 1.122 1.122 1.122v0z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-removebg",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.122 9.415h-2.278v-2.363c0-1.13-0.923-2.052-2.052-2.052h-17.924c-1.13 0-2.052 0.923-2.052 2.052v13.49c0 1.13 0.923 2.052 2.052 2.052h2.297v2.353c0 1.148 0.904 2.052 2.052 2.052h17.914c1.149 0 2.052-0.904 2.052-2.052v-13.49c-0.009-1.148-0.913-2.043-2.062-2.043zM4.868 20.712c-0.094 0-0.169-0.075-0.169-0.169v-13.49c0-0.094 0.075-0.169 0.169-0.169h17.924c0.085 0 0.169 0.075 0.169 0.169v2.363h-13.753c-1.148 0-2.052 0.904-2.052 2.052v9.244h-2.288zM9.048 24.938v-4.886l2.692-1.469c0.951-0.518 2.165-0.169 2.702 0.772l3.267 5.752h-8.501c-0.094 0-0.16-0.066-0.16-0.169zM17.925 21.681l1.713-0.932c0.819-0.442 1.854-0.151 2.316 0.659l2.099 3.7h-4.18l-1.949-3.427zM27.292 24.938c0 0.104-0.066 0.169-0.169 0.169h-0.904l-2.626-4.632c-0.96-1.694-3.135-2.316-4.848-1.384l-1.742 0.951-0.923-1.619c-1.045-1.826-3.389-2.504-5.234-1.497l-1.789 0.979v-6.448c0-0.104 0.066-0.169 0.169-0.169h17.914c0.104 0 0.17 0.066 0.17 0.169v13.481h-0.019zM25.070 14.884c0 0.979-0.791 1.77-1.77 1.77s-1.77-0.791-1.77-1.77 0.791-1.77 1.77-1.77c0.979 0.009 1.77 0.8 1.77 1.77z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-removebg-large",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.811 9.007h-2.419v-2.509c0-1.199-0.979-2.179-2.179-2.179h-19.033c-1.2 0-2.179 0.98-2.179 2.179v14.325c0 1.2 0.98 2.179 2.179 2.179h2.439v2.499c0 1.22 0.959 2.18 2.179 2.18h19.023c1.22 0 2.179-0.96 2.179-2.18v-14.325c0-0.001 0-0.003 0-0.004 0-1.196-0.969-2.165-2.165-2.165-0.008 0-0.017 0-0.025 0h0.001zM4.18 21.003c-0.1 0-0.18-0.080-0.18-0.18v-14.325c0-0.1 0.080-0.18 0.18-0.18h19.033c0.090 0 0.18 0.080 0.18 0.18v2.509h-14.607c-0.006-0-0.013-0-0.019-0-1.193 0-2.159 0.967-2.159 2.159 0 0.007 0 0.014 0 0.021v-0.001 9.817h-2.429zM8.619 25.491v-5.188l2.859-1.559c1.009-0.55 2.299-0.18 2.869 0.82l3.469 6.107h-9.027c-0.1 0-0.169-0.069-0.169-0.18zM18.045 22.033l1.819-0.989c0.252-0.138 0.551-0.219 0.87-0.219 0.676 0 1.267 0.366 1.586 0.91l0.005 0.009 2.229 3.928h-4.439l-2.069-3.639zM27.992 25.491c0 0.111-0.071 0.18-0.18 0.18h-0.96l-2.789-4.918c-1.020-1.8-3.329-2.459-5.148-1.469l-1.849 1.009-0.98-1.719c-1.109-1.939-3.599-2.659-5.558-1.589l-1.899 1.040v-6.849c0-0.11 0.069-0.18 0.18-0.18h19.023c0.11 0 0.18 0.070 0.18 0.18v14.315h-0.020zM25.632 14.815c0 1.040-0.84 1.88-1.879 1.88-0.001 0-0.001 0-0.002 0-1.037 0-1.877-0.841-1.877-1.877 0-0.001 0-0.002 0-0.003v0c0-1.040 0.84-1.879 1.88-1.879 1.039 0.010 1.879 0.85 1.879 1.88z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-transparent",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7f7f7",
    style: {
      fill: "var(--color14, #f7f7f7)"
    },
    d: "M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color6, #000)"
    },
    d: "M-75.2-4.8h203.2v113.6h-203.2z"
  })), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trashbox",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.292 7h-4.125v-0.751c-0.002-1.242-1.009-2.248-2.251-2.249h-3c-1.242 0.002-2.248 1.009-2.249 2.251v0.749h-4.125c-1.033 0-1.875 0.84-1.875 1.875v2.625c0 0.413 0.336 0.751 0.751 0.751h0.409l0.648 13.607c0.057 1.195 1.040 2.143 2.244 2.143 0 0 0.001 0 0.001 0h11.391c1.203 0 2.189-0.941 2.247-2.143l0.648-13.608h0.411c0.413 0 0.749-0.335 0.749-0.749v-2.625c0-1.033-0.84-1.875-1.875-1.875zM14.167 6.249c0-0.413 0.336-0.749 0.751-0.749h3c0.413 0 0.749 0.336 0.749 0.751v0.749h-4.5v-0.751zM8.167 8.876c0-0.208 0.168-0.376 0.375-0.376h15.752c0.207 0 0.375 0.168 0.375 0.375v1.876h-16.501v-1.877zM22.86 25.785c-0.019 0.398-0.347 0.714-0.748 0.715h-11.392c-0.401-0-0.729-0.316-0.748-0.713l-0-0.002-0.644-13.535h14.179l-0.645 13.535z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.417 25c0.413 0 0.749-0.336 0.749-0.751v-9.749c-0.017-0.401-0.347-0.719-0.75-0.719s-0.733 0.318-0.75 0.717l-0 0.002v9.751c0 0.413 0.336 0.749 0.751 0.749zM20.167 25c0.413 0 0.751-0.336 0.751-0.751v-9.749c0-0.415-0.336-0.751-0.751-0.751s-0.751 0.336-0.751 0.751v0 9.751c0 0.413 0.336 0.749 0.751 0.749zM12.667 25c0.413 0 0.751-0.336 0.751-0.751v-9.749c0-0.415-0.336-0.751-0.751-0.751s-0.751 0.336-0.751 0.751v0 9.751c0 0.413 0.336 0.749 0.751 0.749z"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash",
    viewBox: "0 0 27 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 4h-5.5v-1c0-1.654-1.346-3-3-3h-4c-1.654 0-3 1.346-3 3v1h-5.5c-1.379 0-2.5 1.122-2.5 2.5v3.5c0 0.552 0.448 1 1 1h0.546l0.864 18.143c0.076 1.602 1.393 2.857 2.997 2.857h15.186c1.604 0 2.92-1.255 2.996-2.857l0.864-18.143h0.546c0.552 0 1-0.448 1-1v-3.5c0-1.378-1.121-2.5-2.5-2.5zM10 3c0-0.551 0.449-1 1-1h4c0.551 0 1 0.449 1 1v1h-6v-1zM2 6.5c0-0.276 0.224-0.5 0.5-0.5h21c0.276 0 0.5 0.224 0.5 0.5v2.5c-0.308 0-20.723 0-22 0v-2.5zM21.592 29.048c-0.025 0.534-0.464 0.952-0.999 0.952h-15.186c-0.535 0-0.973-0.418-0.999-0.952l-0.859-18.048h18.902l-0.859 18.048z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 28c0.552 0 1-0.448 1-1v-13c0-0.552-0.448-1-1-1s-1 0.448-1 1v13c0 0.552 0.448 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 28c0.552 0 1-0.448 1-1v-13c0-0.552-0.448-1-1-1s-1 0.448-1 1v13c0 0.552 0.448 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 28c0.552 0 1-0.448 1-1v-13c0-0.552-0.448-1-1-1s-1 0.448-1 1v13c0 0.552 0.448 1 1 1z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-upload",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 26.5c0 0.828-0.672 1.5-1.5 1.5v0h-21c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5v0h21c0.828 0 1.5 0.672 1.5 1.5v0zM16 4c0.384 0 0.768 0.146 1.060 0.44l5.316 5.314c0.294 0.275 0.477 0.665 0.477 1.097 0 0.828-0.672 1.5-1.5 1.5-0.433 0-0.823-0.183-1.097-0.477l-0.001-0.001-2.756-2.75v11.566c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v0-11.57l-2.754 2.756c-0.273 0.282-0.655 0.457-1.078 0.457-0.828 0-1.5-0.672-1.5-1.5 0-0.424 0.176-0.806 0.458-1.079l0-0 5.314-5.314c0.271-0.272 0.646-0.44 1.060-0.44 0 0 0 0 0 0h-0z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-upscale",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.312c0 0.518-0.42 0.938-0.938 0.938h-8.063c-2.068 0-3.75-1.682-3.75-3.75v-10.875h-2.813c-0.518 0-0.938-0.42-0.938-0.938s0.42-0.938 0.938-0.938h2.813v-2.813c0-0.518 0.42-0.938 0.938-0.938s0.938 0.42 0.938 0.938v15.563c0 1.034 0.841 1.875 1.875 1.875h8.063c0.518 0 0.938 0.42 0.938 0.937zM27.062 22.375h-2.812v-10.875c0-2.068-1.682-3.75-3.75-3.75h-8.063c-0.518 0-0.938 0.42-0.938 0.938s0.42 0.938 0.938 0.938h8.063c1.034 0 1.875 0.841 1.875 1.875v15.562c0 0.518 0.42 0.938 0.937 0.938s0.938-0.42 0.938-0.938v-2.812h2.812c0.518 0 0.938-0.42 0.938-0.938s-0.42-0.937-0.938-0.937zM25.656 4h-2.812c-0.518 0-0.938 0.42-0.938 0.938s0.42 0.938 0.938 0.938h2.812c0.259 0 0.469 0.21 0.469 0.469v2.812c0 0.518 0.42 0.938 0.937 0.938s0.938-0.42 0.938-0.938v-2.812c0-1.292-1.051-2.344-2.344-2.344zM9.156 26.125h-2.812c-0.258 0-0.469-0.21-0.469-0.469v-2.812c0-0.518-0.42-0.938-0.938-0.938s-0.938 0.42-0.938 0.938v2.812c0 1.292 1.051 2.344 2.344 2.344h2.812c0.518 0 0.938-0.42 0.938-0.938s-0.42-0.937-0.938-0.937z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-upscale-large",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.313c0 0.517-0.42 0.937-0.937 0.937h-8.063c-2.070-0.002-3.748-1.68-3.75-3.75v-10.876h-2.813c-0.518 0-0.937-0.42-0.937-0.937s0.42-0.937 0.937-0.937h2.813v-2.813c0-0.518 0.42-0.938 0.938-0.938s0.938 0.42 0.938 0.938v15.563c0.001 1.035 0.84 1.874 1.875 1.875h8.063c0.517 0 0.937 0.42 0.937 0.937zM27.063 22.375h-2.813v-10.875c-0.002-2.070-1.68-3.748-3.75-3.75h-8.063c-0.518 0-0.938 0.42-0.938 0.938s0.42 0.938 0.938 0.938h8.063c1.035 0.001 1.874 0.84 1.875 1.875v15.563c0 0.518 0.42 0.937 0.937 0.937s0.937-0.42 0.937-0.937v0-2.813h2.813c0.518 0 0.938-0.42 0.938-0.938s-0.42-0.938-0.938-0.938v0zM25.656 4h-2.812c-0.518 0-0.938 0.42-0.938 0.938s0.42 0.938 0.938 0.938h2.812c0.259 0 0.469 0.21 0.469 0.469v2.812c0 0.518 0.42 0.938 0.938 0.938s0.938-0.42 0.938-0.938v0-2.812c-0.002-1.294-1.050-2.342-2.344-2.344h-0zM9.156 26.125h-2.812c-0.259 0-0.469-0.21-0.469-0.469v0-2.812c0-0.518-0.42-0.937-0.937-0.937s-0.937 0.42-0.937 0.937v0 2.812c0.002 1.294 1.050 2.343 2.344 2.344h2.812c0.518 0 0.938-0.42 0.938-0.938s-0.42-0.938-0.938-0.938v0z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9 6.1c-2.644-2.644-6.16-4.101-9.9-4.101s-7.255 1.456-9.899 4.101c-2.644 2.644-4.101 6.16-4.101 9.899s1.456 7.255 4.101 9.9 6.16 4.1 9.899 4.1c3.739 0 7.255-1.456 9.9-4.1s4.1-6.16 4.1-9.9c0-3.74-1.456-7.255-4.1-9.899zM9.019 26.192c0.586-3.371 3.507-5.858 6.981-5.858s6.396 2.487 6.981 5.858c-1.988 1.366-4.393 2.166-6.981 2.166s-4.994-0.801-6.981-2.166zM11.549 14.242c0-2.455 1.997-4.451 4.451-4.451s4.451 1.997 4.451 4.451c0 2.455-1.997 4.451-4.451 4.451s-4.451-1.997-4.451-4.451zM24.402 25.054c-0.442-1.569-1.318-2.993-2.548-4.106-0.754-0.683-1.612-1.221-2.535-1.601 1.668-1.088 2.773-2.97 2.773-5.106 0-3.359-2.733-6.092-6.092-6.092s-6.092 2.733-6.092 6.092c0 2.136 1.105 4.018 2.773 5.106-0.923 0.38-1.781 0.918-2.535 1.6-1.229 1.112-2.106 2.536-2.548 4.106-2.432-2.259-3.957-5.482-3.957-9.055 0-6.815 5.544-12.359 12.359-12.359s12.359 5.544 12.359 12.359c0 3.573-1.525 6.796-3.957 9.055z"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user_2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.314 4.686c-3.022-3.022-7.040-4.686-11.314-4.686s-8.292 1.664-11.314 4.686-4.686 7.040-4.686 11.314c0 4.274 1.664 8.292 4.686 11.314s7.040 4.686 11.314 4.686c4.274 0 8.292-1.664 11.314-4.686s4.686-7.040 4.686-11.314c0-4.274-1.664-8.292-4.686-11.314zM8.021 27.648c0.669-3.853 4.008-6.695 7.979-6.695s7.31 2.842 7.979 6.695c-2.272 1.561-5.020 2.476-7.979 2.476s-5.707-0.915-7.979-2.476zM10.912 13.991c0-2.805 2.282-5.087 5.087-5.087s5.087 2.282 5.087 5.087c0 2.805-2.282 5.087-5.087 5.087s-5.087-2.282-5.087-5.087zM25.603 26.348c-0.505-1.794-1.507-3.421-2.912-4.692-0.862-0.78-1.843-1.396-2.897-1.829 1.906-1.243 3.169-3.395 3.169-5.835 0-3.839-3.124-6.962-6.963-6.962s-6.962 3.123-6.962 6.962c0 2.441 1.263 4.592 3.169 5.835-1.054 0.434-2.036 1.049-2.897 1.829-1.405 1.271-2.407 2.899-2.912 4.692-2.78-2.581-4.522-6.265-4.522-10.348 0-7.789 6.336-14.125 14.125-14.125s14.125 6.336 14.125 14.125c0 4.084-1.743 7.767-4.522 10.349z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user-cabinet",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0c-8.822 0-16 7.178-16 16 0 3.864 1.377 7.412 3.666 10.18 0.006 0.008 0.006 0.018 0.013 0.026 1.653 1.993 3.729 3.521 6.042 4.508 0.027 0.011 0.053 0.023 0.079 0.035 0.187 0.079 0.377 0.152 0.566 0.224 0.075 0.028 0.149 0.057 0.225 0.084 0.164 0.059 0.329 0.114 0.494 0.168 0.106 0.034 0.212 0.068 0.319 0.1 0.147 0.044 0.294 0.086 0.442 0.126 0.13 0.035 0.261 0.068 0.393 0.099 0.133 0.032 0.266 0.064 0.4 0.092 0.149 0.032 0.3 0.060 0.452 0.088 0.122 0.022 0.243 0.046 0.365 0.066 0.168 0.027 0.337 0.049 0.507 0.070 0.109 0.014 0.218 0.030 0.328 0.042 0.192 0.020 0.386 0.035 0.58 0.048 0.090 0.006 0.18 0.016 0.27 0.021 0.283 0.016 0.57 0.024 0.858 0.024s0.575-0.009 0.859-0.023c0.091-0.005 0.18-0.014 0.27-0.021 0.194-0.014 0.388-0.028 0.58-0.048 0.11-0.012 0.219-0.028 0.328-0.042 0.17-0.022 0.339-0.043 0.507-0.070 0.122-0.020 0.244-0.043 0.365-0.066 0.151-0.028 0.302-0.056 0.452-0.088 0.134-0.029 0.267-0.060 0.4-0.092 0.131-0.032 0.262-0.065 0.392-0.099 0.148-0.040 0.296-0.082 0.442-0.126 0.107-0.032 0.213-0.066 0.32-0.1 0.166-0.053 0.331-0.109 0.494-0.168 0.075-0.027 0.15-0.056 0.225-0.084 0.19-0.071 0.379-0.145 0.566-0.223 0.027-0.011 0.053-0.023 0.079-0.035 2.313-0.987 4.389-2.515 6.042-4.508 0.006-0.007 0.007-0.018 0.013-0.026 2.288-2.769 3.665-6.317 3.665-10.181 0-8.822-7.178-16-16-16zM22.484 29.451c-0.008 0.004-0.015 0.008-0.023 0.012-0.19 0.092-0.384 0.178-0.579 0.262-0.044 0.019-0.088 0.038-0.132 0.056-0.171 0.072-0.343 0.139-0.517 0.204-0.073 0.027-0.145 0.054-0.218 0.079-0.154 0.055-0.309 0.108-0.465 0.158-0.097 0.031-0.195 0.060-0.292 0.089-0.139 0.042-0.278 0.082-0.419 0.119-0.118 0.032-0.238 0.060-0.357 0.089-0.125 0.030-0.25 0.060-0.377 0.087-0.138 0.029-0.277 0.054-0.416 0.079-0.113 0.021-0.225 0.043-0.338 0.061-0.156 0.024-0.314 0.044-0.471 0.064-0.1 0.013-0.199 0.028-0.3 0.038-0.18 0.019-0.361 0.031-0.542 0.044-0.081 0.005-0.161 0.014-0.242 0.019-0.264 0.014-0.529 0.021-0.794 0.021s-0.53-0.007-0.794-0.021c-0.081-0.004-0.161-0.013-0.242-0.019-0.181-0.012-0.362-0.025-0.542-0.044-0.101-0.011-0.2-0.026-0.3-0.038-0.157-0.020-0.315-0.040-0.472-0.064-0.114-0.018-0.226-0.040-0.338-0.061-0.139-0.025-0.278-0.051-0.416-0.079-0.126-0.027-0.252-0.057-0.377-0.087-0.119-0.029-0.239-0.057-0.357-0.089-0.14-0.037-0.28-0.078-0.419-0.119-0.098-0.029-0.195-0.058-0.292-0.089-0.156-0.050-0.312-0.103-0.465-0.158-0.073-0.026-0.146-0.053-0.218-0.079-0.174-0.065-0.347-0.133-0.517-0.204-0.044-0.018-0.087-0.037-0.132-0.056-0.195-0.084-0.389-0.171-0.58-0.262-0.008-0.004-0.015-0.007-0.023-0.012-1.861-0.9-3.505-2.178-4.838-3.73 1.031-3.796 3.949-6.857 7.704-8.074 0.074 0.045 0.152 0.086 0.228 0.129 0.045 0.025 0.089 0.052 0.134 0.076 0.159 0.084 0.32 0.163 0.485 0.234 0.126 0.055 0.257 0.102 0.387 0.15 0.026 0.009 0.051 0.019 0.077 0.028 0.723 0.256 1.497 0.403 2.307 0.403s1.584-0.147 2.306-0.403c0.026-0.009 0.051-0.019 0.077-0.028 0.13-0.048 0.261-0.095 0.387-0.15 0.165-0.071 0.326-0.15 0.485-0.234 0.045-0.024 0.090-0.051 0.134-0.076 0.076-0.043 0.154-0.083 0.229-0.129 3.755 1.218 6.673 4.278 7.704 8.074-1.334 1.552-2.978 2.829-4.838 3.73zM10.133 11.733c0-3.235 2.632-5.867 5.867-5.867s5.867 2.632 5.867 5.867c0 2.058-1.067 3.868-2.675 4.916-0.21 0.137-0.429 0.259-0.653 0.365-0.027 0.013-0.053 0.026-0.079 0.038-1.545 0.702-3.373 0.702-4.917 0-0.027-0.012-0.053-0.026-0.079-0.038-0.225-0.107-0.443-0.229-0.653-0.365-1.608-1.047-2.675-2.858-2.675-4.916zM28.122 24.706c-1.209-3.57-3.967-6.456-7.492-7.826 1.41-1.27 2.303-3.104 2.303-5.146 0-3.823-3.11-6.933-6.933-6.933s-6.933 3.11-6.933 6.933c0 2.043 0.893 3.876 2.303 5.146-3.524 1.371-6.283 4.256-7.492 7.826-1.767-2.453-2.812-5.459-2.812-8.706 0-8.234 6.699-14.933 14.933-14.933s14.933 6.699 14.933 14.933c0 3.247-1.045 6.253-2.811 8.706z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.067 24.933c0.267 0.267 0.533 0.4 0.933 0.4s0.667-0.133 0.933-0.4l7.067-7.067 7.067 7.067c0.267 0.267 0.667 0.4 0.933 0.4s0.667-0.133 0.933-0.4c0.533-0.533 0.533-1.333 0-1.867l-7.067-7.067 7.067-7.067c0.533-0.533 0.533-1.333 0-1.867s-1.333-0.533-1.867 0l-7.067 7.067-7.067-7.067c-0.533-0.533-1.333-0.533-1.867 0s-0.533 1.333 0 1.867l7.067 7.067-7.067 7.067c-0.533 0.533-0.533 1.333 0 1.867z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-remove",
    viewBox: "0 0 32 32"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0c-8.823 0-16 7.177-16 16s7.177 16 16 16c8.823 0 16-7.177 16-16s-7.177-16-16-16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    style: {
      fill: "var(--color2, #fafafa)"
    },
    d: "M21.892 20.006c0.521 0.521 0.521 1.364 0 1.886-0.26 0.26-0.601 0.391-0.943 0.391s-0.683-0.131-0.943-0.391l-4.007-4.007-4.007 4.007c-0.26 0.26-0.601 0.391-0.943 0.391s-0.683-0.131-0.943-0.391c-0.521-0.521-0.521-1.364 0-1.886l4.007-4.007-4.007-4.007c-0.521-0.521-0.521-1.364 0-1.886s1.364-0.521 1.886 0l4.007 4.007 4.007-4.007c0.521-0.521 1.364-0.521 1.886 0s0.521 1.364 0 1.886l-4.007 4.007 4.007 4.007z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-linkedin",
    viewBox: "0 0 32 32"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16s-7.163-16-16-16c-8.837 0-16 7.163-16 16s7.163 16 16 16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M25.56 17.29v6.596h-3.824v-6.154c0-1.545-0.552-2.601-1.937-2.601-1.057 0-1.684 0.71-1.962 1.398-0.101 0.246-0.127 0.587-0.127 0.932v6.424h-3.825c0 0 0.051-10.423 0-11.502h3.825v1.63c-0.008 0.013-0.018 0.025-0.025 0.038h0.025v-0.038c0.508-0.782 1.415-1.9 3.447-1.9 2.516 0 4.403 1.644 4.403 5.176zM9.884 6.839c-1.308 0-2.164 0.859-2.164 1.987 0 1.104 0.831 1.988 2.114 1.988h0.025c1.334 0 2.163-0.884 2.163-1.988-0.025-1.128-0.829-1.987-2.138-1.987zM7.947 23.886h3.823v-11.503h-3.823v11.503z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-facebook",
    viewBox: "0 0 32 32"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16s-7.163-16-16-16c-8.837 0-16 7.163-16 16s7.163 16 16 16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M20.022 16.626h-2.855v10.459h-4.326v-10.459h-2.057v-3.676h2.057v-2.379c0-1.701 0.808-4.365 4.364-4.365l3.204 0.013v3.568h-2.325c-0.381 0-0.918 0.191-0.918 1.002v2.163h3.233l-0.378 3.672z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-instagram",
    viewBox: "0 0 32 32"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16s-7.163-16-16-16c-8.837 0-16 7.163-16 16s7.163 16 16 16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M11.81 7.619c-2.314 0-4.191 1.876-4.191 4.19v8.381c0 2.314 1.876 4.191 4.191 4.191h8.381c2.314 0 4.191-1.876 4.191-4.191v-8.381c0-2.314-1.876-4.19-4.191-4.19h-8.381zM16 12.952c-1.683 0-3.048 1.364-3.048 3.048s1.364 3.048 3.048 3.048c1.683 0 3.048-1.364 3.048-3.048s-1.364-3.048-3.048-3.048zM11.429 16c0-2.525 2.047-4.571 4.571-4.571s4.571 2.047 4.571 4.571c0 2.525-2.047 4.571-4.571 4.571s-4.571-2.047-4.571-4.571zM20.571 9.905c-0.842 0-1.524 0.682-1.524 1.524s0.682 1.524 1.524 1.524 1.524-0.682 1.524-1.524c0-0.842-0.682-1.524-1.524-1.524z"
  })), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-fashion-store",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.625 13.871c0-0.483 0.392-0.875 0.875-0.875s0.875 0.392 0.875 0.875v9.917c0 1.45 1.175 2.625 2.625 2.625h14c1.45 0 2.625-1.175 2.625-2.625v-9.917c0-0.483 0.392-0.875 0.875-0.875s0.875 0.392 0.875 0.875v9.917c0 2.416-1.959 4.375-4.375 4.375h-14c-2.416 0-4.375-1.959-4.375-4.375v-9.917z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17.662c1.161 0 2.273 0.461 3.094 1.281 0.82 0.821 1.281 1.933 1.281 3.094v5.25c0 0.483-0.392 0.875-0.875 0.875s-0.875-0.392-0.875-0.875v-5.25c0-0.697-0.276-1.364-0.769-1.856s-1.16-0.769-1.856-0.769-1.364 0.276-1.856 0.769c-0.492 0.492-0.769 1.16-0.769 1.856v5.25c0 0.483-0.392 0.875-0.875 0.875s-0.875-0.392-0.875-0.875v-5.25c0-1.161 0.461-2.273 1.281-3.094 0.821-0.82 1.933-1.281 3.094-1.281z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.435 4.712v6.563c0 2.464-2 4.463-4.464 4.463-1.389 0-2.702-0.64-3.557-1.735-0.855-1.095-1.157-2.522-0.821-3.871l0.927-3.709c0.38-1.52 1.745-2.585 3.311-2.585h3.729c0.483 0 0.875 0.392 0.875 0.875zM10.685 5.587h-2.854c-0.763 0-1.428 0.519-1.612 1.259l-0.928 3.71c-0.207 0.825-0.021 1.699 0.502 2.37 0.524 0.67 1.328 1.062 2.178 1.062 1.498 0 2.714-1.214 2.714-2.713v-5.688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.44 3.837h3.729c1.566 0 2.931 1.065 3.311 2.585l0.927 3.709c0.336 1.349 0.034 2.776-0.821 3.871-0.855 1.094-2.168 1.735-3.557 1.735-2.464 0-4.464-1.998-4.464-4.463v-6.563c0-0.483 0.392-0.875 0.875-0.875zM21.315 5.587v5.688c0 1.498 1.216 2.713 2.714 2.713 0.85 0 1.654-0.392 2.178-1.062 0.523-0.671 0.708-1.545 0.502-2.37l-0.927-3.71c-0.184-0.74-0.849-1.259-1.612-1.259h-2.854z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.55 3.837h8.89c0.232 0 0.455 0.092 0.62 0.257s0.255 0.387 0.255 0.62l-0.006 6.347c-0.002 2.584-2.098 4.677-4.681 4.677h-1.272c-2.585 0-4.682-2.095-4.682-4.681v-6.344c0-0.483 0.392-0.875 0.875-0.875zM12.425 5.587v5.469c0 1.618 1.313 2.931 2.932 2.931h1.272c1.618 0 2.93-1.31 2.931-2.928l0.006-5.472h-7.14z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.912 18.251h-7.344v7.538h-5.129v-7.538h-7.344v-4.741h7.344v-7.538h5.129v7.538h7.344v4.741z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-generate-description",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.698 8.225c-0.301-0.3-0.787-0.3-1.088 0l-15.385 15.385c-0.3 0.3-0.3 0.787 0 1.088l3.077 3.077c0.15 0.15 0.347 0.225 0.544 0.225s0.394-0.075 0.544-0.225l15.385-15.385c0.301-0.3 0.301-0.787 0-1.088l-3.077-3.077zM7.846 26.143l-1.989-1.989 10.451-10.451 1.989 1.989c0-0-10.451 10.451-10.451 10.451zM19.385 14.605l-1.989-1.989 2.758-2.758 1.989 1.989-2.758 2.758z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10c0.75-1.5 1.5-2.25 3-3-1.5-0.75-2.25-1.5-3-3-0.75 1.5-1.5 2.25-3 3 1.5 0.75 2.25 1.5 3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 14c-0.25 1-0.5 1.5-1 2 0.5 0.5 0.75 1 1 2 0.25-1 0.5-1.5 1-2-0.5-0.5-0.75-1-1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 6c-1-0.5-1.5-1-2-2-0.5 1-1 1.5-2 2 1 0.5 1.5 1 2 2 0.5-1 1-1.5 2-2z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-copy",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23-0.007c-0.124 0-12 0-12 0-2.116 0-4 1.941-4 4l-1.156 0.027c-2.115 0-3.844 1.914-3.844 3.973v20c0 2.059 1.884 4 4 4h15c2.116 0 4-1.941 4-4h1c2.116 0 4-1.941 4-4v-15.976l-7-8.024zM21 29.993h-15c-1.050 0-2-0.981-2-2v-20c0-1.019 0.855-1.967 1.905-1.967l1.095-0.033v18c0 2.059 1.884 4 4 4h12c0 1.019-0.95 2-2 2zM28 23.993c0 1.019-0.95 2-2 2h-15c-1.050 0-2-0.981-2-2v-20c0-1.019 0.95-2 2-2h10c-0.016 2.303 0 4.025 0 4.025 0 2.078 1.87 3.975 4 3.975 0 0 1.062 0 3 0v14zM25 7.993c-1.065 0-2-1.935-2-2.973 0 0 0-1.052 0-2.996v-0.002l5 5.971h-3zM23 14.011h-9c-0.552 0-1 0.447-1 0.999s0.448 0.999 1 0.999h9c0.552 0 1-0.447 1-0.999s-0.448-0.999-1-0.999zM23 19.006h-9c-0.552 0-1 0.447-1 0.999s0.448 0.999 1 0.999h9c0.552 0 1-0.447 1-0.999s-0.448-0.999-1-0.999z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pencil",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 0c2.761 0 5 2.239 5 5 0 1.126-0.372 2.164-1 3l-2 2-7-7 2-2c0.836-0.628 1.874-1 3-1zM2 23l-2 9 9-2 18.5-18.5-7-7-18.5 18.5zM22.362 11.362l-14 14-1.724-1.724 14-14 1.724 1.724z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-burger-menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5.333c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333h23.83c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-23.83zM2.667 16.267c0-0.736 0.597-1.333 1.333-1.333h23.83c0.736 0 1.333 0.597 1.333 1.333s-0.597 1.333-1.333 1.333h-23.83c-0.736 0-1.333-0.597-1.333-1.333zM2.667 25.867c0-0.736 0.597-1.333 1.333-1.333h23.83c0.736 0 1.333 0.597 1.333 1.333s-0.597 1.333-1.333 1.333h-23.83c-0.736 0-1.333-0.597-1.333-1.333z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-burger-menu_2",
    viewBox: "0 0 45 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2 2.565c0-1.237 1.003-2.24 2.24-2.24h29.12c1.237 0 2.24 1.003 2.24 2.24s-1.003 2.24-2.24 2.24h-29.12c-1.237 0-2.24-1.003-2.24-2.24zM42.56 13.765h-40.32c-1.237 0-2.24 1.003-2.24 2.24s1.003 2.24 2.24 2.24h40.32c1.237 0 2.24-1.003 2.24-2.24s-1.003-2.24-2.24-2.24zM42.56 27.205h-20.16c-1.237 0-2.24 1.003-2.24 2.24s1.003 2.24 2.24 2.24h20.16c1.237 0 2.24-1.003 2.24-2.24s-1.003-2.24-2.24-2.24z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-beta",
    viewBox: "0 0 91 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M14.425 15.645c1.448 0.263 2.676 1.038 3.684 2.325s1.512 2.745 1.512 4.374c0 1.392-0.362 2.654-1.086 3.783-0.698 1.103-1.719 1.984-3.063 2.64-1.344 0.631-2.908 0.946-4.692 0.946h-10.78v-27.389h10.276c1.835 0 3.412 0.315 4.731 0.946s2.314 1.484 2.986 2.562c0.672 1.051 1.008 2.233 1.008 3.547 0 1.576-0.414 2.89-1.241 3.941s-1.939 1.826-3.335 2.325zM4.421 13.832h5.468c1.448 0 2.572-0.328 3.374-0.985 0.827-0.683 1.241-1.655 1.241-2.916 0-1.235-0.414-2.194-1.241-2.877-0.801-0.709-1.926-1.064-3.374-1.064h-5.468v7.842zM10.392 26.049c1.499 0 2.676-0.368 3.529-1.103s1.28-1.76 1.28-3.074c0-1.34-0.452-2.404-1.357-3.192s-2.107-1.182-3.606-1.182h-5.817v8.552h5.972z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M30.785 5.951v8.039h9.307v3.665h-9.307v8.394h10.47v3.665h-14.891v-27.429h14.891v3.665h-10.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M66.050 2.325v3.665h-7.174v23.724h-4.421v-23.724h-7.213v-3.665h18.807z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M84.836 24.118h-11.284l-1.939 5.596h-4.615l9.656-27.429h5.119l9.656 27.429h-4.653l-1.939-5.596zM83.595 20.453l-4.382-12.729-4.421 12.729h8.803z"
  })), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-thin-plus",
    viewBox: "0 0 34 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.75 17.224h-6.682v6.776h-2.667v-6.776h-6.651v-2.416h6.651v-6.808h2.667v6.808h6.682v2.416z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-dots-in-parallel",
    viewBox: "0 0 224 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.11 32c-4.561 0-8.386-1.534-11.476-4.603s-4.635-6.868-4.635-11.397c0-4.53 1.545-8.329 4.635-11.397s6.915-4.603 11.476-4.603c4.414 0 8.166 1.534 11.255 4.603s4.634 6.868 4.634 11.397c0 4.53-1.545 8.329-4.634 11.397s-6.841 4.603-11.255 4.603z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.11 32c-4.561 0-8.386-1.534-11.476-4.603s-4.635-6.868-4.635-11.397c0-4.53 1.545-8.329 4.635-11.397s6.915-4.603 11.476-4.603c4.414 0 8.165 1.534 11.255 4.603s4.635 6.868 4.635 11.397c0 4.53-1.545 8.329-4.635 11.397s-6.841 4.603-11.255 4.603z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.11 32c-4.561 0-8.386-1.534-11.476-4.603s-4.635-6.868-4.635-11.397c0-4.53 1.545-8.329 4.635-11.397s6.915-4.603 11.476-4.603c4.414 0 8.165 1.534 11.255 4.603s4.635 6.868 4.635 11.397c0 4.53-1.545 8.329-4.635 11.397s-6.841 4.603-11.255 4.603z"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-team",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.165 9.835c-1.047 0-2.077 0.267-2.993 0.775s-1.687 1.242-2.24 2.13-0.872 1.904-0.924 2.95c-0.053 1.046 0.162 2.088 0.624 3.028s1.155 1.747 2.015 2.344c0.86 0.598 1.858 0.966 2.9 1.071s2.093-0.057 3.055-0.471c0.962-0.414 1.802-1.066 2.442-1.895l8.846 4.423c-0.409 1.478-0.253 3.056 0.437 4.425s1.866 2.433 3.298 2.983c1.432 0.55 3.017 0.547 4.447-0.007s2.602-1.622 3.288-2.994c0.686-1.372 0.837-2.95 0.422-4.427s-1.363-2.747-2.662-3.562c-1.299-0.815-2.855-1.118-4.365-0.848s-2.865 1.091-3.803 2.305l-8.845-4.421c0.296-1.076 0.296-2.212 0-3.288l8.846-4.424c0.933 1.205 2.28 2.021 3.781 2.287s3.047-0.035 4.337-0.846c1.29-0.811 2.233-2.073 2.644-3.541s0.261-3.036-0.421-4.399c-0.682-1.363-1.846-2.424-3.267-2.976s-2.996-0.555-4.419-0.009-2.592 1.602-3.279 2.962c-0.687 1.36-0.844 2.928-0.439 4.397l-8.848 4.425c-0.575-0.747-1.315-1.351-2.161-1.767s-1.776-0.631-2.719-0.631zM25.834 22.045c0.75 0 1.482 0.222 2.106 0.639s1.109 1.008 1.396 1.701c0.287 0.693 0.362 1.455 0.215 2.19s-0.507 1.41-1.037 1.941c-0.53 0.53-1.205 0.891-1.941 1.037s-1.497 0.071-2.19-0.216c-0.693-0.287-1.284-0.773-1.701-1.396s-0.639-1.356-0.639-2.106c0.001-1.005 0.401-1.968 1.111-2.679s1.674-1.11 2.679-1.111zM25.834 2.375c0.75 0 1.482 0.222 2.106 0.639s1.109 1.008 1.396 1.701c0.287 0.693 0.362 1.455 0.215 2.19s-0.507 1.41-1.037 1.941c-0.53 0.53-1.205 0.891-1.941 1.037s-1.497 0.071-2.19-0.216-1.284-0.773-1.701-1.396c-0.416-0.623-0.639-1.356-0.639-2.106 0.001-1.005 0.401-1.968 1.111-2.679s1.674-1.11 2.679-1.111zM6.165 19.79c-0.75-0-1.482-0.223-2.105-0.639s-1.109-1.008-1.396-1.701c-0.287-0.693-0.362-1.455-0.215-2.19s0.507-1.41 1.037-1.94c0.53-0.53 1.205-0.891 1.941-1.037s1.497-0.071 2.19 0.216c0.692 0.287 1.284 0.773 1.701 1.396s0.639 1.356 0.639 2.106c-0.001 1.005-0.401 1.968-1.112 2.679s-1.674 1.11-2.679 1.111z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-center",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9ff64",
    style: {
      fill: "var(--color1, #e9ff64)"
    },
    d: "M25.653 15.514c0 0-2.002 4.003-3.717 5.676-1.22 1.19-1.888 1.925-3.54 2.559-2.321 0.89-4.607 0.647-6.157-0.568-2.050-1.29-3.349-3.464-3.513-5.839-0.19-2.691 0.92-5.061 3.031-6.477 3.501-2.336 8.445-1.116 9.673 2.955 0.866 2.87-0.569 5.735-3.285 6.487-2.152 0.599-4.379-0.319-5.185-2.403-0.466-1.437-0.263-2.91 0.849-3.91 1.135-1.011 2.879-1.097 3.968-0.182 1.166 0.976 1.301 2.842 0.038 3.797-0.982 0.7-2.377 0.472-2.848-0.579-0.302-0.68-0.095-1.519 0.558-1.824 0.299-0.144 0.646-0.138 0.899 0.001-0.288 0.017-0.53 0.139-0.687 0.308-0.31 0.337-0.273 0.809-0.046 1.135 0.282 0.426 0.981 0.538 1.479 0.127 0.644-0.596 0.387-1.547-0.199-1.963-0.548-0.39-1.512-0.357-2.133 0.271-0.57 0.59-0.625 1.463-0.316 2.21 0.548 1.212 1.863 1.632 3.104 1.247 1.786-0.564 2.258-2.161 1.717-3.902-0.873-2.844-3.475-2.976-5.885-1.458-1.557 0.953-2.544 2.829-1.801 4.927 0.771 2.18 2.049 2.929 4.034 3.806 4.772 2.109 9.962-6.399 9.962-6.399z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-petal1",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#98b8e9",
    style: {
      fill: "var(--color1, #98b8e9)"
    },
    d: "M25.208 6.139c-5.162-6.040-9.814 3.77-8.522 4.601s3.267 2.718 3.57 3.775c0.304 1.057 10.114-2.336 4.952-8.376z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-petal2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b6634e",
    style: {
      fill: "var(--color1, #b6634e)"
    },
    d: "M29.019 21.401c2.929-6.303-6.954-6.796-7.437-5.965s-2.086 3.288-2.526 4.162c-0.44 0.874 6.903 8.389 9.963 1.803z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-petal3",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8f7581",
    style: {
      fill: "var(--color5, #8f7581)"
    },
    d: "M18.955 31.141c7.239-1.862 0.871-9.74-0.427-8.965s-3.712 1.154-4.783 0.964-2.047 9.868 5.209 8.001z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-petal4",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#779153",
    style: {
      fill: "var(--color4, #779153)"
    },
    d: "M4.241 26.523c-4.84-4.584 4.568-7.672 5.318-6.568s1.433 2.491 2.355 2.718-2.221 9.013-7.672 3.85z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-petal5",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c7ab52",
    style: {
      fill: "var(--color3, #c7ab52)"
    },
    d: "M2.798 14.369c1.723-5.772 8.062-0.436 7.689 0.712s-1.425 2.417-1.080 3.214c0.344 0.797-8.332 1.847-6.609-3.926z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-petal6",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7d6a3c",
    style: {
      fill: "var(--color2, #7d6a3c)"
    },
    d: "M8.838 2.833c7.922-3.302 7.926 7.073 6.475 7.582s-4.716 1.246-5.259 2.203c-0.543 0.957-7.419-7.2-1.216-9.785z"
  })), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-shopify",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.449 31.972l9.621-2.081c0 0-3.472-23.484-3.5-23.64-0.024-0.155-0.152-0.256-0.281-0.256s-2.572-0.181-2.572-0.181-1.7-1.699-1.919-1.881c-0.060-0.049-0.1-0.076-0.161-0.099l-1.219 28.139zM15.613 15.073c0 0-1.080-0.565-2.365-0.565-1.929 0-2.005 1.208-2.005 1.521 0 1.643 4.32 2.287 4.32 6.172 0 3.060-1.92 5.013-4.541 5.013-3.139 0-4.72-1.953-4.72-1.953l0.861-2.781c0 0 1.66 1.421 3.040 1.421 0.9 0 1.3-0.727 1.3-1.243 0-2.159-3.539-2.259-3.539-5.812-0.045-2.983 2.095-5.888 6.436-5.888 1.676 0 2.5 0.481 2.5 0.481l-1.26 3.62zM14.893 1.107c0.181 0 0.361 0.051 0.54 0.18-1.312 0.62-2.752 2.185-3.344 5.323-0.875 0.284-1.724 0.54-2.519 0.771 0.692-2.38 2.364-6.26 5.323-6.26zM16.54 5.039v0.18c-1.005 0.309-2.111 0.645-3.192 0.981 0.621-2.369 1.777-3.527 2.78-3.961 0.257 0.668 0.412 1.568 0.412 2.8zM17.259 2.060c0.925 0.099 1.521 1.156 1.905 2.34-0.465 0.152-0.98 0.308-1.544 0.488v-0.336c0-1.003-0.128-1.828-0.361-2.495zM21.248 3.779c-0.027 0-0.080 0.028-0.104 0.028s-0.385 0.1-0.952 0.28c-0.564-1.644-1.568-3.16-3.344-3.16h-0.153c-0.515-0.648-1.136-0.927-1.675-0.927-4.141 0-6.12 5.169-6.74 7.795-1.592 0.487-2.751 0.848-2.88 0.899-0.9 0.284-0.925 0.309-1.029 1.16-0.1 0.616-2.44 18.751-2.44 18.751l18.081 3.396z"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-info",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.999 0c-8.835 0-15.999 7.164-15.999 15.999s7.164 16.001 15.999 16.001c8.835 0 16.001-7.165 16.001-16.001s-7.165-15.999-16.001-15.999zM19.33 24.797c-0.824 0.325-1.479 0.572-1.971 0.742-0.49 0.171-1.061 0.256-1.709 0.256-0.997 0-1.773-0.244-2.326-0.73s-0.828-1.103-0.828-1.852c0-0.291 0.020-0.589 0.061-0.893 0.042-0.303 0.108-0.645 0.199-1.028l1.031-3.641c0.091-0.349 0.169-0.681 0.232-0.99 0.062-0.312 0.092-0.597 0.092-0.857 0-0.463-0.096-0.788-0.287-0.971-0.194-0.183-0.558-0.272-1.101-0.272-0.265 0-0.539 0.039-0.819 0.122-0.278 0.085-0.519 0.163-0.717 0.238l0.272-1.122c0.675-0.275 1.321-0.511 1.937-0.706 0.616-0.198 1.199-0.295 1.747-0.295 0.99 0 1.754 0.241 2.292 0.718 0.535 0.478 0.805 1.1 0.805 1.864 0 0.158-0.019 0.438-0.056 0.836-0.037 0.4-0.106 0.764-0.206 1.098l-1.025 3.63c-0.084 0.291-0.158 0.624-0.226 0.997-0.066 0.372-0.099 0.657-0.099 0.848 0 0.482 0.107 0.811 0.324 0.986 0.214 0.175 0.589 0.263 1.12 0.263 0.251 0 0.531-0.045 0.848-0.131 0.314-0.087 0.542-0.164 0.685-0.23l-0.275 1.12zM19.149 10.063c-0.478 0.444-1.054 0.666-1.727 0.666-0.672 0-1.252-0.222-1.734-0.666-0.479-0.444-0.722-0.985-0.722-1.616 0-0.63 0.244-1.172 0.722-1.62 0.482-0.45 1.062-0.673 1.734-0.673 0.673 0 1.25 0.223 1.727 0.673 0.478 0.448 0.718 0.99 0.718 1.62 0 0.633-0.24 1.172-0.718 1.616z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-play",
    viewBox: "0 0 32 32"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.878 27.255c6.166 0 11.164-4.998 11.164-11.164s-4.998-11.164-11.164-11.164c-6.166 0-11.164 4.998-11.164 11.164s4.998 11.164 11.164 11.164z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fffcee",
    style: {
      fill: "var(--color2, #fffcee)"
    },
    d: "M13.506 21.116l7.886-4.553c0.083-0.048 0.151-0.117 0.199-0.199s0.073-0.177 0.073-0.272c0-0.095-0.025-0.189-0.073-0.272s-0.116-0.151-0.199-0.199l-7.886-4.554c-0.083-0.047-0.177-0.072-0.272-0.072s-0.189 0.025-0.272 0.073c-0.083 0.048-0.151 0.116-0.199 0.199s-0.073 0.176-0.074 0.272v9.107c0 0.095 0.026 0.189 0.074 0.272s0.117 0.151 0.199 0.199c0.083 0.048 0.176 0.073 0.272 0.073s0.189-0.025 0.272-0.072z"
  })), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-info2",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.432 0c1.34 0 2.010 0.912 2.010 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-0.75-1.974-1.99 0-1.043 0.881-2.479 2.643-2.479zM8.309 20c-1.058 0-1.833-0.652-1.093-3.524l1.214-5.092c0.211-0.814 0.246-1.141 0-1.141-0.317 0-1.689 0.562-2.502 1.117l-0.528-0.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273 0.705 3.23l-1.391 5.352c-0.246 0.945-0.141 1.271 0.106 1.271 0.317 0 1.357-0.392 2.379-1.207l0.6 0.814c-2.502 2.547-5.235 3.527-6.291 3.527z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ask",
    viewBox: "0 0 15 20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M7.474 0.432c1.82 0 3.281 0.499 4.384 1.496 1.12 0.98 1.68 2.336 1.68 4.069 0 1.715-0.551 3.028-1.654 3.938-1.102 0.893-2.564 1.339-4.384 1.339l-0.105 2.021h-3.229l-0.131-4.462h1.181c1.522 0 2.695-0.201 3.517-0.604s1.234-1.138 1.234-2.205c0-0.77-0.227-1.382-0.682-1.837-0.438-0.455-1.041-0.683-1.811-0.683-0.805 0-1.435 0.219-1.89 0.656-0.438 0.438-0.656 1.041-0.656 1.811h-3.465c-0.018-1.068 0.21-2.021 0.682-2.861s1.164-1.496 2.074-1.969c0.928-0.473 2.013-0.709 3.255-0.709zM5.768 19.568c-0.665 0-1.216-0.201-1.654-0.604-0.42-0.42-0.63-0.936-0.63-1.549s0.21-1.12 0.63-1.522c0.438-0.42 0.989-0.63 1.654-0.63 0.647 0 1.181 0.21 1.601 0.63 0.42 0.402 0.63 0.91 0.63 1.522s-0.21 1.129-0.63 1.549c-0.42 0.402-0.954 0.604-1.601 0.604z"
  })), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-settings",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.21 11.84c-0.583-0.085-1.14-0.3-1.629-0.63s-0.897-0.766-1.194-1.275c-0.297-0.509-0.475-1.079-0.521-1.667s0.041-1.179 0.254-1.728c0.136-0.359 0.156-0.752 0.057-1.123s-0.311-0.702-0.607-0.947c-1.308-1.098-2.797-1.961-4.4-2.55-0.365-0.136-0.764-0.153-1.139-0.048s-0.708 0.324-0.951 0.628c-0.366 0.468-0.833 0.846-1.367 1.106s-1.12 0.395-1.713 0.395c-0.594 0-1.18-0.135-1.713-0.395s-1.001-0.638-1.367-1.106c-0.243-0.304-0.576-0.524-0.951-0.628s-0.774-0.087-1.139 0.048c-1.48 0.544-2.864 1.32-4.1 2.3-0.311 0.247-0.536 0.586-0.64 0.97s-0.083 0.79 0.060 1.16c0.231 0.564 0.326 1.174 0.278 1.782s-0.237 1.196-0.553 1.717c-0.316 0.521-0.75 0.961-1.266 1.284s-1.102 0.521-1.709 0.577c-0.394 0.042-0.764 0.21-1.056 0.478s-0.489 0.623-0.564 1.012c-0.186 0.922-0.28 1.86-0.28 2.8-0.001 0.787 0.062 1.573 0.19 2.35 0.064 0.402 0.258 0.771 0.552 1.051s0.673 0.456 1.078 0.499c0.62 0.058 1.217 0.264 1.742 0.601s0.96 0.793 1.272 1.333c0.311 0.539 0.489 1.146 0.518 1.768s-0.092 1.242-0.351 1.808c-0.17 0.368-0.212 0.783-0.12 1.178s0.314 0.748 0.63 1.002c1.3 1.078 2.775 1.927 4.36 2.51 0.203 0.070 0.415 0.107 0.63 0.11 0.294-0.001 0.584-0.072 0.845-0.207s0.486-0.332 0.655-0.573c0.356-0.519 0.834-0.944 1.392-1.236s1.178-0.445 1.808-0.444c0.61 0.001 1.212 0.144 1.757 0.418s1.019 0.672 1.383 1.162c0.242 0.326 0.586 0.562 0.976 0.673s0.807 0.088 1.184-0.063c1.45-0.583 2.799-1.39 4-2.39 0.302-0.249 0.516-0.588 0.613-0.967s0.071-0.779-0.073-1.143c-0.235-0.557-0.338-1.161-0.3-1.764s0.216-1.189 0.52-1.712c0.304-0.523 0.725-0.968 1.23-1.3s1.080-0.542 1.68-0.614c0.389-0.054 0.751-0.23 1.033-0.503s0.47-0.629 0.537-1.017c0.161-0.834 0.248-1.681 0.26-2.53 0-0.896-0.083-1.79-0.25-2.67-0.067-0.379-0.253-0.726-0.529-0.994s-0.63-0.441-1.011-0.496zM28.79 18.080c-0.88 0.129-1.72 0.454-2.457 0.952s-1.352 1.156-1.799 1.925c-0.447 0.769-0.715 1.629-0.783 2.516s0.064 1.778 0.388 2.606c-0.992 0.831-2.104 1.506-3.3 2-0.55-0.715-1.258-1.293-2.067-1.69s-1.7-0.602-2.602-0.6c-0.928 0.005-1.842 0.228-2.669 0.65s-1.543 1.032-2.091 1.78c-1.295-0.493-2.503-1.188-3.58-2.060 0.365-0.839 0.529-1.751 0.478-2.664s-0.313-1.802-0.768-2.596c-0.46-0.802-1.101-1.486-1.871-1.996s-1.651-0.834-2.569-0.944c-0.080-0.65-0.114-1.305-0.1-1.96 0-0.775 0.074-1.549 0.22-2.31 0.895-0.105 1.755-0.414 2.513-0.902s1.393-1.145 1.857-1.918c0.464-0.765 0.747-1.626 0.826-2.517s-0.046-1.788-0.366-2.623c1.021-0.801 2.157-1.441 3.37-1.9 0.555 0.678 1.254 1.224 2.046 1.599s1.657 0.57 2.534 0.57c0.876 0 1.742-0.195 2.534-0.57s1.491-0.921 2.046-1.599c1.318 0.498 2.545 1.211 3.63 2.11-0.296 0.816-0.41 1.688-0.332 2.553s0.346 1.703 0.784 2.453c0.438 0.75 1.036 1.395 1.751 1.888s1.53 0.823 2.387 0.966c0.13 0.726 0.197 1.462 0.2 2.2-0.003 0.697-0.060 1.392-0.17 2.080h-0.040z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.004c-1.187 0-2.347 0.352-3.333 1.011s-1.756 1.596-2.21 2.693c-0.454 1.096-0.573 2.303-0.341 3.467s0.803 2.233 1.642 3.072c0.839 0.839 1.908 1.411 3.072 1.642s2.37 0.113 3.467-0.341 2.034-1.223 2.693-2.21c0.659-0.987 1.011-2.147 1.011-3.333 0-1.591-0.632-3.117-1.757-4.243s-2.651-1.757-4.243-1.757zM16 20.004c-0.791 0-1.564-0.235-2.222-0.674s-1.17-1.064-1.473-1.795c-0.303-0.731-0.382-1.535-0.228-2.311s0.535-1.489 1.095-2.048c0.559-0.559 1.272-0.94 2.048-1.095s1.58-0.075 2.311 0.228c0.731 0.303 1.356 0.815 1.795 1.473s0.674 1.431 0.674 2.222c0 1.061-0.421 2.078-1.172 2.828s-1.768 1.172-2.828 1.172z"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-price",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.947 25.686l-2.995-16.983c-0.206-1.17-0.986-2.136-2.085-2.585l-7.146-2.919c-0.308-0.126-0.628-0.203-0.951-0.236l-0.386-2.188c-0.090-0.51-0.576-0.85-1.086-0.76s-0.85 0.576-0.76 1.086l0.386 2.188c-0.288 0.139-0.559 0.318-0.802 0.538l-0.809 0.729-0.12-0.109c-0.246-0.223-0.521-0.406-0.813-0.547l0.494-2.799c0.090-0.51-0.251-0.996-0.76-1.086s-0.996 0.251-1.086 0.76l-0.494 2.799c-0.318 0.032-0.634 0.108-0.938 0.231l-7.21 2.914c-1.106 0.447-1.89 1.415-2.097 2.59l-2.234 12.669c-0.329 1.867 0.922 3.653 2.788 3.982l9.13 1.61 0.28 1.589c0.294 1.666 1.748 2.841 3.384 2.841 0.197 0 0.398-0.017 0.599-0.053l12.926-2.279c1.867-0.329 3.117-2.116 2.788-3.982zM28.833 27.822l-12.926 2.279c-0.411 0.072-0.826-0.019-1.168-0.259s-0.57-0.598-0.643-1.009l-0.162-0.917 1.831 0.323c0.202 0.035 0.404 0.053 0.604 0.053 0.699 0 1.38-0.213 1.964-0.623 0.752-0.527 1.254-1.315 1.414-2.219l2.235-12.675c0.206-1.17-0.196-2.345-1.075-3.143l-4.201-3.812 0.668-0.602c0.291-0.262 0.668-0.4 1.049-0.4 0.199 0 0.398 0.038 0.587 0.115l7.146 2.919c0.5 0.204 0.854 0.643 0.948 1.175l2.995 16.983c0.15 0.849-0.419 1.661-1.267 1.81zM1.899 22.303l2.234-12.669c0.094-0.534 0.451-0.974 0.953-1.177l7.090-2.865-0.203 1.152c-0.090 0.51 0.251 0.996 0.76 1.086 0.055 0.010 0.11 0.014 0.164 0.014 0.446 0 0.842-0.32 0.922-0.775l0.203-1.153 5.626 5.105c0.4 0.363 0.582 0.897 0.489 1.428l-2.235 12.675c-0.073 0.411-0.301 0.769-0.643 1.009s-0.756 0.331-1.168 0.259l-12.926-2.279c-0.848-0.15-1.417-0.962-1.267-1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.446 21.804l-0.15 0.849c-0.060 0.34 0.167 0.664 0.507 0.724 0.037 0.006 0.073 0.009 0.109 0.009 0.298 0 0.561-0.213 0.615-0.516l0.158-0.896c0.642-0.002 1.255-0.18 1.799-0.528 0.648-0.414 1.146-1.041 1.404-1.767 0.524-1.477-0.039-2.942-1.436-3.731-0.231-0.13-0.443-0.254-0.639-0.371l0.624-3.541c0.439 0.162 0.692 0.428 0.86 0.606 0.048 0.051 0.093 0.098 0.139 0.141 0.254 0.234 0.649 0.219 0.883-0.035s0.219-0.649-0.035-0.883c-0.016-0.014-0.049-0.049-0.080-0.083-0.227-0.239-0.7-0.74-1.548-0.989l0.129-0.732c0.060-0.34-0.167-0.664-0.507-0.724s-0.664 0.167-0.724 0.507l-0.142 0.806c-0.129 0.005-0.262 0.014-0.401 0.031-1.029 0.122-1.907 0.83-2.291 1.849-0.349 0.926-0.207 1.901 0.371 2.546 0.323 0.36 0.744 0.711 1.345 1.112l-0.773 4.386c-0.609-0.14-0.98-0.337-1.575-0.896-0.252-0.236-0.647-0.224-0.883 0.028s-0.224 0.647 0.028 0.883c0.81 0.76 1.398 1.034 2.214 1.215zM12.71 19.261c-0.244 0.687-0.887 1.352-1.802 1.45l0.674-3.82c0.083 0.048 0.168 0.096 0.256 0.146 1.285 0.726 0.993 1.886 0.873 2.224zM10.022 14.241c-0.265-0.296-0.316-0.782-0.132-1.27 0.171-0.455 0.595-0.969 1.269-1.049 0.010-0.001 0.020-0.002 0.030-0.003l-0.512 2.907c-0.274-0.207-0.487-0.399-0.654-0.585z"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logout",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.947 29.287h-11.96c-0.734 0-1.329-0.595-1.329-1.329v-23.92c0-0.734 0.595-1.329 1.329-1.329h11.96c0.735 0 1.329-0.594 1.329-1.329s-0.594-1.329-1.329-1.329h-11.96c-2.198 0-3.987 1.789-3.987 3.987v23.92c0 2.198 1.789 3.987 3.987 3.987h11.96c0.735 0 1.329-0.594 1.329-1.329s-0.594-1.329-1.329-1.329z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.602 15.051l-8.080-7.973c-0.521-0.516-1.364-0.509-1.879 0.013s-0.51 1.363 0.013 1.879l5.774 5.698h-15.472c-0.735 0-1.329 0.594-1.329 1.329s0.594 1.329 1.329 1.329h15.472l-5.774 5.698c-0.524 0.516-0.528 1.357-0.013 1.879 0.26 0.263 0.603 0.396 0.946 0.396 0.338 0 0.675-0.128 0.933-0.383l8.080-7.973c0.253-0.25 0.396-0.59 0.396-0.946s-0.142-0.695-0.396-0.946z"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pricing",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.077 15.076h-6.461c-2.025 0-3.692 1.667-3.692 3.692s1.667 3.692 3.692 3.692h3.692v2.769c0 0.507-0.416 0.923-0.923 0.923h-14.768c-1.519 0-2.769-1.25-2.769-2.769v-13.845c0-1.519 1.25-2.769 2.769-2.769h1.846c0.507 0 0.923-0.416 0.923-0.923s-0.416-0.923-0.923-0.923h-1.846c-2.532 0-4.615 2.083-4.615 4.615v13.845c0 2.532 2.083 4.615 4.615 4.615h14.768c1.519 0 2.769-1.25 2.769-2.769v-2.769h0.923c0.507 0 0.923-0.416 0.923-0.923v-5.538c0-0.507-0.416-0.923-0.923-0.923zM26.154 20.614h-5.538c-1.013 0-1.846-0.834-1.846-1.846s0.833-1.846 1.846-1.846h5.538v3.692z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.285 8.679c-1.030 0.45-0.689 1.781 0.332 1.781h14.768c0.507 0 0.923 0.416 0.923 0.923v0.923c0 0.507 0.416 0.923 0.923 0.923s0.923-0.416 0.923-0.923v-0.923c-0.001-0.734-0.293-1.438-0.812-1.957s-1.223-0.811-1.957-0.812h-0.295l-1.615-4.034c-0.187-0.466-0.723-0.699-1.191-0.517l-11.999 4.615zM21.096 8.614h-7.504l6.507-2.501 0.997 2.501z"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ai-avatars",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.721 4.666c-6.473 0-11.721 5.223-11.721 11.667s5.248 11.667 11.721 11.667c6.473 0 11.721-5.223 11.721-11.667 0-0.515-0.42-0.933-0.938-0.933s-0.938 0.418-0.938 0.933c0 5.412-4.408 9.8-9.846 9.8s-9.846-4.388-9.846-9.8c0-5.412 4.408-9.8 9.846-9.8 0.518 0 0.938-0.418 0.938-0.933s-0.42-0.933-0.938-0.933z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.074 7.466c0-0.394 0.321-0.714 0.717-0.714h2.049v-2.039c0-0.394 0.321-0.714 0.717-0.714s0.717 0.319 0.717 0.714v2.039h2.049c0.396 0 0.717 0.32 0.717 0.714s-0.321 0.714-0.717 0.714h-2.049v2.039c0 0.394-0.321 0.714-0.717 0.714s-0.717-0.32-0.717-0.714v-2.039h-2.049c-0.396 0-0.717-0.319-0.717-0.714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.302 16.855h-1.956l-0.956-0.631 0.748-1.084c0.308-0.434 0.465-0.944 0.465-1.473 0-0.045 0-0.083-0.006-0.128-0.673-0.236-1.484-0.816-2.113-1.741-0.861 1.129-1.742 1.786-2.88 2.258 0.057 0.389 0.201 0.759 0.434 1.084l0.748 1.084-1.094 0.721c-1.075 0.708-1.779 1.83-1.956 3.1h4.012c0.39 0 0.51 0.144 0.524 0.601 0.015 0.475-0.115 0.675-0.524 0.675h-4.691c-0.346 0-0.629-0.287-0.629-0.638 0-0.217 0.013-0.427 0.038-0.638 0.189-1.747 1.157-3.259 2.54-4.171-0.069-0.096-0.132-0.198-0.189-0.3-0.585 0.006-1.176-0.038-1.761-0.631 0.629 0 1.258-0.638 1.258-1.276 0-2.111 1.691-3.827 3.773-3.827s3.773 1.716 3.773 3.827c0 0.638 0.629 1.276 1.258 1.276-0.585 0.593-1.176 0.638-1.761 0.631-0.057 0.102-0.119 0.204-0.189 0.3 0.415 0.281 0.799 0.606 1.132 0.982z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-rotate",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    style: {
      fill: "var(--color1, #595959)"
    },
    d: "M16 2.561c1.060 0 1.92 0.86 1.92 1.92s-0.86 1.92-1.92 1.92c-1.060 0-1.92-0.86-1.92-1.92s0.86-1.92 1.92-1.92zM19.2 4.481c0-1.767-1.433-3.2-3.2-3.2s-3.2 1.433-3.2 3.2c0 1.767 1.433 3.2 3.2 3.2s3.2-1.433 3.2-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    style: {
      fill: "var(--color1, #595959)"
    },
    d: "M18.56 10.244c1.060 0 1.92 0.86 1.92 1.92v7.002c0 0.353-0.287 0.64-0.64 0.64h-1.28c-0.353 0-0.64 0.287-0.64 0.64v8.358c0 0.353-0.287 0.64-0.64 0.64h-2.56c-0.353 0-0.64-0.287-0.64-0.64v-8.358c0-0.353-0.287-0.64-0.64-0.64h-1.28c-0.353 0-0.64-0.287-0.64-0.64v-7.002c0-1.060 0.86-1.92 1.92-1.92h5.12zM21.76 12.164c0-1.767-1.433-3.2-3.2-3.2h-5.12c-1.767 0-3.2 1.433-3.2 3.2v7.002c0 1.060 0.86 1.92 1.92 1.92h0.64v7.718c0 1.060 0.86 1.92 1.92 1.92h2.56c1.060 0 1.92-0.86 1.92-1.92v-7.718h0.64c1.060 0 1.92-0.86 1.92-1.92v-7.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    style: {
      fill: "var(--color1, #595959)"
    },
    d: "M24.347 18.378c-0.102 0.338 0.090 0.695 0.429 0.797 1.523 0.457 2.725 1.020 3.531 1.629 0.816 0.616 1.133 1.202 1.133 1.708 0 0.573-0.411 1.25-1.466 1.942-0.769 0.505-1.809 0.967-3.067 1.355l1.264-2.476c0.161-0.315 0.036-0.7-0.279-0.861s-0.7-0.036-0.861 0.279l-1.92 3.762c-0.16 0.313-0.037 0.696 0.275 0.859l3.84 1.998c0.313 0.163 0.7 0.041 0.863-0.272s0.041-0.7-0.272-0.863l-2.393-1.246c1.283-0.405 2.391-0.898 3.254-1.465 1.182-0.776 2.044-1.788 2.044-3.013 0-1.084-0.679-2.003-1.642-2.73-0.972-0.734-2.331-1.351-3.934-1.833-0.339-0.102-0.695 0.090-0.797 0.429zM7.653 18.378c-0.102-0.339-0.458-0.531-0.797-0.429-1.604 0.482-2.962 1.099-3.934 1.833-0.963 0.727-1.642 1.646-1.642 2.73 0 1.224 0.862 2.237 2.044 3.013 1.203 0.79 2.882 1.436 4.848 1.902 0.344 0.082 0.689-0.131 0.77-0.475s-0.131-0.689-0.475-0.77c-1.886-0.447-3.408-1.049-4.441-1.727-1.055-0.692-1.466-1.369-1.466-1.942 0-0.506 0.317-1.092 1.133-1.708 0.806-0.609 2.008-1.171 3.531-1.629 0.339-0.102 0.531-0.459 0.429-0.797z"
  })), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-clock",
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.425 18.659l-4.199-3.149v-6.415c0-0.645-0.521-1.166-1.166-1.166s-1.166 0.521-1.166 1.166v6.999c0 0.367 0.173 0.714 0.467 0.933l4.666 3.499c0.21 0.158 0.455 0.233 0.699 0.233 0.356 0 0.706-0.16 0.934-0.468 0.387-0.515 0.282-1.246-0.233-1.632z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.059 0.941c-8.304 0-15.059 6.755-15.059 15.059s6.755 15.059 15.059 15.059c8.304 0 15.059-6.755 15.059-15.059s-6.755-15.059-15.059-15.059zM15.059 28.726c-7.016 0-12.726-5.71-12.726-12.726s5.71-12.726 12.726-12.726c7.017 0 12.726 5.71 12.726 12.726s-5.71 12.726-12.726 12.726z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-broken-file",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M3.048 16c0-7.153 5.799-12.952 12.952-12.952s12.952 5.799 12.952 12.952c0 7.153-5.799 12.952-12.952 12.952s-12.952-5.799-12.952-12.952z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2c-7.731 0-14 6.269-14 14s6.269 14 14 14c7.731 0 14-6.269 14-14s-6.269-14-14-14zM14.5 17.205v-7.206c0-0.826 0.674-1.5 1.5-1.5s1.5 0.68 1.5 1.5v7.206c0 0.82-0.674 1.5-1.5 1.5s-1.5-0.674-1.5-1.5zM15.994 20.313c0.939 0 1.7 0.761 1.7 1.7s-0.761 1.7-1.7 1.7c-0.939 0-1.7-0.761-1.7-1.7s0.761-1.7 1.7-1.7z"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-feedback-like",
    viewBox: "0 0 36 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.059 28.028h-4.484c-0.201-0-0.393-0.080-0.535-0.222s-0.222-0.334-0.222-0.535v-15.653c0-0.201 0.080-0.393 0.222-0.535s0.334-0.222 0.535-0.222h4.484c0.201 0 0.393 0.080 0.535 0.222s0.222 0.335 0.222 0.535v15.653c-0 0.201-0.080 0.393-0.222 0.535s-0.334 0.222-0.535 0.222zM8.080 23.711c0-0.069-0.027-0.136-0.076-0.184s-0.115-0.076-0.184-0.076-0.136 0.027-0.184 0.076c-0.049 0.049-0.076 0.115-0.076 0.184v2.787c0 0.069 0.027 0.135 0.076 0.184s0.115 0.076 0.184 0.076 0.136-0.027 0.184-0.076c0.049-0.049 0.076-0.115 0.076-0.184v-2.787z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.737 12.377c-0.004-1.149-0.958-2.082-2.126-2.082h-8.274c-0.212 0-0.42-0.052-0.607-0.153s-0.345-0.246-0.462-0.422-0.187-0.38-0.206-0.591c-0.019-0.211 0.015-0.423 0.099-0.618 1.277-2.968 1.321-5.591 0.109-6.685-0.824-0.744-1.917-0.732-2.853 0.031-0.501 0.407-0.834 0.984-0.937 1.621-0.444 2.74-1.567 4.886-2.43 6.204-0.778 1.188-1.478 1.923-1.713 2.158v14.938c1.335 1.165 3.048 1.807 4.82 1.806h9.728c0.373 0 0.729-0.205 1.004-0.58 0.294-0.402 0.454-0.941 0.452-1.518-0.002-0.571-0.167-1.105-0.465-1.502-0.279-0.373-0.64-0.58-1.017-0.58h-6.232c-0.069 0-0.136-0.027-0.184-0.076s-0.076-0.115-0.076-0.184c0-0.069 0.027-0.136 0.076-0.184s0.115-0.076 0.184-0.076h7.319c0.423 0 0.824-0.21 1.13-0.592 0.321-0.4 0.497-0.935 0.495-1.508-0.004-1.148-0.745-2.082-1.652-2.082h-6.845c-0.068-0.002-0.132-0.031-0.179-0.080s-0.073-0.114-0.073-0.181c0-0.068 0.026-0.133 0.073-0.181s0.111-0.077 0.179-0.080h7.754c0.494 0 0.959-0.214 1.31-0.603 0.365-0.411 0.563-0.944 0.556-1.494-0.004-1.149-0.853-2.082-1.898-2.082h-7.722c-0.068-0.002-0.132-0.031-0.179-0.080s-0.073-0.114-0.073-0.181c0-0.068 0.026-0.133 0.073-0.181s0.111-0.077 0.179-0.080h8.573c0.275-0 0.547-0.055 0.802-0.16s0.485-0.26 0.679-0.455c0.194-0.195 0.348-0.426 0.453-0.681s0.158-0.527 0.157-0.802v-0.001z"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-feedback-dislike",
    viewBox: "0 0 36 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.059 3.972h-4.484c-0.201 0-0.393 0.080-0.535 0.222s-0.222 0.334-0.222 0.535v15.653c0 0.201 0.080 0.393 0.222 0.535s0.334 0.222 0.535 0.222h4.484c0.201-0 0.393-0.080 0.535-0.222s0.222-0.334 0.222-0.535v-15.653c-0-0.201-0.080-0.393-0.222-0.535s-0.334-0.222-0.535-0.222zM8.080 8.289c0 0.069-0.027 0.136-0.076 0.184s-0.115 0.076-0.184 0.076-0.136-0.027-0.184-0.076c-0.049-0.049-0.076-0.115-0.076-0.184v-2.787c0-0.069 0.027-0.135 0.076-0.184s0.115-0.076 0.184-0.076 0.136 0.027 0.184 0.076c0.049 0.049 0.076 0.115 0.076 0.184v2.787z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.737 19.622c-0.004 1.149-0.958 2.082-2.126 2.082h-8.274c-0.212-0-0.42 0.052-0.607 0.153s-0.345 0.246-0.462 0.422-0.187 0.38-0.206 0.591c-0.019 0.211 0.015 0.423 0.099 0.618 1.277 2.968 1.321 5.591 0.109 6.685-0.824 0.744-1.917 0.732-2.853-0.031-0.501-0.407-0.834-0.984-0.937-1.621-0.444-2.74-1.567-4.886-2.43-6.204-0.778-1.188-1.478-1.923-1.713-2.158v-14.938c1.335-1.165 3.048-1.807 4.82-1.806h9.728c0.373 0 0.729 0.205 1.004 0.58 0.294 0.402 0.454 0.941 0.452 1.518-0.002 0.571-0.167 1.105-0.465 1.502-0.279 0.373-0.64 0.58-1.017 0.58h-6.232c-0.069 0-0.136 0.027-0.184 0.076s-0.076 0.115-0.076 0.184c0 0.069 0.027 0.136 0.076 0.184s0.115 0.076 0.184 0.076h7.319c0.423 0 0.824 0.21 1.13 0.592 0.321 0.4 0.497 0.935 0.495 1.508-0.004 1.148-0.745 2.082-1.652 2.082h-6.845c-0.068 0.002-0.132 0.031-0.179 0.080s-0.073 0.114-0.073 0.181c0 0.068 0.026 0.133 0.073 0.181s0.111 0.077 0.179 0.080h7.754c0.494 0 0.959 0.214 1.31 0.603 0.365 0.411 0.563 0.944 0.556 1.494-0.004 1.149-0.853 2.082-1.898 2.082h-7.722c-0.068 0.002-0.132 0.031-0.179 0.080s-0.073 0.114-0.073 0.181c0 0.068 0.026 0.133 0.073 0.181s0.111 0.077 0.179 0.080h8.573c0.275 0 0.547 0.055 0.802 0.16s0.485 0.26 0.679 0.455c0.194 0.195 0.348 0.426 0.453 0.68s0.158 0.527 0.157 0.802v0.001z"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-archive",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 2h-20l-6 6v21c0 0.552 0.448 1 1 1h30c0.552 0 1-0.448 1-1v-21l-6-6zM16 26l-10-8h6v-6h8v6h6l-10 8zM4.828 6l2-2h18.343l2 2h-22.343z"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-members",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.75 17.167c-1.038 0-2.053-0.308-2.917-0.885s-1.536-1.397-1.934-2.356c-0.397-0.959-0.501-2.015-0.299-3.033s0.703-1.954 1.437-2.688c0.734-0.734 1.67-1.234 2.688-1.437s2.074-0.099 3.033 0.299c0.959 0.397 1.779 1.070 2.356 1.934s0.885 1.878 0.885 2.917c-0.002 1.392-0.555 2.726-1.539 3.711s-2.319 1.538-3.711 1.539zM10.75 9c-0.577 0-1.141 0.171-1.62 0.492s-0.853 0.776-1.074 1.309c-0.221 0.533-0.279 1.119-0.166 1.685s0.39 1.085 0.798 1.493c0.408 0.408 0.928 0.686 1.493 0.798s1.152 0.055 1.685-0.166c0.533-0.221 0.988-0.595 1.309-1.074s0.492-1.044 0.492-1.62c0-0.774-0.307-1.515-0.854-2.062s-1.289-0.854-2.062-0.854zM19.5 28.833v-0.583c0-2.321-0.922-4.546-2.563-6.187s-3.867-2.563-6.187-2.563c-2.321 0-4.546 0.922-6.187 2.563s-2.563 3.867-2.563 6.187v0.583c0 0.309 0.123 0.606 0.342 0.825s0.516 0.342 0.825 0.342 0.606-0.123 0.825-0.342c0.219-0.219 0.342-0.515 0.342-0.825v-0.583c0-1.702 0.676-3.334 1.879-4.537s2.835-1.879 4.537-1.879 3.334 0.676 4.537 1.879c1.203 1.203 1.879 2.835 1.879 4.537v0.583c0 0.309 0.123 0.606 0.342 0.825s0.516 0.342 0.825 0.342 0.606-0.123 0.825-0.342c0.219-0.219 0.342-0.515 0.342-0.825zM30 23c0-1.577-0.456-3.119-1.314-4.442s-2.080-2.369-3.519-3.013c-1.439-0.644-3.034-0.857-4.592-0.614s-3.012 0.931-4.187 1.982c-0.116 0.102-0.21 0.225-0.278 0.364s-0.107 0.289-0.117 0.443c-0.009 0.154 0.012 0.308 0.063 0.454s0.13 0.28 0.233 0.394c0.103 0.115 0.227 0.208 0.366 0.275s0.29 0.105 0.444 0.112c0.154 0.008 0.308-0.015 0.453-0.067s0.278-0.132 0.392-0.236c0.839-0.751 1.878-1.242 2.991-1.416s2.252-0.021 3.28 0.439c1.028 0.46 1.901 1.207 2.513 2.152s0.938 2.047 0.938 3.173c0 0.309 0.123 0.606 0.342 0.825s0.516 0.342 0.825 0.342c0.309 0 0.606-0.123 0.825-0.342s0.342-0.516 0.342-0.825zM22.417 12.5c-1.038 0-2.053-0.308-2.917-0.885s-1.536-1.397-1.934-2.356-0.501-2.015-0.299-3.033c0.203-1.018 0.703-1.954 1.437-2.688s1.67-1.234 2.688-1.437c1.018-0.203 2.074-0.099 3.033 0.299s1.779 1.070 2.356 1.934c0.577 0.863 0.885 1.878 0.885 2.917-0.001 1.392-0.555 2.726-1.539 3.711s-2.319 1.538-3.711 1.539zM22.417 4.333c-0.577 0-1.141 0.171-1.62 0.492s-0.853 0.776-1.074 1.309c-0.221 0.533-0.279 1.119-0.166 1.685s0.39 1.085 0.798 1.493c0.408 0.408 0.928 0.686 1.493 0.798s1.152 0.055 1.685-0.166c0.533-0.221 0.988-0.595 1.309-1.074s0.492-1.044 0.492-1.62c0-0.774-0.307-1.515-0.854-2.062s-1.289-0.854-2.062-0.854z"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sad",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 31.361c-8.469 0-15.36-6.89-15.36-15.36s6.891-15.36 15.36-15.36c8.47 0 15.36 6.891 15.36 15.36s-6.89 15.36-15.36 15.36zM16 2.561c-7.411 0-13.44 6.029-13.44 13.44s6.029 13.44 13.44 13.44 13.44-6.029 13.44-13.44c0-7.411-6.029-13.44-13.44-13.44zM23.149 22.619c0.474-0.237 0.666-0.814 0.429-1.288-0.090-0.179-2.247-4.371-7.579-4.371s-7.489 4.192-7.579 4.371c-0.236 0.473-0.045 1.045 0.426 1.284 0.473 0.238 1.048 0.049 1.289-0.421 0.069-0.135 1.745-3.314 5.864-3.314s5.794 3.178 5.861 3.309c0.168 0.337 0.507 0.531 0.86 0.53 0.144 0 0.291-0.032 0.428-0.101zM20.8 14.081c-1.059 0-1.92-0.861-1.92-1.92s0.861-1.92 1.92-1.92c1.059 0 1.92 0.861 1.92 1.92s-0.861 1.92-1.92 1.92zM11.2 14.081c-1.059 0-1.92-0.861-1.92-1.92s0.861-1.92 1.92-1.92c1.059 0 1.92 0.861 1.92 1.92s-0.861 1.92-1.92 1.92z"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-images",
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.859 16.334c1.466 0 2.654-1.188 2.654-2.654s-1.188-2.654-2.654-2.654c-1.466 0-2.654 1.188-2.654 2.654s1.188 2.654 2.654 2.654z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.767 4.574l-18.099-3.393c-0.583-0.109-1.185 0.018-1.674 0.352s-0.825 0.85-0.935 1.433l-0.939 5.007h-3.761c-0.293 0-0.584 0.058-0.855 0.17s-0.518 0.277-0.725 0.485c-0.208 0.208-0.372 0.454-0.484 0.725s-0.17 0.562-0.17 0.855v18.415c0 0.593 0.236 1.161 0.655 1.58s0.987 0.654 1.58 0.654h18.415c0.593 0 1.161-0.235 1.58-0.654s0.655-0.988 0.655-1.58v-1.657l0.541 0.102c0.288 0.054 0.585 0.051 0.872-0.010s0.56-0.177 0.802-0.343c0.242-0.166 0.449-0.378 0.61-0.623s0.271-0.521 0.325-0.809l3.393-18.099c0.054-0.288 0.051-0.585-0.010-0.872s-0.177-0.56-0.343-0.802-0.378-0.449-0.623-0.61c-0.246-0.16-0.521-0.271-0.809-0.325zM1.569 20.56v-9.476c0-0.442 0.176-0.866 0.488-1.179s0.737-0.488 1.179-0.488h16.764c0.415 0 0.813 0.165 1.106 0.458s0.458 0.691 0.458 1.106v14.18l-6.996-6.558-2.551 1.557-3.905-3.905-6.543 4.305zM27.989 7.677l-2.613 13.937-2.367-3.231v-8.176c0-0.593-0.235-1.161-0.654-1.58s-0.988-0.655-1.58-0.655h-13.184l0.727-3.879c0.040-0.215 0.123-0.42 0.242-0.604s0.274-0.341 0.455-0.465c0.181-0.124 0.384-0.211 0.598-0.256s0.435-0.047 0.651-0.007l16.477 3.089c0.202 0.038 0.395 0.115 0.567 0.227s0.32 0.257 0.436 0.427c0.116 0.17 0.198 0.36 0.24 0.561s0.045 0.408 0.007 0.61z"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-laptop",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.484 23.273h-28.966v-15.861c0-1.327 1.027-2.412 2.283-2.412h24.401c1.256 0 2.283 1.086 2.283 2.412v15.861zM28.163 20.952v-13.539c0-0.025-0.007-0.064-0.022-0.091h-24.28c-0.015 0.027-0.022 0.066-0.022 0.091v13.539h24.324z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.576 26.991c-0.867 0-1.576-0.709-1.576-1.576v-1.576h32v1.576c0 0.867-0.709 1.576-1.576 1.576h-28.849zM19.056 24.196h-6.113v0.585c0 0.321 0.251 0.584 0.557 0.584h4.999c0.306 0 0.557-0.263 0.557-0.584v-0.585z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-united-kingdom",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    style: {
      fill: "var(--color1, #012169)"
    },
    d: "M-5.333 0v32h53.333v-32h-53.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color2, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 6.4,
    d: "M-5.333 0l53.333 32M48 0l-53.333 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c8102e",
    style: {
      stroke: "var(--color3, #c8102e)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 4.2667,
    d: "M-5.333 0l53.333 32M48 0l-53.333 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    style: {
      fill: "var(--color3, #c8102e)",
      stroke: "var(--color2, #fff)"
    },
    stroke: "#fff",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.051,
    d: "M-5.323 11.9h22.561v-12.306h8.204v12.306h22.561v8.204h-22.561v12.306h-8.204v-12.306h-22.561v-8.204z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-germany",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f93939",
    style: {
      fill: "var(--color4, #f93939)"
    },
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffda2c",
    style: {
      fill: "var(--color5, #ffda2c)"
    },
    d: "M-23.469 21.333h89.6v10.667h-89.6v-10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151515",
    style: {
      fill: "var(--color6, #151515)"
    },
    d: "M-23.469 0h89.6v10.667h-89.6v-10.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-united-arab-emirates",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M0 0h42.667v32h-42.667v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5eaa22",
    style: {
      fill: "var(--color11, #5eaa22)"
    },
    d: "M0 0v10.667h42.667v-10.667h-42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272727",
    style: {
      fill: "var(--color12, #272727)"
    },
    d: "M0 21.333v10.667h42.667v-10.667h-42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e31d1c",
    style: {
      fill: "var(--color2, #e31d1c)"
    },
    d: "M0 0h13.333v32h-13.333v-32z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-spain",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    style: {
      fill: "var(--color10, #ad1519)"
    },
    d: "M45.333 0h-48v32h48v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fabd00",
    style: {
      fill: "var(--color11, #fabd00)"
    },
    d: "M45.333 8h-48v16h48v-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M13.321 14.28c-0.686-0.001-1.307-0.087-1.779-0.22 0.472-0.133 1.093-0.215 1.779-0.216 0.686 0.001 1.31 0.083 1.782 0.216-0.472 0.133-1.096 0.219-1.782 0.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M13.294 11.448c0.412 0 0.779 0.066 1.018 0.17 0.137 0.067 0.32 0.117 0.521 0.146 0.153 0.022 0.298 0.027 0.425 0.016 0.169-0.004 0.414 0.050 0.658 0.168 0.203 0.098 0.372 0.217 0.484 0.332l-0.097 0.094-0.028 0.268-0.267 0.333-0.133 0.123-0.316 0.275-0.161 0.014-0.049 0.152-2.042-0.261-2.048 0.261-0.049-0.152-0.161-0.014-0.316-0.275-0.133-0.123-0.266-0.333-0.028-0.268-0.098-0.094c0.113-0.115 0.282-0.234 0.484-0.332 0.245-0.117 0.489-0.171 0.658-0.168 0.126 0.011 0.272 0.006 0.425-0.016 0.201-0.029 0.385-0.079 0.521-0.146 0.239-0.103 0.585-0.17 0.997-0.17v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M14.765 12.108l-0.129-0.23c0.14-0.093 0.236-0.256 0.236-0.441 0-0.021-0.001-0.041-0.003-0.061-0.013-0.293-0.341-0.535-0.757-0.535-0.216 0-0.411 0.064-0.548 0.168-0.004-0.045-0.007-0.084-0.013-0.126 0.151-0.096 0.347-0.154 0.562-0.154 0.478 0 0.852 0.296 0.871 0.647 0.002 0.021 0.003 0.041 0.003 0.062 0 0.187-0.078 0.356-0.202 0.473l0.069 0.122-0.086 0.075zM11.876 12.108l0.129-0.23c-0.14-0.093-0.236-0.256-0.236-0.441 0-0.021 0.001-0.041 0.003-0.061 0.013-0.293 0.341-0.535 0.757-0.535 0.216 0 0.411 0.064 0.548 0.168 0.004-0.045 0.007-0.084 0.013-0.126-0.151-0.096-0.347-0.154-0.562-0.154-0.478 0-0.852 0.296-0.871 0.647-0.002 0.021-0.002 0.041-0.003 0.062 0 0.187 0.078 0.356 0.202 0.473l-0.069 0.122 0.086 0.075z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.106 11.527c0-0.229-0.138-0.433-0.346-0.569 0.129 0.113 0.207 0.258 0.218 0.421 0.002 0.020 0.003 0.041 0.003 0.062 0 0.187-0.078 0.356-0.202 0.473l0.063 0.125c0.163-0.133 0.265-0.313 0.265-0.512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M10.356 12.274c-0.091-0.112-0.147-0.256-0.147-0.414-0-0.093 0.019-0.184 0.057-0.267 0.132-0.296 0.546-0.512 1.039-0.512 0.134 0 0.263 0.016 0.381 0.045-0.026 0.031-0.047 0.066-0.067 0.1-0.099-0.021-0.204-0.032-0.314-0.032-0.451 0-0.828 0.191-0.937 0.449-0.030 0.067-0.045 0.141-0.045 0.216 0 0.157 0.067 0.298 0.173 0.394l-0.163 0.291-0.087-0.076 0.112-0.195v-0zM13.322 10.677c0.109 0 0.203 0.079 0.226 0.184 0.015 0.093 0.024 0.2 0.026 0.313 0 0.012-0.001 0.023-0.001 0.035 0 0.013 0.003 0.028 0.003 0.042 0.004 0.238 0.035 0.447 0.079 0.576l-0.333 0.347-0.337-0.347c0.045-0.128 0.076-0.338 0.080-0.576 0-0.014 0.003-0.028 0.003-0.042 0-0.012-0.001-0.023-0-0.035 0.002-0.113 0.011-0.22 0.026-0.313 0.022-0.106 0.12-0.184 0.229-0.184h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M13.324 13.708c-0.761 0.001-1.442 0.099-1.928 0.259-0.034 0.011-0.053 0.044-0.052 0.079-0.002 0.037 0.017 0.072 0.052 0.084 0.486 0.16 1.168 0.258 1.928 0.259 0.761-0.001 1.441-0.099 1.928-0.259 0.035-0.012 0.054-0.047 0.052-0.084 0.001-0.036-0.017-0.068-0.052-0.079-0.486-0.159-1.167-0.258-1.928-0.259h-0zM13.322 13.844c0.686 0.001 1.31 0.083 1.782 0.216-0.472 0.133-1.096 0.219-1.782 0.22-0.686-0.001-1.307-0.087-1.779-0.22 0.472-0.133 1.093-0.215 1.779-0.216z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M13.324 13.704c-0.77 0.002-1.461 0.107-1.947 0.27 0.040-0.021 0.037-0.075-0.014-0.216-0.061-0.171-0.155-0.163-0.155-0.163 0.538-0.173 1.286-0.281 2.119-0.283 0.833 0.001 1.588 0.109 2.125 0.283 0 0-0.095-0.008-0.155 0.163-0.050 0.141-0.054 0.195-0.014 0.216-0.486-0.163-1.19-0.268-1.96-0.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M13.322 13.312c-0.833 0.001-1.581 0.109-2.119 0.283-0.036 0.012-0.074-0.004-0.085-0.041s0.008-0.080 0.044-0.091c0.54-0.181 1.308-0.294 2.161-0.296 0.854 0.002 1.624 0.115 2.164 0.296 0.036 0.012 0.055 0.054 0.044 0.091s-0.050 0.052-0.085 0.041c-0.538-0.173-1.289-0.281-2.123-0.283z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M12.729 13.518c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.032-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M13.325 13.568h-0.204c-0.038 0-0.069-0.031-0.069-0.070s0.030-0.070 0.068-0.070h0.412c0.037 0 0.068 0.032 0.068 0.070s-0.031 0.070-0.069 0.070h-0.206z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006f46",
    style: {
      fill: "var(--color14, #006f46)"
    },
    d: "M12.297 13.638l-0.147 0.019c-0.037 0.005-0.072-0.023-0.077-0.061s0.022-0.074 0.059-0.078l0.297-0.038c0.037-0.005 0.071 0.022 0.076 0.061s-0.023 0.074-0.060 0.078l-0.149 0.019z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M11.708 13.643c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M11.265 13.753l0.062-0.087 0.209 0.029-0.167 0.133-0.092-0.039-0.026-0.013 0.015-0.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006f46",
    style: {
      fill: "var(--color14, #006f46)"
    },
    d: "M14.345 13.638l0.146 0.019c0.037 0.005 0.072-0.023 0.077-0.061s-0.022-0.074-0.059-0.078l-0.297-0.038c-0.037-0.005-0.071 0.022-0.076 0.061s0.023 0.074 0.060 0.078l0.149 0.019z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M13.781 13.518c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.032-0.068-0.070zM14.805 13.648c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M15.399 13.774l-0.076-0.108-0.209 0.029 0.167 0.133 0.124-0.044-0.007-0.010z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M13.315 10.781c0.057 0 0.105 0.039 0.116 0.094 0.014 0.088 0.023 0.189 0.024 0.296 0 0.011-0.001 0.022-0.001 0.033 0 0.013 0.002 0.026 0.002 0.040 0.004 0.224 0.033 0.422 0.075 0.544l-0.22 0.227-0.22-0.227c0.042-0.121 0.071-0.319 0.075-0.544 0-0.013 0.002-0.027 0.003-0.040 0-0.011-0.001-0.022-0.001-0.033 0.002-0.107 0.011-0.207 0.025-0.296 0.011-0.055 0.063-0.094 0.12-0.094h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M13.198 11.871c0-0.067 0.053-0.121 0.118-0.121s0.118 0.054 0.118 0.121c0 0.067-0.053 0.122-0.118 0.122s-0.118-0.055-0.118-0.122z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M13.198 11.633c0-0.067 0.053-0.122 0.118-0.122s0.118 0.055 0.118 0.122c0 0.067-0.053 0.122-0.118 0.122s-0.118-0.054-0.118-0.122zM13.222 11.376c0-0.054 0.042-0.097 0.094-0.097s0.094 0.043 0.094 0.097-0.042 0.097-0.094 0.097c-0.052 0-0.094-0.043-0.094-0.097zM13.248 11.144c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070zM13.262 10.942c0-0.031 0.024-0.056 0.054-0.056s0.054 0.025 0.054 0.056c0 0.031-0.024 0.056-0.054 0.056s-0.054-0.025-0.054-0.056z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M13.325 12.604l0.077 0.015c-0.012 0.034-0.015 0.071-0.015 0.11 0 0.174 0.137 0.315 0.305 0.315 0.135 0 0.25-0.091 0.29-0.217 0.004 0.003 0.029-0.114 0.042-0.112 0.011 0.001 0.010 0.122 0.014 0.12 0.020 0.159 0.153 0.266 0.302 0.266 0.168 0 0.304-0.14 0.304-0.314 0-0.013-0.001-0.026-0.002-0.038l0.096-0.103 0.051 0.132c-0.020 0.041-0.029 0.088-0.029 0.137 0 0.166 0.13 0.3 0.291 0.3 0.101 0 0.19-0.053 0.242-0.133l0.061-0.085-0 0.104c0 0.104 0.040 0.198 0.134 0.215 0 0 0.107 0.007 0.25-0.114s0.221-0.223 0.221-0.223l0.012 0.122c0 0-0.118 0.199-0.247 0.28-0.070 0.045-0.177 0.091-0.262 0.076-0.090-0.016-0.154-0.094-0.187-0.185-0.064 0.041-0.14 0.065-0.22 0.065-0.174 0-0.33-0.104-0.392-0.26-0.080 0.094-0.191 0.152-0.322 0.152-0.139 0-0.266-0.068-0.346-0.173-0.078 0.078-0.185 0.126-0.302 0.126-0.154 0-0.291-0.082-0.369-0.206-0.078 0.124-0.215 0.206-0.368 0.206-0.117 0-0.224-0.048-0.303-0.126-0.079 0.105-0.207 0.173-0.346 0.173-0.131 0-0.242-0.058-0.322-0.152-0.062 0.156-0.218 0.26-0.392 0.26-0.081 0-0.156-0.024-0.22-0.065-0.033 0.090-0.097 0.169-0.187 0.185-0.085 0.015-0.192-0.032-0.262-0.076-0.129-0.081-0.247-0.28-0.247-0.28l0.012-0.122c0 0 0.078 0.101 0.22 0.223s0.25 0.114 0.25 0.114c0.094-0.017 0.134-0.11 0.134-0.215l-0-0.104 0.061 0.085c0.052 0.080 0.141 0.133 0.242 0.133 0.161 0 0.291-0.134 0.291-0.3 0-0.050-0.008-0.096-0.029-0.137l0.051-0.132 0.096 0.103c-0.001 0.012-0.002 0.025-0.002 0.038 0 0.174 0.136 0.314 0.304 0.314 0.15 0 0.283-0.107 0.302-0.266 0.004 0.002 0.003-0.118 0.014-0.12 0.013-0.001 0.037 0.116 0.042 0.112 0.040 0.126 0.155 0.217 0.29 0.217 0.168 0 0.305-0.141 0.305-0.315 0-0.039-0.002-0.076-0.015-0.11l0.080-0.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M15.416 13.010c0.018-0.056 0.002-0.112-0.035-0.124s-0.082 0.023-0.099 0.079c-0.018 0.056-0.002 0.112 0.035 0.124s0.082-0.023 0.099-0.079zM14.091 12.73c0.007-0.059-0.019-0.11-0.058-0.115s-0.076 0.038-0.083 0.097c-0.007 0.059 0.019 0.11 0.058 0.115s0.076-0.039 0.083-0.097zM12.551 12.73c-0.007-0.059 0.019-0.11 0.058-0.115s0.076 0.038 0.083 0.097c0.007 0.059-0.019 0.11-0.058 0.115s-0.076-0.039-0.083-0.097zM11.226 13.010c-0.018-0.056-0.002-0.112 0.035-0.124s0.082 0.023 0.099 0.079c0.017 0.056 0.002 0.112-0.035 0.124s-0.082-0.023-0.099-0.079z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.832 12.739c-0.021-0.018-0.037-0.043-0.042-0.073s0.001-0.059 0.014-0.083c0 0-0.055-0.030-0.114-0.047-0.045-0.013-0.123-0.013-0.147-0.014s-0.071-0.002-0.071-0.002 0.004 0.012 0.017 0.037c0.016 0.031 0.031 0.050 0.031 0.050-0.079 0.020-0.146 0.076-0.188 0.141 0.061 0.046 0.143 0.074 0.223 0.065 0 0-0.007 0.023-0.012 0.059-0.004 0.029-0.004 0.041-0.004 0.041s0.044-0.018 0.066-0.027c0.022-0.009 0.096-0.037 0.134-0.065 0.050-0.037 0.092-0.085 0.092-0.085zM12.009 12.707c0.014-0.024 0.020-0.053 0.015-0.083s-0.020-0.055-0.041-0.073c0 0 0.041-0.048 0.091-0.084 0.038-0.028 0.112-0.056 0.134-0.065s0.066-0.027 0.066-0.027 0 0.012-0.004 0.041c-0.005 0.035-0.012 0.058-0.012 0.058 0.080-0.009 0.162 0.020 0.223 0.067-0.042 0.065-0.11 0.12-0.188 0.14 0 0 0.014 0.019 0.031 0.050 0.014 0.026 0.018 0.037 0.018 0.037s-0.047-0.001-0.071-0.002c-0.024-0-0.102-0.001-0.147-0.014-0.059-0.017-0.114-0.047-0.114-0.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.947 12.257c0 0 0.008-0.017 0.044-0.040s0.068-0.022 0.068-0.022-0.011 0.066-0.016 0.089c-0.005 0.023-0.006 0.093-0.019 0.157s-0.039 0.114-0.039 0.114c-0.014-0.012-0.029-0.021-0.046-0.025s-0.034-0.006-0.052-0.003c-0.036 0.007-0.066 0.030-0.083 0.061 0 0-0.040-0.039-0.075-0.093s-0.057-0.12-0.070-0.14c-0.013-0.020-0.044-0.078-0.044-0.078s0.029-0.012 0.071-0.003c0.042 0.008 0.055 0.022 0.055 0.022-0.009-0.087 0.017-0.177 0.064-0.243 0.066 0.045 0.123 0.121 0.143 0.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M11.781 12.649c0-0.077 0.060-0.139 0.134-0.139s0.134 0.062 0.134 0.139c0 0.077-0.060 0.139-0.134 0.139s-0.134-0.062-0.134-0.139z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M13.447 12.080c0 0 0.012-0.018 0.056-0.036s0.079-0.011 0.079-0.011-0.024 0.071-0.034 0.096c-0.010 0.025-0.024 0.103-0.052 0.171s-0.065 0.119-0.065 0.119c-0.025-0.031-0.062-0.051-0.104-0.051s-0.079 0.020-0.103 0.051c0 0-0.038-0.051-0.065-0.119s-0.041-0.146-0.052-0.171c-0.010-0.025-0.035-0.096-0.035-0.096s0.035-0.007 0.079 0.011c0.045 0.018 0.057 0.036 0.057 0.036 0.006-0.098 0.053-0.194 0.118-0.258 0.065 0.064 0.114 0.159 0.121 0.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M13.225 12.605c-0.020-0.024-0.033-0.056-0.033-0.090s0.012-0.066 0.032-0.089c0 0-0.055-0.045-0.118-0.076-0.047-0.024-0.135-0.040-0.161-0.045s-0.079-0.016-0.079-0.016 0.002 0.014 0.012 0.045c0.012 0.038 0.025 0.063 0.025 0.063-0.091 0.006-0.177 0.055-0.236 0.12 0.059 0.064 0.145 0.112 0.236 0.118 0 0-0.012 0.024-0.025 0.063-0.010 0.031-0.012 0.045-0.012 0.045s0.053-0.011 0.079-0.016c0.026-0.006 0.114-0.022 0.161-0.046 0.062-0.031 0.119-0.075 0.119-0.075zM13.428 12.605c0.020-0.024 0.033-0.056 0.033-0.090s-0.012-0.066-0.032-0.089c0 0 0.055-0.045 0.118-0.076 0.047-0.024 0.135-0.040 0.161-0.045s0.079-0.016 0.079-0.016-0.002 0.014-0.012 0.045c-0.012 0.038-0.024 0.063-0.024 0.063 0.091 0.006 0.177 0.055 0.236 0.12-0.059 0.064-0.145 0.112-0.236 0.118 0 0 0.012 0.024 0.024 0.063 0.010 0.031 0.012 0.045 0.012 0.045s-0.052-0.011-0.079-0.016c-0.026-0.006-0.114-0.022-0.161-0.046-0.062-0.031-0.119-0.075-0.119-0.075zM14.705 12.257c0 0-0.008-0.017-0.044-0.040s-0.068-0.022-0.068-0.022 0.010 0.066 0.016 0.089c0.005 0.023 0.006 0.093 0.019 0.157s0.039 0.114 0.039 0.114c0.014-0.012 0.029-0.021 0.046-0.025s0.034-0.006 0.052-0.003c0.036 0.007 0.066 0.030 0.083 0.061 0 0 0.040-0.039 0.075-0.093s0.057-0.12 0.070-0.14c0.013-0.020 0.044-0.078 0.044-0.078s-0.029-0.012-0.071-0.003c-0.042 0.008-0.055 0.022-0.055 0.022 0.009-0.087-0.017-0.177-0.064-0.243-0.066 0.045-0.123 0.121-0.143 0.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M14.816 12.739c0.021-0.018 0.037-0.043 0.042-0.073 0.005-0.029-0-0.058-0.014-0.083 0 0 0.055-0.030 0.113-0.047 0.045-0.013 0.124-0.013 0.147-0.014s0.071-0.002 0.071-0.002-0.004 0.012-0.017 0.037c-0.016 0.031-0.031 0.050-0.031 0.050 0.079 0.020 0.146 0.076 0.188 0.141-0.061 0.046-0.143 0.074-0.223 0.065 0 0 0.007 0.023 0.012 0.059 0.004 0.029 0.004 0.041 0.004 0.041s-0.044-0.018-0.066-0.027c-0.022-0.009-0.096-0.037-0.134-0.065-0.049-0.037-0.092-0.085-0.092-0.085zM14.639 12.707c-0.014-0.024-0.020-0.053-0.015-0.083s0.020-0.055 0.041-0.073c0 0-0.042-0.048-0.091-0.084-0.038-0.028-0.112-0.056-0.134-0.065s-0.066-0.027-0.066-0.027-0 0.012 0.004 0.041c0.005 0.035 0.012 0.058 0.012 0.058-0.080-0.009-0.162 0.020-0.223 0.067 0.042 0.065 0.11 0.12 0.188 0.14 0 0-0.014 0.019-0.031 0.050-0.014 0.026-0.017 0.037-0.017 0.037s0.047-0.001 0.071-0.002c0.023-0 0.103-0.001 0.147-0.014 0.059-0.017 0.114-0.047 0.114-0.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M14.604 12.649c0-0.077 0.060-0.139 0.134-0.139s0.135 0.062 0.135 0.139c0 0.077-0.060 0.139-0.135 0.139s-0.134-0.062-0.134-0.139zM16.108 12.958c-0.032-0.036-0.097-0.029-0.146 0.017s-0.063 0.112-0.032 0.148c0.032 0.036 0.097 0.029 0.146-0.017s0.063-0.112 0.032-0.148z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.92 13.042c0.007-0.025 0.022-0.050 0.045-0.072 0.049-0.046 0.115-0.053 0.146-0.017 0.004 0.005 0.008 0.011 0.011 0.017 0 0 0.068-0.141 0.149-0.188s0.217-0.035 0.217-0.035c0-0.108-0.081-0.195-0.186-0.195-0.061 0-0.12 0.028-0.154 0.075l-0.014-0.072c0 0-0.084 0.018-0.123 0.123s0.003 0.257 0.003 0.257-0.021-0.065-0.053-0.109c-0.031-0.043-0.112-0.090-0.154-0.112s-0.085-0.054-0.085-0.054-0.002 0.012-0.004 0.041c-0.002 0.035 0.001 0.056 0.001 0.056-0.077-0.011-0.167 0.003-0.237 0.032 0.030 0.064 0.087 0.125 0.162 0.156 0 0-0.027 0.024-0.052 0.051-0.020 0.023-0.027 0.033-0.027 0.033s0.053 0.008 0.079 0.012c0.026 0.004 0.114 0.019 0.166 0.015 0.039-0.003 0.082-0.010 0.108-0.015zM10.735 13.042c-0.007-0.025-0.022-0.050-0.045-0.072-0.049-0.046-0.114-0.053-0.146-0.017-0.004 0.005-0.008 0.011-0.011 0.017 0 0-0.068-0.141-0.149-0.188s-0.217-0.035-0.217-0.035c0-0.108 0.081-0.195 0.186-0.195 0.062 0 0.119 0.028 0.154 0.075l0.014-0.072c0 0 0.084 0.018 0.123 0.123s-0.004 0.257-0.004 0.257 0.021-0.065 0.053-0.109c0.032-0.043 0.112-0.090 0.154-0.112s0.085-0.054 0.085-0.054 0.002 0.012 0.003 0.041c0.002 0.035-0.001 0.056-0.001 0.056 0.077-0.011 0.167 0.003 0.237 0.032-0.030 0.064-0.087 0.125-0.162 0.156 0 0 0.027 0.024 0.052 0.051 0.021 0.023 0.027 0.033 0.027 0.033s-0.053 0.008-0.079 0.012c-0.027 0.004-0.114 0.019-0.166 0.015-0.039-0.003-0.082-0.010-0.108-0.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M10.538 12.954c0.032-0.036 0.097-0.029 0.146 0.017s0.063 0.112 0.032 0.148c-0.032 0.036-0.097 0.029-0.146-0.017s-0.063-0.112-0.032-0.148zM13.185 12.514c0-0.077 0.060-0.139 0.134-0.139s0.135 0.062 0.135 0.139c0 0.077-0.060 0.139-0.135 0.139s-0.134-0.062-0.134-0.139z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0044ad",
    style: {
      fill: "var(--color15, #0044ad)"
    },
    d: "M13.042 10.409c0-0.157 0.123-0.284 0.275-0.284s0.275 0.127 0.275 0.284c0 0.156-0.123 0.283-0.275 0.283s-0.275-0.127-0.275-0.283z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M13.245 9.604v0.153h-0.15v0.155h0.15v0.447h-0.189c-0.002 0.015-0.014 0.025-0.014 0.040 0 0.039 0.008 0.077 0.021 0.111 0 0.001 0.002 0.001 0.002 0.002h0.504c0-0.001 0.002-0.001 0.002-0.002 0.014-0.035 0.022-0.072 0.021-0.111 0-0.015-0.011-0.026-0.014-0.040h-0.183v-0.447h0.15v-0.155h-0.15v-0.153h-0.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M16.417 12.528c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M16.51 12.341c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M16.573 12.133c0-0.039 0.031-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M16.583 11.914c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M16.531 11.695c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M16.427 11.497c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M16.281 11.331c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M16.125 11.195c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M15.927 11.080c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M15.729 11.008c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.031 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M16.277 12.265c0.091-0.112 0.147-0.256 0.147-0.414 0-0.093-0.019-0.184-0.057-0.267-0.132-0.296-0.546-0.512-1.039-0.512-0.134 0-0.263 0.016-0.381 0.045 0.026 0.031 0.047 0.066 0.067 0.1 0.099-0.021 0.204-0.032 0.314-0.032 0.451 0 0.828 0.191 0.937 0.449 0.030 0.067 0.045 0.141 0.045 0.216 0 0.157-0.067 0.298-0.173 0.394l0.163 0.291 0.087-0.076-0.112-0.195v-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M15.5 10.966c0-0.039 0.030-0.070 0.068-0.070s0.068 0.032 0.068 0.070-0.030 0.070-0.068 0.070c-0.037 0-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M15.292 10.945c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M15.083 10.956c0-0.039 0.031-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M14.875 10.956c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M14.981 11.154c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.032-0.068-0.070zM15.024 11.37c0-0.039 0.030-0.070 0.068-0.070s0.068 0.032 0.068 0.070c0 0.038-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070zM15.032 11.585c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070zM14.97 11.781c0-0.039 0.030-0.070 0.068-0.070s0.068 0.032 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070zM14.854 11.961c0-0.039 0.031-0.070 0.068-0.070s0.068 0.032 0.068 0.070-0.030 0.070-0.068 0.070c-0.037 0-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M14.719 10.82c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M14.531 10.706c0-0.039 0.030-0.070 0.068-0.070s0.068 0.032 0.068 0.070-0.030 0.070-0.068 0.070c-0.038 0-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M14.323 10.643c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.032-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M14.115 10.601c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.032-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M13.906 10.602c0-0.039 0.030-0.070 0.068-0.070s0.068 0.032 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M13.688 10.643c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M13.479 10.716c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.032-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M10.083 12.528c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M9.99 12.341c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M9.927 12.133c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M9.917 11.914c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M9.969 11.695c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M10.073 11.497c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M10.208 11.331c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M10.375 11.195c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M10.573 11.080c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M10.771 11.008c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M10.99 10.966c0-0.039 0.030-0.070 0.068-0.070s0.068 0.032 0.068 0.070-0.030 0.070-0.068 0.070c-0.037 0-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M11.208 10.945c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M11.417 10.956c0-0.039 0.031-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M11.625 10.956c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.796 12.039c-0.163-0.133-0.265-0.313-0.265-0.512 0-0.229 0.137-0.433 0.346-0.569-0.129 0.113-0.207 0.258-0.218 0.421-0.002 0.020-0.003 0.041-0.003 0.062 0 0.187 0.078 0.356 0.202 0.473l-0.063 0.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M11.519 11.154c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.032-0.068-0.070zM11.477 11.37c0-0.039 0.030-0.070 0.068-0.070s0.068 0.032 0.068 0.070c0 0.038-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070zM11.469 11.585c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070zM11.531 11.781c0-0.039 0.030-0.070 0.068-0.070s0.068 0.032 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070zM11.646 11.961c0-0.039 0.031-0.070 0.068-0.070s0.068 0.032 0.068 0.070-0.030 0.070-0.068 0.070c-0.037 0-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M11.781 10.82c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M11.969 10.706c0-0.039 0.030-0.070 0.068-0.070s0.068 0.032 0.068 0.070-0.030 0.070-0.068 0.070c-0.037 0-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M12.177 10.643c0-0.039 0.031-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.032-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M12.385 10.601c0-0.039 0.031-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.032-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M12.594 10.602c0-0.039 0.030-0.070 0.068-0.070s0.068 0.032 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M12.813 10.643c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.031-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M13.010 10.716c0-0.039 0.030-0.070 0.068-0.070s0.068 0.031 0.068 0.070c0 0.039-0.030 0.070-0.068 0.070s-0.068-0.032-0.068-0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M10.52 11.292c-0.119 0.081-0.208 0.181-0.258 0.293-0.037 0.083-0.057 0.175-0.057 0.267 0 0.158 0.056 0.302 0.147 0.414l-0.099 0.175c-0.095-0.133-0.15-0.288-0.15-0.453 0-0.284 0.166-0.532 0.416-0.696h0zM16.117 11.292c0.119 0.081 0.208 0.181 0.258 0.293 0.037 0.083 0.056 0.175 0.056 0.267 0 0.158-0.056 0.302-0.147 0.414l0.099 0.175c0.095-0.133 0.15-0.288 0.15-0.453 0-0.284-0.166-0.532-0.416-0.696z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M17.96 13.99c0 0-0.046 0.052-0.079 0.060s-0.075-0.033-0.075-0.033-0.030 0.034-0.067 0.043c-0.037 0.009-0.088-0.045-0.088-0.045s-0.035 0.054-0.067 0.067c-0.032 0.013-0.070-0.016-0.070-0.016s-0.014 0.027-0.040 0.042c-0.011 0.006-0.030-0.004-0.030-0.004l-0.037-0.025-0.042-0.049-0.039-0.016c0 0-0.017-0.061-0.019-0.072s-0.005-0.038-0.005-0.038c-0.008-0.044 0.054-0.095 0.143-0.117 0.051-0.013 0.095-0.012 0.128-0.001 0.035-0.033 0.11-0.056 0.198-0.056 0.080 0 0.15 0.018 0.188 0.047 0.038-0.029 0.108-0.047 0.188-0.047 0.088 0 0.162 0.023 0.198 0.056 0.033-0.011 0.077-0.012 0.128 0.001 0.088 0.022 0.151 0.073 0.143 0.117 0 0-0.004 0.027-0.005 0.038s-0.019 0.072-0.019 0.072l-0.039 0.016-0.042 0.049-0.036 0.025c0 0-0.019 0.010-0.030 0.004-0.026-0.015-0.040-0.042-0.040-0.042s-0.039 0.029-0.070 0.016c-0.032-0.013-0.067-0.067-0.067-0.067s-0.051 0.054-0.088 0.045c-0.037-0.009-0.067-0.043-0.067-0.043s-0.042 0.040-0.075 0.033c-0.033-0.007-0.079-0.060-0.079-0.060z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.875 13.705c0-0.073 0.038-0.132 0.085-0.132s0.086 0.059 0.086 0.132c0 0.074-0.038 0.133-0.086 0.133s-0.085-0.059-0.085-0.133z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.927 13.705c0-0.067 0.018-0.122 0.039-0.122s0.039 0.055 0.039 0.122c0 0.067-0.017 0.122-0.039 0.122s-0.039-0.055-0.039-0.122z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.526 14.251c-0.013-0.039-0.036-0.073-0.036-0.073 0.121-0.039 0.289-0.063 0.476-0.063s0.356 0.025 0.477 0.063c0 0-0.014 0.026-0.032 0.062-0.010 0.020-0.024 0.055-0.023 0.055-0.109-0.036-0.25-0.055-0.422-0.055s-0.339 0.023-0.425 0.058c0.001 0-0.006-0.022-0.015-0.046h0.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M17.961 14.419c0.151-0 0.317-0.025 0.378-0.042 0.041-0.013 0.065-0.033 0.060-0.056-0.002-0.011-0.011-0.021-0.023-0.026-0.090-0.031-0.252-0.054-0.416-0.054s-0.326 0.023-0.417 0.054c-0.012 0.006-0.021 0.015-0.023 0.026-0.005 0.023 0.019 0.043 0.060 0.056 0.061 0.017 0.228 0.042 0.379 0.042z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.961 14.419c0.151-0 0.317-0.025 0.378-0.042 0.041-0.013 0.065-0.033 0.060-0.056-0.002-0.011-0.011-0.021-0.023-0.026-0.090-0.031-0.252-0.054-0.416-0.054s-0.326 0.023-0.417 0.054c-0.012 0.006-0.021 0.015-0.023 0.026-0.005 0.023 0.019 0.043 0.060 0.056 0.061 0.017 0.228 0.042 0.379 0.042z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M18.326 13.766c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029zM18.31 13.665c0-0.016 0.012-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029h-0zM18.239 13.601c0-0.016 0.012-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029zM18.152 13.571c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.012 0.029-0.028 0.029s-0.028-0.013-0.028-0.029zM18.063 13.574c0-0.016 0.012-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M18.633 13.875c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029zM18.622 13.768c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029zM18.559 13.687c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.012 0.029-0.028 0.029s-0.028-0.013-0.028-0.029zM18.475 13.643c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029v0zM18.385 13.647c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M18.452 14.1l-0.037-0.036c0 0-0.035 0.023-0.079 0.016s-0.058-0.065-0.058-0.065-0.049 0.045-0.089 0.042c-0.040-0.004-0.066-0.042-0.066-0.042s-0.044 0.034-0.083 0.031c-0.039-0.004-0.075-0.056-0.075-0.056s-0.039 0.054-0.077 0.058c-0.039 0.003-0.070-0.036-0.070-0.036s-0.018 0.040-0.067 0.049c-0.049 0.009-0.091-0.042-0.091-0.042s-0.028 0.049-0.061 0.062c-0.033 0.013-0.077-0.018-0.077-0.018s-0.007 0.018-0.012 0.029c-0.005 0.011-0.019 0.013-0.019 0.013l0.011 0.032c0.12-0.038 0.283-0.061 0.467-0.062s0.352 0.024 0.472 0.062l0.012-0.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M17.542 13.766c0-0.016 0.012-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029v0zM17.557 13.665c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029zM17.627 13.601c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029zM17.715 13.571c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029zM17.805 13.574c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M17.24 13.875c0-0.016 0.012-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029zM17.25 13.768c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029zM17.313 13.687c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.013 0.029-0.028 0.029s-0.028-0.013-0.028-0.029zM17.397 13.643c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.012 0.029-0.028 0.029s-0.028-0.013-0.028-0.029v0zM17.487 13.647c0-0.016 0.013-0.029 0.028-0.029s0.028 0.013 0.028 0.029c0 0.016-0.012 0.029-0.028 0.029s-0.028-0.013-0.028-0.029z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.966 13.927l0.017 0.003c-0.003 0.008-0.003 0.016-0.003 0.025 0 0.039 0.031 0.071 0.069 0.071 0.031 0 0.057-0.021 0.066-0.049 0.001 0.001 0.007-0.026 0.009-0.025s0.002 0.028 0.003 0.027c0.005 0.036 0.035 0.060 0.069 0.060 0.038 0 0.069-0.032 0.069-0.071 0-0.003-0-0.006-0.001-0.009l0.022-0.024 0.012 0.030c-0.005 0.009-0.006 0.020-0.006 0.031 0 0.038 0.030 0.068 0.066 0.068 0.023 0 0.043-0.012 0.055-0.030l0.014-0.019-0 0.024c0 0.024 0.009 0.045 0.030 0.048 0 0 0.024 0.002 0.057-0.026s0.050-0.051 0.050-0.051l0.002 0.028c0 0-0.032 0.057-0.060 0.075-0.016 0.010-0.040 0.021-0.059 0.017-0.020-0.003-0.034-0.021-0.042-0.041-0.015 0.010-0.032 0.015-0.050 0.015-0.039 0-0.074-0.024-0.088-0.058-0.018 0.021-0.043 0.034-0.072 0.034-0.031 0-0.060-0.015-0.078-0.039-0.018 0.018-0.042 0.029-0.068 0.029-0.034 0-0.065-0.019-0.083-0.046-0.017 0.028-0.048 0.046-0.083 0.046-0.025 0-0.049-0.010-0.068-0.029-0.018 0.024-0.046 0.039-0.078 0.039-0.029 0-0.054-0.013-0.072-0.034-0.014 0.035-0.049 0.058-0.088 0.058-0.017 0-0.034-0.005-0.049-0.015-0.007 0.020-0.022 0.038-0.042 0.041-0.019 0.004-0.043-0.007-0.059-0.017-0.029-0.018-0.063-0.075-0.063-0.075l0.004-0.028c0 0 0.018 0.023 0.050 0.051s0.057 0.026 0.057 0.026c0.021-0.004 0.030-0.025 0.030-0.048v-0.024l0.014 0.019c0.006 0.009 0.014 0.017 0.024 0.022s0.020 0.008 0.031 0.008c0.037 0 0.066-0.030 0.066-0.068 0-0.011-0.002-0.022-0.006-0.031l0.012-0.030 0.022 0.024c-0 0.003-0 0.006-0 0.009 0 0.039 0.031 0.071 0.069 0.071 0.034 0 0.064-0.024 0.069-0.060 0.001 0 0.001-0.027 0.003-0.027s0.009 0.026 0.010 0.025c0.009 0.029 0.035 0.049 0.066 0.049 0.038 0 0.069-0.032 0.069-0.071 0-0.009-0-0.017-0.003-0.025l0.018-0.003h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M17.966 14.119c-0.187 0-0.355 0.024-0.476 0.063-0.008 0.003-0.018-0.004-0.021-0.012s0.003-0.019 0.011-0.022c0.121-0.040 0.294-0.066 0.485-0.066s0.364 0.026 0.486 0.066c0.008 0.003 0.014 0.013 0.011 0.022s-0.013 0.015-0.021 0.012c-0.121-0.039-0.289-0.063-0.476-0.063z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.966 14.119c-0.187 0-0.355 0.024-0.476 0.063-0.008 0.003-0.018-0.004-0.021-0.012s0.003-0.019 0.011-0.022c0.121-0.040 0.294-0.066 0.485-0.066s0.364 0.026 0.486 0.066c0.008 0.003 0.014 0.013 0.011 0.022s-0.013 0.015-0.021 0.012c-0.121-0.039-0.289-0.063-0.476-0.063z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M17.781 14.184c0-0.015 0.012-0.028 0.027-0.028s0.027 0.013 0.027 0.028c0 0.016-0.012 0.028-0.027 0.028s-0.027-0.012-0.027-0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M17.781 14.184c0-0.015 0.012-0.028 0.027-0.028s0.027 0.013 0.027 0.028c0 0.016-0.012 0.028-0.027 0.028s-0.027-0.012-0.027-0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M17.966 14.198h-0.060c-0.011 0-0.020-0.010-0.020-0.021s0.009-0.021 0.020-0.021h0.122c0.011 0 0.020 0.009 0.020 0.021s-0.009 0.021-0.020 0.021h-0.061z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006f46",
    style: {
      fill: "var(--color14, #006f46)"
    },
    d: "M17.66 14.226l-0.043 0.007c-0.011 0.002-0.021-0.006-0.023-0.018s0.006-0.022 0.017-0.024l0.043-0.007 0.044-0.007c0.011-0.001 0.021 0.006 0.023 0.017s-0.006 0.022-0.017 0.024l-0.044 0.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M17.49 14.252l0.019-0.034 0.041 0.008-0.024 0.038-0.036-0.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M18.094 14.184c0-0.015 0.012-0.028 0.027-0.028s0.027 0.013 0.027 0.028c0 0.016-0.012 0.028-0.027 0.028s-0.027-0.012-0.027-0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M18.094 14.184c0-0.015 0.012-0.028 0.027-0.028s0.027 0.013 0.027 0.028c0 0.016-0.012 0.028-0.027 0.028s-0.027-0.012-0.027-0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006f46",
    style: {
      fill: "var(--color14, #006f46)"
    },
    d: "M18.259 14.226l0.043 0.007c0.011 0.002 0.021-0.006 0.023-0.018s-0.006-0.022-0.016-0.024l-0.043-0.007-0.044-0.007c-0.011-0.001-0.021 0.006-0.023 0.017s0.006 0.022 0.017 0.024l0.044 0.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M18.432 14.254l-0.015-0.036-0.042 0.004 0.020 0.040 0.037-0.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M17.964 14.383c-0.151-0-0.287-0.015-0.391-0.044 0.104-0.029 0.241-0.047 0.391-0.047s0.288 0.018 0.392 0.047c-0.104 0.029-0.241 0.044-0.392 0.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M18.438 14.018c0.004-0.013 0-0.025-0.008-0.028s-0.018 0.006-0.022 0.018c-0.004 0.013-0.001 0.026 0.008 0.029s0.019-0.005 0.023-0.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M18.438 14.018c0.004-0.013 0-0.025-0.008-0.028s-0.018 0.006-0.022 0.018c-0.004 0.013-0.001 0.026 0.008 0.029s0.019-0.005 0.023-0.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M18.136 13.964c0.002-0.013-0.004-0.025-0.013-0.026s-0.017 0.009-0.019 0.022c-0.002 0.013 0.004 0.025 0.013 0.026s0.017-0.009 0.019-0.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M18.136 13.964c0.002-0.013-0.004-0.025-0.013-0.026s-0.017 0.009-0.019 0.022c-0.002 0.013 0.004 0.025 0.013 0.026s0.017-0.009 0.019-0.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M17.792 13.964c-0.002-0.013 0.004-0.025 0.013-0.026s0.017 0.009 0.019 0.022c0.001 0.013-0.004 0.025-0.013 0.026s-0.017-0.009-0.019-0.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M17.792 13.964c-0.002-0.013 0.004-0.025 0.013-0.026s0.017 0.009 0.019 0.022c0.001 0.013-0.004 0.025-0.013 0.026s-0.017-0.009-0.019-0.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M17.491 14.018c-0.004-0.013-0-0.025 0.008-0.028s0.019 0.006 0.023 0.018c0.004 0.013 0 0.026-0.008 0.029s-0.019-0.005-0.023-0.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M17.491 14.018c-0.004-0.013-0-0.025 0.008-0.028s0.019 0.006 0.023 0.018c0.004 0.013 0 0.026-0.008 0.029s-0.019-0.005-0.023-0.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.959 13.771l-0.053 0.035 0.039 0.093 0.014 0.010 0.014-0.010 0.040-0.093c-0.018-0.012-0.035-0.024-0.053-0.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.844 13.912l0.024 0.038 0.083-0.028 0.009-0.013-0.009-0.013-0.083-0.026c-0.009 0.014-0.017 0.027-0.024 0.042zM18.078 13.912l-0.024 0.038-0.083-0.028-0.009-0.013 0.009-0.013 0.083-0.026c0.009 0.014 0.016 0.028 0.024 0.042zM17.615 13.813l-0.042 0.043 0.053 0.077 0.014 0.006 0.010-0.012 0.019-0.093c-0.018-0.007-0.037-0.014-0.055-0.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.524 13.971l0.031 0.032 0.076-0.045 0.006-0.014-0.011-0.011-0.087-0.008c-0.006 0.015-0.010 0.030-0.015 0.046v-0zM17.753 13.921l-0.016 0.042-0.087-0.009-0.011-0.011 0.006-0.015 0.076-0.044c0.011 0.011 0.022 0.023 0.032 0.035zM17.441 13.983l-0.007 0.045-0.087 0.010-0.013-0.008 0.003-0.015 0.065-0.059c0.013 0.010 0.026 0.019 0.039 0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M17.615 13.938c0-0.018 0.014-0.032 0.030-0.032s0.030 0.014 0.030 0.032c0 0.017-0.014 0.031-0.030 0.031s-0.030-0.014-0.030-0.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M17.615 13.938c0-0.018 0.014-0.032 0.030-0.032s0.030 0.014 0.030 0.032c0 0.017-0.014 0.031-0.030 0.031s-0.030-0.014-0.030-0.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M18.305 13.813l0.042 0.043-0.054 0.077-0.014 0.006-0.010-0.012-0.019-0.093c0.019-0.007 0.037-0.014 0.055-0.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M18.396 13.971l-0.031 0.032-0.076-0.045-0.006-0.014 0.011-0.011 0.087-0.008c0.006 0.015 0.010 0.030 0.015 0.046zM18.167 13.921l0.016 0.042 0.087-0.009 0.011-0.011-0.006-0.015-0.076-0.044c-0.011 0.012-0.021 0.024-0.032 0.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M18.469 13.976l0.007 0.045 0.087 0.010 0.013-0.008-0.003-0.015-0.065-0.059-0.038 0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M18.469 13.976l0.007 0.045 0.087 0.010 0.013-0.008-0.003-0.015-0.065-0.059c-0.013 0.009-0.026 0.018-0.038 0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M17.938 13.907c0-0.018 0.013-0.032 0.030-0.032s0.030 0.014 0.030 0.032c0 0.017-0.014 0.031-0.030 0.031s-0.030-0.014-0.030-0.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M17.938 13.907c0-0.018 0.013-0.032 0.030-0.032s0.030 0.014 0.030 0.032c0 0.017-0.014 0.031-0.030 0.031s-0.030-0.014-0.030-0.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M18.25 13.938c0-0.018 0.014-0.032 0.030-0.032s0.031 0.014 0.031 0.032c0 0.017-0.014 0.031-0.031 0.031s-0.030-0.014-0.030-0.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M18.25 13.938c0-0.018 0.014-0.032 0.030-0.032s0.031 0.014 0.031 0.032c0 0.017-0.014 0.031-0.031 0.031s-0.030-0.014-0.030-0.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M18.004 13.531v0.039h-0.088v-0.039h0.029v-0.088h-0.038v-0.039h0.038v-0.039h0.038v0.039h0.038v0.039h-0.038v0.088h0.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0044ad",
    style: {
      fill: "var(--color15, #0044ad)"
    },
    d: "M17.983 13.48c0.032 0.009 0.054 0.040 0.054 0.075 0 0.043-0.034 0.078-0.076 0.078s-0.076-0.035-0.076-0.078c0-0.036 0.024-0.067 0.056-0.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.33 14.024c-0.011-0.016-0.024-0.031-0.038-0.045-0.012-0.012-0.042-0.022-0.042-0.022 0-0.006 0.017-0.019 0.036-0.019 0.011 0 0.021 0.005 0.028 0.014l0.002-0.013c0 0 0.015 0.003 0.022 0.022s0.003 0.048 0.003 0.048c-0.002 0.006-0.008 0.011-0.011 0.016v-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M17.327 14.016c0.007-0.008 0.022-0.006 0.033 0.004s0.014 0.025 0.007 0.034c-0.007 0.008-0.022 0.006-0.033-0.004s-0.014-0.026-0.007-0.034v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M18.583 14.028c0.001 0.001 0.023-0.033 0.041-0.049 0.012-0.012 0.042-0.022 0.042-0.022 0-0.006-0.017-0.019-0.036-0.019-0.011 0-0.021 0.005-0.028 0.014l-0.002-0.013c0 0-0.015 0.003-0.022 0.022s-0.003 0.048-0.003 0.048 0.003 0.013 0.008 0.020z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M18.583 14.028c0.001 0.001 0.023-0.033 0.041-0.049 0.012-0.012 0.042-0.022 0.042-0.022 0-0.006-0.017-0.019-0.036-0.019-0.011 0-0.021 0.005-0.028 0.014l-0.002-0.013c0 0-0.015 0.003-0.022 0.022s-0.003 0.048-0.003 0.048c-0 0.008 0.003 0.011 0.008 0.020z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M18.586 14.016c-0.007-0.008-0.022-0.006-0.033 0.004s-0.014 0.025-0.007 0.034c0.007 0.008 0.022 0.006 0.033-0.004s0.014-0.026 0.007-0.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M18.586 14.016c-0.007-0.008-0.022-0.006-0.033 0.004s-0.014 0.025-0.007 0.034c0.007 0.008 0.022 0.006 0.033-0.004s0.014-0.026 0.007-0.034v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M18.043 13.531v0.039h-0.157v-0.039h0.058v-0.088h-0.038v-0.039h0.038v-0.039h0.038v0.039h0.038v0.039h-0.038v0.088h0.061z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M17.271 14.801h1.382v-0.395h-1.382v0.395z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.271 14.801h1.382v-0.395h-1.382v0.395z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M18.509 15.064c-0.009-0.004-0.015-0.004-0.026-0.004h-1.035c-0.010 0-0.020 0.002-0.029 0.006 0.036-0.013 0.061-0.048 0.061-0.089s-0.028-0.077-0.064-0.090c0.009 0.003 0.020 0.006 0.030 0.006h1.036c0.010 0 0.020-0 0.029-0.004l-0.006 0.001c-0.037 0.012-0.058 0.048-0.058 0.088 0 0.038 0.024 0.076 0.061 0.088z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M18.509 15.064c-0.009-0.004-0.015-0.004-0.026-0.004h-1.035c-0.010 0-0.020 0.002-0.029 0.006 0.036-0.013 0.061-0.048 0.061-0.089s-0.028-0.077-0.064-0.090c0.009 0.003 0.020 0.006 0.030 0.006h1.036c0.010 0 0.020-0 0.029-0.004l-0.006 0.001c-0.037 0.012-0.058 0.048-0.058 0.088 0 0.038 0.024 0.076 0.061 0.088z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M17.439 15.063h1.035c0.035 0 0.063 0.024 0.063 0.053s-0.028 0.053-0.063 0.053h-1.035c-0.035 0-0.064-0.024-0.064-0.053s0.028-0.053 0.064-0.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.439 15.063h1.035c0.035 0 0.063 0.024 0.063 0.053s-0.028 0.053-0.063 0.053h-1.035c-0.035 0-0.064-0.024-0.064-0.053s0.028-0.053 0.064-0.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M17.438 14.802h1.036c0.035 0 0.063 0.020 0.063 0.045s-0.028 0.045-0.063 0.045h-1.036c-0.035 0-0.063-0.020-0.063-0.045s0.028-0.045 0.063-0.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.438 14.802h1.036c0.035 0 0.063 0.020 0.063 0.045s-0.028 0.045-0.063 0.045h-1.036c-0.035 0-0.063-0.020-0.063-0.045s0.028-0.045 0.063-0.045v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M18.506 20.781c-0.003 0.014-0.008 0.027-0.008 0.042 0 0.099 0.078 0.178 0.174 0.178h-1.422c0.096 0 0.174-0.079 0.174-0.178 0-0.014-0.003-0.028-0.005-0.042 0.008 0.003 0.017 0.004 0.027 0.004h1.035c0.008 0 0.018-0.001 0.025-0.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M18.506 20.781c-0.003 0.014-0.008 0.027-0.008 0.042 0 0.099 0.078 0.178 0.174 0.178h-1.422c0.096 0 0.174-0.079 0.174-0.178 0-0.014-0.003-0.028-0.005-0.042 0.008 0.003 0.017 0.004 0.027 0.004h1.035c0.008 0 0.018-0.001 0.025-0.004h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M17.439 20.677h1.035c0.035 0 0.063 0.024 0.063 0.053s-0.028 0.053-0.063 0.053h-1.035c-0.035 0-0.064-0.024-0.064-0.053s0.028-0.053 0.064-0.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.439 20.677h1.035c0.035 0 0.063 0.024 0.063 0.053s-0.028 0.053-0.063 0.053h-1.035c-0.035 0-0.064-0.024-0.064-0.053s0.028-0.053 0.064-0.053v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M17.25 21.394h1.419v-0.394h-1.419v0.394z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.25 21.394h1.419v-0.394h-1.419v0.394z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    style: {
      fill: "var(--color9, #ce1126)"
    },
    d: "M18.78 19.281c0.14 0.088 0.236 0.179 0.221 0.224-0.008 0.042-0.052 0.072-0.116 0.119-0.1 0.076-0.161 0.212-0.114 0.275-0.083-0.073-0.135-0.182-0.135-0.303 0-0.127 0.055-0.241 0.144-0.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M18.78 19.281c0.14 0.088 0.236 0.179 0.221 0.224-0.008 0.042-0.052 0.072-0.116 0.119-0.1 0.076-0.161 0.212-0.114 0.275-0.083-0.073-0.135-0.182-0.135-0.303 0-0.127 0.055-0.241 0.144-0.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    style: {
      fill: "var(--color19, #b2b2b2)"
    },
    d: "M17.458 20.613h1.008v-5.384h-1.008v5.384z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    style: {
      fill: "var(--color9, #ce1126)"
    },
    d: "M16.427 17.242c0.22-0.099 0.594-0.173 1.023-0.188 0.148 0.001 0.313 0.016 0.483 0.047 0.603 0.11 1.062 0.372 1.026 0.586-0.001 0.005-0.002 0.014-0.003 0.018 0 0 0.226-0.555 0.229-0.576 0.040-0.237-0.469-0.529-1.138-0.65-0.21-0.038-0.415-0.053-0.593-0.051-0.428 0-0.8 0.060-1.025 0.15l-0.003 0.664z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M16.427 17.242c0.22-0.099 0.594-0.173 1.023-0.188 0.148 0.001 0.313 0.016 0.483 0.047 0.603 0.11 1.062 0.372 1.026 0.586-0.001 0.005-0.002 0.014-0.003 0.018 0 0 0.226-0.555 0.229-0.576 0.040-0.237-0.469-0.529-1.138-0.65-0.21-0.038-0.415-0.053-0.593-0.051-0.428 0-0.8 0.060-1.025 0.15l-0.003 0.664z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    style: {
      fill: "var(--color9, #ce1126)"
    },
    d: "M18.471 17.922c0.28-0.022 0.47-0.103 0.492-0.231 0.017-0.102-0.077-0.214-0.246-0.316-0.076 0.009-0.16 0.020-0.248 0.020l0.002 0.526z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M18.471 17.922c0.28-0.022 0.47-0.103 0.492-0.231 0.017-0.102-0.077-0.214-0.246-0.316-0.076 0.009-0.16 0.020-0.248 0.020l0.002 0.526z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    style: {
      fill: "var(--color9, #ce1126)"
    },
    d: "M17.454 17.51c-0.175 0.029-0.306 0.076-0.371 0.134l-0.006 0.012c-0.031 0.070 0.122 0.218 0.379 0.383l-0.001-0.529z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M17.454 17.51c-0.175 0.029-0.306 0.076-0.371 0.134l-0.006 0.012c-0.031 0.070 0.122 0.218 0.379 0.383l-0.001-0.529z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M19.097 18.961c0.026-0.087-0.246-0.261-0.631-0.415-0.176-0.069-0.321-0.14-0.502-0.227-0.535-0.258-0.93-0.554-0.882-0.662l0.005-0.011c-0.028 0.025-0.072 0.557-0.072 0.557-0.049 0.099 0.313 0.391 0.805 0.648 0.158 0.082 0.491 0.216 0.648 0.276 0.281 0.106 0.56 0.307 0.535 0.381l0.093-0.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M17.051 17.006c0.038-0.158 0.087-0.31 0.136-0.465-0.011 0.003-0.022 0.006-0.033 0.007s-0.023 0.003-0.034 0.003c-0.023 0.111-0.054 0.222-0.088 0.334-0.060-0.097-0.124-0.192-0.176-0.29-0.021 0.005-0.042 0.010-0.063 0.013s-0.043 0.005-0.064 0.007c0.090 0.131 0.177 0.263 0.26 0.4 0.010-0.003 0.020-0.006 0.031-0.008 0.010-0.001 0.020-0.001 0.031-0.002zM17.435 16.545c-0.018 0.001-0.037 0.002-0.055 0.002s-0.037-0.003-0.055-0.004l-0.007 0.434 0.278 0.005c-0.001-0.009-0.003-0.019-0.003-0.028s0.003-0.018 0.004-0.027c-0.050 0.004-0.104 0.007-0.168 0.006l0.007-0.388zM17.871 16.616c0.044 0.004 0.087 0.012 0.13 0.021-0.001-0.009-0.002-0.018-0.001-0.028s0.004-0.018 0.006-0.026l-0.377-0.034c0.001 0.009 0.002 0.018 0.001 0.027s-0.004 0.018-0.006 0.027c0.038-0.001 0.085-0.001 0.137 0.003l-0.033 0.39c0.018 0 0.037 0 0.055 0.002s0.037 0.005 0.055 0.008l0.033-0.39zM18.025 17.043c0.018 0.003 0.036 0.006 0.054 0.010s0.035 0.010 0.053 0.016l0.045-0.199 0.005 0.001c0.010 0.027 0.024 0.061 0.031 0.080l0.056 0.15c0.022 0.004 0.044 0.007 0.065 0.012s0.043 0.012 0.064 0.019l-0.019-0.045c-0.030-0.068-0.062-0.136-0.088-0.204 0.069 0.003 0.123-0.024 0.137-0.085 0.010-0.042-0.006-0.075-0.042-0.104-0.027-0.021-0.079-0.032-0.113-0.040l-0.152-0.036-0.095 0.426zM18.22 16.677c0.044 0.011 0.098 0.018 0.098 0.072-0 0.014-0.001 0.023-0.004 0.032-0.014 0.064-0.058 0.086-0.132 0.062l0.037-0.166zM18.742 17.173c-0.003 0.047-0.011 0.093-0.019 0.142 0.019 0.010 0.038 0.019 0.056 0.030s0.035 0.023 0.053 0.035l0.037-0.489c-0.009-0.004-0.017-0.008-0.025-0.013s-0.016-0.010-0.023-0.016l-0.395 0.274c0.010 0.006 0.021 0.011 0.031 0.017s0.019 0.013 0.029 0.019c0.033-0.030 0.068-0.055 0.108-0.088l0.148 0.089zM18.63 17.062l0.132-0.093-0.015 0.162-0.116-0.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    style: {
      fill: "var(--color20, #005bbf)"
    },
    d: "M16.99 21.447c0.096 0 0.181-0.022 0.244-0.058 0.062-0.035 0.147-0.056 0.24-0.056s0.18 0.021 0.242 0.056c0.062 0.036 0.149 0.058 0.243 0.058s0.181-0.024 0.244-0.061c0.062-0.033 0.144-0.053 0.235-0.053 0.094 0 0.177 0.019 0.239 0.055 0.063 0.036 0.15 0.059 0.245 0.059v0.163c-0.095 0-0.183-0.024-0.245-0.060-0.063-0.035-0.146-0.055-0.239-0.055-0.091 0-0.173 0.020-0.235 0.054-0.063 0.036-0.148 0.061-0.244 0.061-0.094 0-0.181-0.023-0.243-0.058s-0.149-0.057-0.242-0.057c-0.093 0-0.177 0.021-0.24 0.056-0.063 0.037-0.147 0.059-0.242 0.059l-0.001-0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0045af",
    style: {
      fill: "var(--color21, #0045af)"
    },
    d: "M16.99 21.447c0.096 0 0.181-0.022 0.244-0.058 0.062-0.035 0.147-0.056 0.24-0.056s0.18 0.021 0.242 0.056c0.062 0.036 0.149 0.058 0.243 0.058s0.181-0.024 0.244-0.061c0.062-0.033 0.144-0.053 0.235-0.053 0.094 0 0.177 0.019 0.239 0.055 0.063 0.036 0.15 0.059 0.245 0.059v0.163c-0.095 0-0.183-0.024-0.245-0.060-0.063-0.035-0.146-0.055-0.239-0.055-0.091 0-0.173 0.020-0.235 0.054-0.063 0.036-0.148 0.061-0.244 0.061-0.094 0-0.181-0.023-0.243-0.058s-0.149-0.057-0.242-0.057c-0.093 0-0.177 0.021-0.24 0.056-0.063 0.037-0.147 0.059-0.242 0.059l-0.001-0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    style: {
      fill: "var(--color19, #b2b2b2)"
    },
    d: "M16.99 21.615c0.096 0 0.181-0.022 0.244-0.059 0.062-0.035 0.147-0.056 0.24-0.056s0.18 0.021 0.242 0.057c0.062 0.036 0.149 0.058 0.243 0.058s0.181-0.025 0.244-0.061c0.062-0.033 0.144-0.054 0.235-0.054 0.094 0 0.177 0.020 0.239 0.055s0.15 0.060 0.245 0.060v0.163c-0.095 0-0.183-0.023-0.245-0.059s-0.146-0.055-0.239-0.055c-0.091 0-0.173 0.020-0.235 0.054-0.063 0.036-0.148 0.061-0.244 0.061-0.094 0-0.181-0.023-0.243-0.058s-0.149-0.056-0.242-0.056c-0.093 0-0.177 0.021-0.24 0.056-0.063 0.036-0.147 0.058-0.242 0.058l-0.001-0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    style: {
      fill: "var(--color20, #005bbf)"
    },
    d: "M16.99 21.771c0.096 0 0.181-0.022 0.244-0.058 0.062-0.035 0.147-0.056 0.24-0.056s0.18 0.021 0.242 0.056c0.062 0.036 0.149 0.058 0.243 0.058s0.181-0.024 0.244-0.061c0.062-0.033 0.144-0.054 0.235-0.054 0.094 0 0.177 0.020 0.239 0.055s0.15 0.059 0.245 0.059v0.163c-0.095 0-0.183-0.023-0.245-0.059-0.063-0.035-0.146-0.055-0.239-0.055-0.091 0-0.173 0.020-0.235 0.053-0.063 0.036-0.148 0.061-0.244 0.061-0.094 0-0.181-0.022-0.243-0.058s-0.149-0.056-0.242-0.056c-0.093 0-0.177 0.021-0.24 0.056-0.063 0.037-0.147 0.058-0.242 0.058l-0.001-0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0045af",
    style: {
      fill: "var(--color21, #0045af)"
    },
    d: "M16.99 21.771c0.096 0 0.181-0.022 0.244-0.058 0.062-0.035 0.147-0.056 0.24-0.056s0.18 0.021 0.242 0.056c0.062 0.036 0.149 0.058 0.243 0.058s0.181-0.024 0.244-0.061c0.062-0.033 0.144-0.054 0.235-0.054 0.094 0 0.177 0.020 0.239 0.055s0.15 0.059 0.245 0.059v0.163c-0.095 0-0.183-0.023-0.245-0.059-0.063-0.035-0.146-0.055-0.239-0.055-0.091 0-0.173 0.020-0.235 0.053-0.063 0.036-0.148 0.061-0.244 0.061-0.094 0-0.181-0.022-0.243-0.058s-0.149-0.056-0.242-0.056c-0.093 0-0.177 0.021-0.24 0.056-0.063 0.037-0.147 0.058-0.242 0.058l-0.001-0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    style: {
      fill: "var(--color19, #b2b2b2)"
    },
    d: "M16.991 22.1c0.096 0 0.179-0.022 0.242-0.059 0.062-0.035 0.147-0.056 0.24-0.056s0.18 0.021 0.242 0.056c0.062 0.036 0.149 0.058 0.243 0.058s0.181-0.024 0.244-0.061c0.062-0.033 0.144-0.053 0.235-0.053 0.094 0 0.177 0.020 0.239 0.055 0.063 0.036 0.15 0.060 0.245 0.060v-0.162c-0.095 0-0.183-0.024-0.245-0.061-0.063-0.035-0.146-0.055-0.239-0.055-0.091 0-0.173 0.020-0.235 0.053-0.063 0.037-0.148 0.061-0.244 0.061-0.094 0-0.181-0.022-0.243-0.058s-0.149-0.056-0.242-0.056c-0.093 0-0.177 0.021-0.24 0.056-0.063 0.037-0.148 0.058-0.244 0.058l0.001 0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    style: {
      fill: "var(--color20, #005bbf)"
    },
    d: "M16.991 22.267c0.096 0 0.179-0.022 0.242-0.058 0.062-0.035 0.147-0.056 0.24-0.056s0.18 0.022 0.242 0.057c0.062 0.036 0.149 0.058 0.243 0.058s0.181-0.025 0.244-0.061c0.062-0.033 0.144-0.054 0.235-0.054 0.094 0 0.177 0.020 0.239 0.055s0.15 0.060 0.245 0.060v-0.162c-0.095 0-0.183-0.025-0.245-0.061-0.063-0.035-0.146-0.054-0.239-0.054-0.091 0-0.173 0.020-0.235 0.053-0.063 0.036-0.148 0.061-0.244 0.061-0.094 0-0.181-0.023-0.243-0.058s-0.149-0.056-0.242-0.056c-0.093 0-0.177 0.021-0.24 0.056-0.063 0.036-0.148 0.058-0.243 0.058l0.001 0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0045af",
    style: {
      fill: "var(--color21, #0045af)"
    },
    d: "M16.991 22.267c0.096 0 0.179-0.022 0.242-0.058 0.062-0.035 0.147-0.056 0.24-0.056s0.18 0.022 0.242 0.057c0.062 0.036 0.149 0.058 0.243 0.058s0.181-0.025 0.244-0.061c0.062-0.033 0.144-0.054 0.235-0.054 0.094 0 0.177 0.020 0.239 0.055s0.15 0.060 0.245 0.060v-0.162c-0.095 0-0.183-0.025-0.245-0.061-0.063-0.035-0.146-0.054-0.239-0.054-0.091 0-0.173 0.020-0.235 0.053-0.063 0.036-0.148 0.061-0.244 0.061-0.094 0-0.181-0.023-0.243-0.058s-0.149-0.056-0.242-0.056c-0.093 0-0.177 0.021-0.24 0.056-0.063 0.036-0.148 0.058-0.243 0.058l0.001 0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    style: {
      fill: "var(--color9, #ce1126)"
    },
    d: "M8.24 14.119c0 0-0.032 0-0.049-0.011s-0.070-0.065-0.070-0.065l-0.042-0.033-0.038-0.058c0 0-0.046-0.079-0.025-0.141s0.056-0.083 0.088-0.101c0.032-0.018 0.098-0.040 0.098-0.040s0.053-0.025 0.070-0.029c0.017-0.004 0.081-0.022 0.081-0.022s0.018-0.011 0.035-0.018c0.018-0.007 0.042-0.007 0.056-0.011s0.049-0.016 0.070-0.017c0.033-0.001 0.084 0.006 0.102 0.006s0.077 0.004 0.101 0.004 0.112-0.007 0.137-0.007c0.024 0 0.042-0.003 0.070 0s0.077 0.022 0.091 0.029c0.014 0.007 0.098 0.040 0.13 0.051s0.109 0.025 0.144 0.043c0.035 0.018 0.056 0.049 0.074 0.074s0.021 0.053 0.028 0.071c0.007 0.018 0.007 0.057 0 0.075s-0.032 0.055-0.032 0.055l-0.039 0.069-0.049 0.043c0 0-0.035 0.036-0.063 0.033s-0.312-0.058-0.494-0.058c-0.182 0-0.473 0.058-0.473 0.058z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M8.24 14.119c0 0-0.032 0-0.049-0.011s-0.070-0.065-0.070-0.065l-0.042-0.033-0.038-0.058c0 0-0.046-0.079-0.025-0.141s0.056-0.083 0.088-0.101c0.032-0.018 0.098-0.040 0.098-0.040s0.053-0.025 0.070-0.029c0.017-0.004 0.081-0.022 0.081-0.022s0.018-0.011 0.035-0.018c0.018-0.007 0.042-0.007 0.056-0.011s0.049-0.016 0.070-0.017c0.033-0.001 0.084 0.006 0.102 0.006s0.077 0.004 0.101 0.004 0.112-0.007 0.137-0.007c0.024 0 0.042-0.003 0.070 0s0.077 0.022 0.091 0.029c0.014 0.007 0.098 0.040 0.13 0.051s0.109 0.025 0.144 0.043c0.035 0.018 0.056 0.049 0.074 0.074s0.021 0.053 0.028 0.071c0.007 0.018 0.007 0.057 0 0.075s-0.032 0.055-0.032 0.055l-0.039 0.069-0.049 0.043c0 0-0.035 0.036-0.063 0.033s-0.312-0.058-0.494-0.058c-0.182 0-0.473 0.058-0.473 0.058h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.635 13.669c0-0.093 0.038-0.169 0.086-0.169s0.086 0.075 0.086 0.169c0 0.093-0.038 0.169-0.086 0.169s-0.086-0.076-0.086-0.169z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.677 13.676c0-0.086 0.018-0.156 0.039-0.156s0.039 0.070 0.039 0.156c0 0.085-0.017 0.155-0.039 0.155s-0.039-0.070-0.039-0.155z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.715 14.109h-0.298l-0.007-0.080-0.014-0.083-0.015-0.104c-0.082-0.118-0.158-0.196-0.183-0.179 0.006-0.022 0.013-0.038 0.029-0.048 0.073-0.047 0.224 0.066 0.337 0.253 0.010 0.017 0.020 0.034 0.029 0.051h0.246c0.009-0.017 0.019-0.034 0.029-0.051 0.113-0.187 0.264-0.3 0.337-0.253 0.016 0.010 0.023 0.026 0.029 0.048-0.026-0.016-0.101 0.061-0.183 0.179l-0.015 0.104-0.014 0.083-0.007 0.080h-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.276 14.251c-0.013-0.039-0.036-0.073-0.036-0.073 0.121-0.039 0.289-0.063 0.476-0.063s0.356 0.025 0.477 0.063c0 0-0.014 0.026-0.032 0.062-0.010 0.020-0.024 0.055-0.023 0.055-0.109-0.036-0.25-0.055-0.422-0.055s-0.339 0.023-0.425 0.058c0.001 0-0.006-0.022-0.015-0.046h0.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M8.711 14.419c0.151-0 0.317-0.025 0.378-0.042 0.041-0.013 0.065-0.033 0.060-0.056-0.002-0.011-0.011-0.021-0.023-0.026-0.090-0.031-0.252-0.054-0.416-0.054s-0.326 0.023-0.417 0.054c-0.012 0.006-0.021 0.015-0.023 0.026-0.005 0.023 0.019 0.043 0.061 0.056 0.061 0.017 0.228 0.042 0.379 0.042z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.711 14.419c0.151-0 0.317-0.025 0.378-0.042 0.041-0.013 0.065-0.033 0.060-0.056-0.002-0.011-0.011-0.021-0.023-0.026-0.090-0.031-0.252-0.054-0.416-0.054s-0.326 0.023-0.417 0.054c-0.012 0.006-0.021 0.015-0.023 0.026-0.005 0.023 0.019 0.043 0.061 0.056 0.061 0.017 0.228 0.042 0.379 0.042z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M9.202 14.1l-0.037-0.036c0 0-0.035 0.023-0.079 0.016s-0.058-0.065-0.058-0.065-0.049 0.045-0.089 0.042c-0.040-0.004-0.066-0.042-0.066-0.042s-0.044 0.034-0.083 0.031c-0.039-0.004-0.075-0.056-0.075-0.056s-0.039 0.054-0.077 0.058c-0.039 0.003-0.070-0.036-0.070-0.036s-0.018 0.040-0.067 0.049c-0.049 0.009-0.091-0.042-0.091-0.042s-0.028 0.049-0.061 0.062c-0.033 0.013-0.077-0.018-0.077-0.018s-0.007 0.018-0.012 0.029c-0.005 0.011-0.019 0.013-0.019 0.013l0.011 0.032c0.12-0.038 0.283-0.061 0.467-0.062s0.352 0.024 0.472 0.062l0.012-0.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.716 13.927l0.017 0.003c-0.003 0.008-0.003 0.016-0.003 0.025 0 0.039 0.031 0.071 0.069 0.071 0.031 0 0.057-0.021 0.066-0.049 0.001 0.001 0.007-0.026 0.009-0.025s0.002 0.028 0.003 0.027c0.005 0.036 0.035 0.060 0.069 0.060 0.038 0 0.069-0.032 0.069-0.071 0-0.003-0-0.006-0.001-0.009l0.022-0.024 0.012 0.030c-0.005 0.009-0.006 0.020-0.006 0.031 0 0.038 0.030 0.068 0.066 0.068 0.023 0 0.043-0.012 0.055-0.030l0.014-0.019-0 0.024c0 0.024 0.009 0.045 0.030 0.048 0 0 0.024 0.002 0.057-0.026s0.050-0.051 0.050-0.051l0.002 0.028c0 0-0.032 0.057-0.060 0.075-0.016 0.010-0.040 0.021-0.059 0.017-0.020-0.003-0.034-0.021-0.042-0.041-0.015 0.010-0.032 0.015-0.050 0.015-0.039 0-0.074-0.024-0.088-0.058-0.018 0.021-0.043 0.034-0.072 0.034-0.031 0-0.060-0.015-0.078-0.039-0.018 0.018-0.042 0.029-0.068 0.029-0.034 0-0.065-0.019-0.083-0.046-0.018 0.028-0.048 0.046-0.083 0.046-0.025 0-0.049-0.010-0.068-0.029-0.018 0.024-0.046 0.039-0.078 0.039-0.029 0-0.054-0.013-0.072-0.034-0.014 0.035-0.049 0.058-0.088 0.058-0.017 0-0.034-0.005-0.049-0.015-0.007 0.020-0.022 0.038-0.042 0.041-0.019 0.004-0.043-0.007-0.059-0.017-0.029-0.018-0.063-0.075-0.063-0.075l0.004-0.028c0 0 0.018 0.023 0.050 0.051s0.057 0.026 0.057 0.026c0.021-0.004 0.030-0.025 0.030-0.048v-0.024l0.014 0.019c0.006 0.009 0.014 0.017 0.024 0.022s0.020 0.008 0.031 0.008c0.037 0 0.066-0.030 0.066-0.068 0-0.011-0.002-0.022-0.006-0.031l0.012-0.030 0.022 0.024c-0 0.003-0 0.006-0 0.009 0 0.039 0.031 0.071 0.069 0.071 0.034 0 0.064-0.024 0.069-0.060 0.001 0 0.001-0.027 0.003-0.027s0.009 0.026 0.010 0.025c0.009 0.029 0.035 0.049 0.066 0.049 0.038 0 0.069-0.032 0.069-0.071 0-0.009-0-0.017-0.003-0.025l0.018-0.003h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M8.716 14.119c-0.187 0-0.355 0.024-0.476 0.063-0.008 0.003-0.018-0.004-0.021-0.012s0.003-0.019 0.011-0.022c0.121-0.040 0.294-0.066 0.485-0.066s0.364 0.026 0.486 0.066c0.008 0.003 0.014 0.013 0.011 0.022s-0.013 0.015-0.021 0.012c-0.121-0.039-0.289-0.063-0.476-0.063z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.716 14.119c-0.187 0-0.355 0.024-0.476 0.063-0.008 0.003-0.018-0.004-0.021-0.012s0.003-0.019 0.011-0.022c0.121-0.040 0.294-0.066 0.485-0.066s0.364 0.026 0.486 0.066c0.008 0.003 0.014 0.013 0.011 0.022s-0.013 0.015-0.021 0.012c-0.121-0.039-0.289-0.063-0.476-0.063z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M8.531 14.184c0-0.015 0.012-0.028 0.027-0.028s0.027 0.013 0.027 0.028c0 0.016-0.012 0.028-0.027 0.028s-0.027-0.012-0.027-0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M8.531 14.184c0-0.015 0.012-0.028 0.027-0.028s0.027 0.013 0.027 0.028c0 0.016-0.012 0.028-0.027 0.028s-0.027-0.012-0.027-0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    style: {
      fill: "var(--color9, #ce1126)"
    },
    d: "M8.716 14.198h-0.060c-0.011 0-0.020-0.010-0.020-0.021s0.009-0.021 0.020-0.021h0.122c0.011 0 0.020 0.009 0.020 0.021s-0.009 0.021-0.020 0.021h-0.061z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M8.716 14.198h-0.060c-0.011 0-0.020-0.010-0.020-0.021s0.009-0.021 0.020-0.021h0.122c0.011 0 0.020 0.009 0.020 0.021s-0.009 0.021-0.020 0.021h-0.061z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006f46",
    style: {
      fill: "var(--color14, #006f46)"
    },
    d: "M8.41 14.226l-0.043 0.007c-0.011 0.002-0.021-0.006-0.023-0.018s0.006-0.022 0.017-0.024l0.043-0.007 0.044-0.007c0.011-0.001 0.021 0.006 0.023 0.017s-0.006 0.022-0.017 0.024l-0.044 0.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    style: {
      fill: "var(--color9, #ce1126)"
    },
    d: "M8.24 14.252l0.019-0.034 0.041 0.008-0.024 0.038-0.036-0.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M8.24 14.252l0.019-0.034 0.041 0.008-0.024 0.038-0.036-0.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M8.844 14.184c0-0.015 0.012-0.028 0.027-0.028s0.027 0.013 0.027 0.028c0 0.016-0.012 0.028-0.027 0.028s-0.027-0.012-0.027-0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M8.844 14.184c0-0.015 0.012-0.028 0.027-0.028s0.027 0.013 0.027 0.028c0 0.016-0.012 0.028-0.027 0.028s-0.027-0.012-0.027-0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006f46",
    style: {
      fill: "var(--color14, #006f46)"
    },
    d: "M9.009 14.226l0.043 0.007c0.011 0.002 0.021-0.006 0.023-0.018s-0.006-0.022-0.016-0.024l-0.043-0.007-0.044-0.007c-0.011-0.001-0.021 0.006-0.023 0.017s0.006 0.022 0.017 0.024l0.044 0.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    style: {
      fill: "var(--color9, #ce1126)"
    },
    d: "M9.182 14.254l-0.015-0.036-0.042 0.004 0.020 0.040 0.037-0.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M9.181 14.252l-0.014-0.034-0.042 0.004 0.020 0.040c0.013-0.003 0.025-0.008 0.036-0.010z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    style: {
      fill: "var(--color9, #ce1126)"
    },
    d: "M8.714 14.383c-0.151-0-0.287-0.015-0.391-0.044 0.104-0.029 0.241-0.047 0.391-0.047s0.288 0.018 0.392 0.047c-0.104 0.029-0.241 0.044-0.392 0.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M8.714 14.383c-0.151-0-0.287-0.015-0.391-0.044 0.104-0.029 0.241-0.047 0.391-0.047s0.288 0.018 0.392 0.047c-0.104 0.029-0.241 0.044-0.392 0.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M9.188 14.018c0.004-0.013 0-0.025-0.008-0.028s-0.018 0.006-0.022 0.018c-0.004 0.013-0.001 0.026 0.008 0.029s0.019-0.005 0.023-0.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M9.188 14.018c0.004-0.013 0-0.025-0.008-0.028s-0.018 0.006-0.022 0.018c-0.004 0.013-0.001 0.026 0.008 0.029s0.019-0.005 0.023-0.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M8.886 13.964c0.002-0.013-0.004-0.025-0.013-0.026s-0.017 0.009-0.019 0.022c-0.002 0.013 0.004 0.025 0.013 0.026s0.017-0.009 0.019-0.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M8.886 13.964c0.002-0.013-0.004-0.025-0.013-0.026s-0.017 0.009-0.019 0.022c-0.002 0.013 0.004 0.025 0.013 0.026s0.017-0.009 0.019-0.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M8.542 13.964c-0.002-0.013 0.004-0.025 0.013-0.026s0.017 0.009 0.019 0.022c0.001 0.013-0.004 0.025-0.013 0.026s-0.017-0.009-0.019-0.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M8.542 13.964c-0.002-0.013 0.004-0.025 0.013-0.026s0.017 0.009 0.019 0.022c0.001 0.013-0.004 0.025-0.013 0.026s-0.017-0.009-0.019-0.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M8.241 14.018c-0.004-0.013-0-0.025 0.008-0.028s0.019 0.006 0.023 0.018c0.004 0.013 0 0.026-0.008 0.029s-0.019-0.005-0.023-0.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    style: {
      fill: "var(--color17, #e6e6e6)"
    },
    d: "M8.241 14.018c-0.004-0.013-0-0.025 0.008-0.028s0.019 0.006 0.023 0.018c0.004 0.013 0 0.026-0.008 0.029s-0.019-0.005-0.023-0.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.709 13.771l-0.053 0.035 0.040 0.093 0.014 0.010 0.014-0.010 0.040-0.093c-0.018-0.012-0.035-0.024-0.053-0.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.594 13.912l0.024 0.038 0.083-0.028 0.009-0.013-0.009-0.013-0.083-0.026c-0.009 0.014-0.017 0.027-0.024 0.042zM8.828 13.912l-0.024 0.038-0.083-0.028-0.009-0.013 0.009-0.013 0.083-0.026c0.008 0.014 0.016 0.028 0.024 0.042zM8.365 13.813l-0.042 0.043 0.053 0.077 0.014 0.006 0.011-0.012 0.019-0.093c-0.018-0.007-0.037-0.014-0.055-0.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.284 13.971l0.031 0.032 0.076-0.045 0.006-0.014-0.011-0.011-0.087-0.008c-0.006 0.015-0.010 0.030-0.015 0.046zM8.513 13.921l-0.016 0.042-0.087-0.009-0.011-0.011 0.006-0.015 0.076-0.044c0.011 0.011 0.022 0.023 0.032 0.035zM8.201 13.983l-0.007 0.045-0.087 0.010-0.013-0.008 0.003-0.015 0.065-0.059c0.013 0.010 0.026 0.019 0.039 0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M8.365 13.938c0-0.018 0.014-0.032 0.030-0.032s0.030 0.014 0.030 0.032c0 0.017-0.014 0.031-0.030 0.031s-0.030-0.014-0.030-0.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M8.365 13.938c0-0.018 0.014-0.032 0.030-0.032s0.030 0.014 0.030 0.032c0 0.017-0.014 0.031-0.030 0.031s-0.030-0.014-0.030-0.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M9.066 13.813l0.042 0.043-0.053 0.077-0.014 0.006-0.010-0.012-0.019-0.093c0.019-0.007 0.037-0.014 0.055-0.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M9.146 13.971l-0.031 0.032-0.076-0.045-0.006-0.014 0.011-0.011 0.087-0.008c0.006 0.015 0.010 0.030 0.015 0.046zM8.917 13.921l0.016 0.042 0.087-0.009 0.011-0.011-0.006-0.015-0.076-0.044c-0.011 0.012-0.021 0.024-0.032 0.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M9.219 13.976l0.007 0.045 0.087 0.010 0.013-0.008-0.003-0.015-0.065-0.059-0.038 0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M9.219 13.976l0.007 0.045 0.087 0.010 0.013-0.008-0.003-0.015-0.065-0.059c-0.013 0.009-0.026 0.018-0.038 0.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M8.688 13.907c0-0.018 0.013-0.032 0.030-0.032s0.030 0.014 0.030 0.032c0 0.017-0.014 0.031-0.030 0.031s-0.030-0.014-0.030-0.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M8.688 13.907c0-0.018 0.013-0.032 0.030-0.032s0.030 0.014 0.030 0.032c0 0.017-0.014 0.031-0.030 0.031s-0.030-0.014-0.030-0.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M9 13.938c0-0.018 0.014-0.032 0.030-0.032s0.031 0.014 0.031 0.032c0 0.017-0.014 0.031-0.031 0.031s-0.030-0.014-0.030-0.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M9 13.938c0-0.018 0.014-0.032 0.030-0.032s0.031 0.014 0.031 0.032c0 0.017-0.014 0.031-0.031 0.031s-0.030-0.014-0.030-0.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.080 14.024c-0.011-0.016-0.024-0.031-0.038-0.045-0.012-0.012-0.042-0.022-0.042-0.022 0-0.006 0.017-0.019 0.036-0.019 0.011 0 0.021 0.005 0.028 0.014l0.002-0.013c0 0 0.015 0.003 0.022 0.022s0.003 0.048 0.003 0.048c-0.002 0.006-0.008 0.011-0.011 0.016v-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M8.077 14.016c0.007-0.008 0.022-0.006 0.033 0.004s0.014 0.025 0.007 0.034c-0.007 0.008-0.022 0.006-0.033-0.004s-0.014-0.026-0.007-0.034v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M9.343 14.028c0.001 0.001 0.023-0.033 0.041-0.049 0.012-0.012 0.042-0.022 0.042-0.022 0-0.006-0.017-0.019-0.036-0.019-0.011 0-0.021 0.005-0.028 0.014l-0.002-0.013c0 0-0.015 0.003-0.022 0.022s-0.003 0.048-0.003 0.048 0.003 0.013 0.008 0.020z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M9.343 14.028c0.001 0.001 0.023-0.033 0.041-0.049 0.012-0.012 0.042-0.022 0.042-0.022 0-0.006-0.017-0.019-0.036-0.019-0.011 0-0.021 0.005-0.028 0.014l-0.002-0.013c0 0-0.015 0.003-0.022 0.022s-0.003 0.048-0.003 0.048c-0 0.008 0.003 0.011 0.008 0.020z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M9.336 14.016c-0.007-0.008-0.022-0.006-0.033 0.004s-0.014 0.025-0.007 0.034c0.007 0.008 0.022 0.006 0.033-0.004s0.014-0.026 0.007-0.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M9.336 14.016c-0.007-0.008-0.022-0.006-0.033 0.004s-0.014 0.025-0.007 0.034c0.007 0.008 0.022 0.006 0.033-0.004s0.014-0.026 0.007-0.034v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0044ad",
    style: {
      fill: "var(--color15, #0044ad)"
    },
    d: "M8.733 13.396c0.031 0.009 0.054 0.040 0.054 0.075 0 0.043-0.034 0.078-0.076 0.078s-0.076-0.035-0.076-0.078c0-0.036 0.024-0.067 0.056-0.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.793 13.448v0.039h-0.157v-0.039h0.058v-0.088h-0.038v-0.039h0.038v-0.039h0.038v0.039h0.038v0.039h-0.038v0.088h0.061z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.021 14.801h1.382v-0.395h-1.382v0.395z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M8.16 15.064c0.009-0.004 0.015-0.004 0.026-0.004h1.035c0.010 0 0.020 0.002 0.028 0.006-0.035-0.013-0.061-0.048-0.061-0.089s0.028-0.077 0.063-0.090c-0.008 0.003-0.020 0.006-0.030 0.006h-1.036c-0.011 0-0.021-0-0.029-0.004l0.006 0.001c0.037 0.012 0.058 0.048 0.058 0.088 0 0.038-0.023 0.076-0.060 0.088z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.16 15.064c0.009-0.004 0.015-0.004 0.026-0.004h1.035c0.010 0 0.020 0.002 0.028 0.006-0.035-0.013-0.061-0.048-0.061-0.089s0.028-0.077 0.063-0.090c-0.008 0.003-0.020 0.006-0.030 0.006h-1.036c-0.011 0-0.021-0-0.029-0.004l0.006 0.001c0.037 0.012 0.058 0.048 0.058 0.088 0 0.038-0.023 0.076-0.060 0.088z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.188 15.063h1.035c0.035 0 0.063 0.024 0.063 0.053s-0.028 0.053-0.063 0.053h-1.035c-0.035 0-0.063-0.024-0.063-0.053s0.028-0.053 0.063-0.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M8.188 14.802h1.036c0.035 0 0.064 0.020 0.064 0.045s-0.029 0.045-0.064 0.045h-1.036c-0.035 0-0.063-0.020-0.063-0.045s0.028-0.045 0.063-0.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.188 14.802h1.036c0.035 0 0.064 0.020 0.064 0.045s-0.029 0.045-0.064 0.045h-1.036c-0.035 0-0.063-0.020-0.063-0.045s0.028-0.045 0.063-0.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M8.166 20.781c0.003 0.014 0.008 0.027 0.008 0.042 0 0.099-0.078 0.178-0.174 0.178h1.423c-0.096 0-0.174-0.079-0.174-0.178 0-0.014 0.003-0.028 0.006-0.042-0.008 0.003-0.018 0.004-0.027 0.004h-1.035c-0.008 0-0.018-0.001-0.026-0.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.166 20.781c0.003 0.014 0.008 0.027 0.008 0.042 0 0.099-0.078 0.178-0.174 0.178h1.423c-0.096 0-0.174-0.079-0.174-0.178 0-0.014 0.003-0.028 0.006-0.042-0.008 0.003-0.018 0.004-0.027 0.004h-1.035c-0.008 0-0.018-0.001-0.026-0.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M8.188 20.677h1.035c0.035 0 0.063 0.024 0.063 0.053s-0.028 0.053-0.063 0.053h-1.035c-0.035 0-0.063-0.024-0.063-0.053s0.028-0.053 0.063-0.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.188 20.677h1.035c0.035 0 0.063 0.024 0.063 0.053s-0.028 0.053-0.063 0.053h-1.035c-0.035 0-0.063-0.024-0.063-0.053s0.028-0.053 0.063-0.053v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8 21.394h1.419v-0.394h-1.419v0.394z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    style: {
      fill: "var(--color9, #ce1126)"
    },
    d: "M7.888 19.281c-0.14 0.088-0.236 0.179-0.22 0.224 0.008 0.042 0.052 0.072 0.116 0.119 0.1 0.076 0.161 0.212 0.113 0.275 0.083-0.073 0.136-0.182 0.136-0.303 0-0.127-0.055-0.241-0.145-0.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M7.888 19.281c-0.14 0.088-0.236 0.179-0.22 0.224 0.008 0.042 0.052 0.072 0.116 0.119 0.1 0.076 0.161 0.212 0.113 0.275 0.083-0.073 0.136-0.182 0.136-0.303 0-0.127-0.055-0.241-0.145-0.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    style: {
      fill: "var(--color19, #b2b2b2)"
    },
    d: "M8.198 20.613h1.008v-5.384h-1.008v5.384z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M10.24 17.242c-0.22-0.099-0.594-0.173-1.023-0.188-0.148 0.001-0.313 0.016-0.483 0.047-0.603 0.11-1.062 0.372-1.026 0.586 0.001 0.005 0.002 0.014 0.003 0.018 0 0-0.226-0.555-0.23-0.576-0.040-0.237 0.469-0.529 1.139-0.65 0.21-0.038 0.415-0.053 0.593-0.051 0.428 0 0.8 0.060 1.024 0.15l0.003 0.664z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    style: {
      fill: "var(--color9, #ce1126)"
    },
    d: "M8.203 17.922c-0.28-0.022-0.47-0.103-0.492-0.231-0.017-0.102 0.077-0.214 0.246-0.316 0.075 0.009 0.16 0.020 0.248 0.020l-0.002 0.526z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M8.203 17.922c-0.28-0.022-0.47-0.103-0.492-0.231-0.017-0.102 0.077-0.214 0.246-0.316 0.075 0.009 0.16 0.020 0.248 0.020l-0.002 0.526z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    style: {
      fill: "var(--color9, #ce1126)"
    },
    d: "M9.21 17.51c0.175 0.029 0.306 0.076 0.371 0.134l0.006 0.012c0.031 0.070-0.122 0.218-0.379 0.383l0.002-0.529z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M9.21 17.51c0.175 0.029 0.306 0.076 0.371 0.134l0.006 0.012c0.031 0.070-0.122 0.218-0.379 0.383l0.002-0.529z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M7.575 18.961c-0.027-0.087 0.246-0.261 0.631-0.415 0.176-0.069 0.321-0.14 0.502-0.227 0.535-0.258 0.93-0.554 0.882-0.662l-0.005-0.011c0.029 0.025 0.073 0.557 0.073 0.557 0.049 0.099-0.313 0.391-0.806 0.648-0.158 0.082-0.491 0.216-0.648 0.276-0.281 0.106-0.561 0.307-0.535 0.381l-0.093-0.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M8.136 16.984c0.123-0.049 0.204-0.107 0.164-0.213-0.025-0.067-0.089-0.080-0.184-0.042l-0.169 0.067 0.152 0.408c0.016-0.008 0.033-0.017 0.050-0.024s0.035-0.012 0.052-0.017l-0.066-0.179v-0zM8.063 16.787l0.043-0.017c0.035-0.014 0.075 0.006 0.093 0.054 0.013 0.036 0.010 0.077-0.031 0.105-0.013 0.009-0.029 0.016-0.044 0.022l-0.061-0.164zM8.53 16.616c-0.018 0.005-0.035 0.011-0.053 0.015s-0.036 0.006-0.054 0.009l0.087 0.424 0.272-0.060c-0.003-0.008-0.007-0.017-0.009-0.026s-0.002-0.019-0.002-0.028c-0.048 0.015-0.1 0.031-0.162 0.045l-0.078-0.379zM9.074 16.982c0.051-0.154 0.113-0.301 0.175-0.451-0.011 0.002-0.023 0.004-0.034 0.004s-0.023 0.001-0.034 0c-0.033 0.108-0.073 0.217-0.116 0.324-0.051-0.102-0.108-0.202-0.151-0.305-0.021 0.003-0.043 0.006-0.064 0.008s-0.043 0.001-0.064 0.001c0.078 0.139 0.154 0.278 0.226 0.422 0.010-0.002 0.020-0.005 0.031-0.005s0.021 0 0.031 0.001zM9.643 16.655c0.009-0.021 0.019-0.041 0.030-0.060-0.015-0.015-0.059-0.037-0.112-0.043-0.111-0.012-0.175 0.042-0.182 0.115-0.016 0.153 0.206 0.139 0.195 0.241-0.004 0.044-0.047 0.061-0.092 0.057-0.050-0.006-0.087-0.036-0.094-0.081l-0.014-0.001c-0.007 0.027-0.018 0.052-0.029 0.078 0.032 0.023 0.074 0.036 0.115 0.040 0.113 0.012 0.199-0.037 0.207-0.118 0.015-0.145-0.209-0.153-0.2-0.239 0.004-0.036 0.029-0.060 0.087-0.053 0.041 0.005 0.067 0.029 0.078 0.064l0.011 0.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    style: {
      fill: "var(--color20, #005bbf)"
    },
    d: "M9.672 21.447c-0.096 0-0.181-0.022-0.243-0.058-0.062-0.035-0.147-0.056-0.24-0.056s-0.18 0.021-0.242 0.056c-0.063 0.036-0.149 0.058-0.243 0.058-0.096 0-0.181-0.024-0.243-0.061-0.062-0.033-0.145-0.053-0.235-0.053-0.094 0-0.177 0.019-0.239 0.055-0.063 0.036-0.15 0.059-0.245 0.059v0.163c0.095 0 0.182-0.024 0.245-0.060 0.062-0.035 0.146-0.055 0.239-0.055 0.090 0 0.173 0.020 0.235 0.054 0.063 0.036 0.148 0.061 0.243 0.061 0.094 0 0.181-0.023 0.243-0.058s0.149-0.057 0.242-0.057c0.093 0 0.177 0.021 0.24 0.056 0.063 0.037 0.146 0.059 0.242 0.059l0.001-0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0044ad",
    style: {
      fill: "var(--color15, #0044ad)"
    },
    d: "M9.672 21.447c-0.096 0-0.181-0.022-0.243-0.058-0.062-0.035-0.147-0.056-0.24-0.056s-0.18 0.021-0.242 0.056c-0.063 0.036-0.149 0.058-0.243 0.058-0.096 0-0.181-0.024-0.243-0.061-0.062-0.033-0.145-0.053-0.235-0.053-0.094 0-0.177 0.019-0.239 0.055-0.063 0.036-0.15 0.059-0.245 0.059v0.163c0.095 0 0.182-0.024 0.245-0.060 0.062-0.035 0.146-0.055 0.239-0.055 0.090 0 0.173 0.020 0.235 0.054 0.063 0.036 0.148 0.061 0.243 0.061 0.094 0 0.181-0.023 0.243-0.058s0.149-0.057 0.242-0.057c0.093 0 0.177 0.021 0.24 0.056 0.063 0.037 0.146 0.059 0.242 0.059l0.001-0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    style: {
      fill: "var(--color19, #b2b2b2)"
    },
    d: "M9.672 21.615c-0.096 0-0.181-0.022-0.243-0.059-0.062-0.035-0.147-0.056-0.24-0.056s-0.18 0.021-0.242 0.057c-0.063 0.036-0.149 0.058-0.243 0.058-0.096 0-0.181-0.025-0.243-0.061-0.062-0.033-0.145-0.054-0.235-0.054-0.094 0-0.177 0.020-0.239 0.055s-0.15 0.060-0.245 0.060v0.163c0.095 0 0.182-0.023 0.245-0.059s0.146-0.055 0.239-0.055c0.090 0 0.173 0.020 0.235 0.054 0.063 0.036 0.148 0.061 0.243 0.061 0.094 0 0.181-0.023 0.243-0.058s0.149-0.056 0.242-0.056c0.093 0 0.177 0.021 0.24 0.056 0.063 0.036 0.146 0.058 0.242 0.058l0.001-0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    style: {
      fill: "var(--color20, #005bbf)"
    },
    d: "M9.672 21.771c-0.096 0-0.181-0.022-0.243-0.058-0.062-0.035-0.147-0.056-0.24-0.056s-0.18 0.021-0.242 0.056c-0.063 0.036-0.149 0.058-0.243 0.058-0.096 0-0.181-0.024-0.243-0.061-0.062-0.033-0.145-0.054-0.235-0.054-0.094 0-0.177 0.020-0.239 0.055s-0.15 0.059-0.245 0.059v0.163c0.095 0 0.182-0.023 0.245-0.059 0.062-0.035 0.146-0.055 0.239-0.055 0.090 0 0.173 0.020 0.235 0.053 0.063 0.036 0.148 0.061 0.243 0.061 0.094 0 0.181-0.022 0.243-0.058s0.149-0.056 0.242-0.056c0.093 0 0.177 0.021 0.24 0.056 0.063 0.037 0.146 0.058 0.242 0.058l0.001-0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0044ad",
    style: {
      fill: "var(--color15, #0044ad)"
    },
    d: "M9.672 21.771c-0.096 0-0.181-0.022-0.243-0.058-0.062-0.035-0.147-0.056-0.24-0.056s-0.18 0.021-0.242 0.056c-0.063 0.036-0.149 0.058-0.243 0.058-0.096 0-0.181-0.024-0.243-0.061-0.062-0.033-0.145-0.054-0.235-0.054-0.094 0-0.177 0.020-0.239 0.055s-0.15 0.059-0.245 0.059v0.163c0.095 0 0.182-0.023 0.245-0.059 0.062-0.035 0.146-0.055 0.239-0.055 0.090 0 0.173 0.020 0.235 0.053 0.063 0.036 0.148 0.061 0.243 0.061 0.094 0 0.181-0.022 0.243-0.058s0.149-0.056 0.242-0.056c0.093 0 0.177 0.021 0.24 0.056 0.063 0.037 0.146 0.058 0.242 0.058l0.001-0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    style: {
      fill: "var(--color19, #b2b2b2)"
    },
    d: "M9.671 22.1c-0.096 0-0.18-0.022-0.242-0.059-0.062-0.035-0.147-0.056-0.24-0.056s-0.18 0.021-0.242 0.056c-0.063 0.036-0.149 0.058-0.243 0.058-0.096 0-0.181-0.024-0.243-0.061-0.062-0.033-0.145-0.053-0.235-0.053-0.094 0-0.177 0.020-0.239 0.055-0.063 0.036-0.15 0.060-0.245 0.060v-0.162c0.095 0 0.182-0.024 0.245-0.061 0.062-0.035 0.146-0.055 0.239-0.055 0.090 0 0.173 0.020 0.235 0.053 0.063 0.037 0.148 0.061 0.243 0.061 0.094 0 0.181-0.022 0.243-0.058s0.149-0.056 0.242-0.056c0.093 0 0.177 0.021 0.24 0.056 0.063 0.037 0.148 0.058 0.243 0.058l-0.001 0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    style: {
      fill: "var(--color20, #005bbf)"
    },
    d: "M9.671 22.267c-0.096 0-0.18-0.022-0.242-0.058-0.062-0.035-0.147-0.056-0.24-0.056s-0.18 0.022-0.242 0.057c-0.063 0.036-0.149 0.058-0.243 0.058-0.096 0-0.181-0.025-0.243-0.061-0.062-0.033-0.145-0.054-0.235-0.054-0.094 0-0.177 0.020-0.239 0.055s-0.15 0.060-0.245 0.060v-0.162c0.095 0 0.182-0.025 0.245-0.061 0.062-0.035 0.146-0.054 0.239-0.054 0.090 0 0.173 0.020 0.235 0.053 0.063 0.036 0.148 0.061 0.243 0.061 0.094 0 0.181-0.023 0.243-0.058s0.149-0.056 0.242-0.056c0.093 0 0.177 0.021 0.24 0.056 0.063 0.036 0.147 0.058 0.243 0.058l-0.001 0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0044ad",
    style: {
      fill: "var(--color15, #0044ad)"
    },
    d: "M9.671 22.267c-0.096 0-0.18-0.022-0.242-0.058-0.062-0.035-0.147-0.056-0.24-0.056s-0.18 0.022-0.242 0.057c-0.063 0.036-0.149 0.058-0.243 0.058-0.096 0-0.181-0.025-0.243-0.061-0.062-0.033-0.145-0.054-0.235-0.054-0.094 0-0.177 0.020-0.239 0.055s-0.15 0.060-0.245 0.060v-0.162c0.095 0 0.182-0.025 0.245-0.061 0.062-0.035 0.146-0.054 0.239-0.054 0.090 0 0.173 0.020 0.235 0.053 0.063 0.036 0.148 0.061 0.243 0.061 0.094 0 0.181-0.023 0.243-0.058s0.149-0.056 0.242-0.056c0.093 0 0.177 0.021 0.24 0.056 0.063 0.036 0.147 0.058 0.243 0.058l-0.001 0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    style: {
      fill: "var(--color19, #b2b2b2)"
    },
    d: "M13.349 22.376c-0.811 0-1.615-0.217-2.292-0.577-0.498-0.269-0.829-0.812-0.829-1.432v-2.251h6.228v2.251c0 0.621-0.33 1.163-0.829 1.432-0.676 0.361-1.468 0.577-2.279 0.577z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M13.332 20.359c0 0.89-0.692 1.611-1.553 1.611s-1.56-0.721-1.56-1.611v-2.255h3.114v2.255z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M10.906 21.684c0.097 0.056 0.231 0.15 0.374 0.188l-0.009-3.851h-0.365v3.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M10.219 20.327c0.009 0.475 0.183 0.828 0.356 1.060v-3.345h-0.351l-0.004 2.285z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.594 21.956c0.143 0.016 0.249 0.013 0.365 0v-3.935h-0.365v3.935zM12.279 21.872c0.143-0.031 0.304-0.128 0.374-0.178v-3.673h-0.365l-0.009 3.851zM12.992 21.347c0.152-0.147 0.295-0.481 0.346-0.863l0.009-2.463h-0.365l0.009 3.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M10.219 18.11h3.112v-3.766h-3.112v3.766z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b1100",
    style: {
      fill: "var(--color22, #2b1100)"
    },
    d: "M10.844 17.389v-0.274h0.271l-0.002-0.484-0.002-0.484-0.133-0.004v-0.143c0-0.079 0.002-0.188 0.004-0.243l0.004-0.099 0.030-0c0.016-0 0.060-0.002 0.096-0.004l0.066-0.004v-0.238h-0.124l0-0.080c0-0.044 0.002-0.108 0.004-0.142l0.004-0.062h0.11v0.028c0 0.030 0.005 0.035 0.035 0.035s0.035-0.005 0.035-0.035v-0.028h0.158l0.004 0.028c0.004 0.030 0.010 0.035 0.041 0.035 0.025 0 0.033-0.010 0.033-0.039v-0.024h0.112v0.283l-0.127 0.004-0.002 0.118-0.002 0.118h0.177v-0.586h-0.118v-0.284h0.118l-0.008 0.063h0.021c0.011 0 0.029-0.002 0.039-0.004 0.017-0.004 0.018-0.006 0.018-0.032v-0.028h0.153v0.027c0 0.034 0.008 0.042 0.039 0.042 0.029 0 0.035-0.006 0.041-0.043l0.004-0.027h0.111v0.284h-0.124v0.586h0.148l-0.003-0.236-0.115-0.004 0.001-0.115c0-0.063 0.002-0.129 0.004-0.146l0.004-0.032 0.109-0.004v0.030c0 0.036 0.007 0.046 0.033 0.046 0.031 0 0.037-0.005 0.041-0.038l0.004-0.031h0.046c0.025 0 0.058-0.002 0.073-0.004l0.027-0.004v0.077h0.035c0.039 0 0.046-0.005 0.049-0.037 0.002-0.025 0.008-0.027 0.071-0.034l0.040-0.004v0.289l-0.027 0.004c-0.015 0.002-0.043 0.004-0.062 0.004h-0.035v0.238l0.072 0.004c0.039 0.002 0.088 0.004 0.109 0.004h0.037v0.125c0 0.069 0.002 0.178 0.004 0.243l0.004 0.118-0.129 0.004v0.965l0.25 0.003v0.548h-1.879v-0.274z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.124 16.125v1.009l-0.26 0.001v0.519l1.827-0.003v-0.519l-0.251-0.001v-1.006h-1.316z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M10.865 17.652v0zM10.865 17.524v0zM10.865 17.396v0zM10.865 17.272v0zM10.866 17.133v0zM11.129 16.995v0zM11.125 16.863v0zM11.125 16.752v0zM11.125 16.626v0zM11.125 16.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M11.125 16.375v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M12.169 16.253v0zM11.125 16.25v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M11.125 17.647v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.126 17.397v0zM11.010 17.397v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M11.25 17.522v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.386 17.128v0zM11.388 16.861v0zM11.25 17.269v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M11.010 17.277v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.25 16.866v0zM11.512 16.866v0zM11.771 16.869v0zM11.639 16.87v0zM11.772 16.629v0zM11.642 16.251v0zM11.773 16.125v0zM11.512 16.125v0zM11.265 16.125v0zM12.436 17.652v0zM12.436 17.4v0zM12.552 17.4v0zM12.291 17.526v0zM12.166 17.132v0zM12.165 16.867v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M12.292 17.277v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M12.552 17.277v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M12.292 16.865v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M12.031 16.862v0zM11.906 16.864v0zM11.906 16.5v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M11.771 16.375v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.913 16.256v0zM12.038 16.136v0zM12.298 16.135v0zM11.646 16.633v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M12.033 17.652v-0.341c0-0.065-0.025-0.259-0.267-0.259-0.229 0-0.255 0.195-0.255 0.259v0.341h0.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.916 17.404l0.254 0.001-0-0.13-0.086-0.141-0.176 0.136c0.018 0.048 0.009 0.102 0.009 0.134zM11.851 17.203l0.057-0.201-0.262-0.002 0.061 0.199c0.048-0.010 0.097-0.009 0.145 0.004zM12.045 16.758v-0.297c0-0.081 0.046-0.148 0.127-0.148s0.127 0.067 0.127 0.148v0.297h-0.253z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.638 17.521h-0.252l-0 0v0.124l0 0.001h0.252l0-0.001v-0.124l-0-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.91 17.525h0.254v0.125h-0.254v-0.125zM11.638 17.397l-0.252 0.003 0.002-0.128 0.075-0.136 0.18 0.129c-0.011 0.052-0.003 0.050-0.004 0.133z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.385 16.25v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.25 16.751v-0.299c0-0.082 0.048-0.15 0.132-0.15s0.132 0.068 0.132 0.15v0.299h-0.263z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.198 15.399h0.261v0.74h-0.261v-0.74zM11.65 15.063h0.26v1.076h-0.26v-1.076zM12.083 15.399h0.261v0.74h-0.261v-0.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.655 15.719v0zM11.652 15.826v0zM12.084 15.466v0zM12.083 15.606v0zM12.083 15.715v0zM12.087 15.832v0zM12.214 15.464v0zM12.215 15.71v0zM12.212 15.937v0zM11.198 15.72v0zM11.202 15.837v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11 16.138v-0.468l0.196-0.001 0.058 0.041 0.002 0.227 0.165 0.001-0.001-0.234 0.050-0.036 0.169-0 0.058 0.047-0.001 0.225 0.171 0.001 0.002-0.222 0.044-0.049 0.168-0 0.051 0.045 0.007 0.218 0.156 0.001-0.003-0.215 0.054-0.049 0.216 0.001v0.467l-1.564 0.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11 16.001v0zM11.128 16.001v0zM11.392 16v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M11.646 16.010v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.911 16v0zM12.17 16.001v0zM12.441 16.001v0zM11.255 15.868v0zM11.252 15.74v0zM11.254 15.878v0zM11.696 15.739v0zM12.134 15.739v0zM12.564 15.738v0zM11.695 15.878v0zM12.138 15.878v0zM12.562 15.877v0zM11.125 15.743v0zM11.517 15.877v0zM11.651 15.74v0zM11.911 15.74v0zM12.441 15.736v0zM11.516 15.667v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M11.781 15.938v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M12.033 15.881v0zM12.031 15.667v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M12.292 15.885v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0044ad",
    style: {
      fill: "var(--color15, #0044ad)"
    },
    d: "M11.909 17.65v-0.284c0-0.047 0.010-0.19-0.144-0.178-0.156-0.009-0.128 0.13-0.128 0.178v0.284h0.271z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0044ad",
    style: {
      fill: "var(--color15, #0044ad)"
    },
    d: "M12.235 16.707v-0.223c0-0.059-0.023-0.117-0.070-0.117s-0.070 0.059-0.070 0.117v0.223h0.14zM11.453 16.705v-0.223c0-0.059-0.023-0.117-0.070-0.117s-0.070 0.059-0.070 0.117v0.223h0.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.646 15.609v0zM11.646 15.472v0zM11.646 15.356v0zM11.646 15.234v0zM11.646 15.126v0zM11.775 15.234v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M11.781 15.473v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.78 15.718v0zM11.78 15.934v0zM11.199 15.47v0zM11.198 15.609v0zM11.329 15.467v0zM11.33 15.714v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M11.323 15.946v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.533 14.792l-0.002 0.27 0.505-0.002-0.002-0.266-0.087 0.002-0.004 0.066-0.094-0.002v-0.065h-0.13v0.065h-0.097l0.002-0.067h-0.090z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M11.531 14.948v0zM11.777 15.060v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.075 15.135l-0.002 0.27 0.505-0.002-0.002-0.266-0.088 0.002-0.004 0.066-0.094-0.002v-0.065h-0.13v0.065h-0.097l0.002-0.068h-0.090z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M11.073 15.292v0zM11.319 15.404v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M11.971 15.135l-0.002 0.27 0.505-0.002-0.002-0.266-0.087 0.002-0.004 0.066-0.094-0.002v-0.065h-0.13v0.065h-0.097l0.002-0.068h-0.090z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M11.969 15.292v0zM12.214 15.404v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b60028",
    style: {
      fill: "var(--color23, #b60028)"
    },
    d: "M16.455 18.104v2.255c0 0.89-0.7 1.611-1.561 1.611s-1.56-0.721-1.56-1.611v-2.255h3.122z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M13.791 18.333c-0.1 0-0.18 0.084-0.18 0.187 0 0.082 0.051 0.153 0.122 0.178v0.291l-0.115 0.036v0.322l0.113 0.036v-0.104h0.002v-0.187h0.111v-0.391c0.005-0.002 0.013-0.003 0.017-0.005l0.354 0.434-0.065 0.107 0.202 0.244 0.111-0.052 0.28 0.344c-0.005 0.009-0.008 0.018-0.011 0.028h-0.183l-0.033-0.121h-0.311l-0.035 0.121h-0.213c-0.017-0.058-0.060-0.104-0.115-0.123v-0.398l-0.111 0v0.104l-0.002-0 0.002 0.294c-0.061 0.020-0.11 0.071-0.124 0.137-0 0.001 0 0.002 0 0.002-0.002 0.011-0.004 0.023-0.004 0.036 0 0.083 0.053 0.154 0.126 0.178v0.19l-0.115 0.043 0.017 0.322 0.115 0.028c0.016 0.089 0.041 0.174 0.074 0.256l-0.009 0.012c-0.065 0.078-0.056 0.196 0.020 0.263 0.049 0.044 0.114 0.054 0.172 0.036 0.050 0.061 0.107 0.118 0.167 0.168l-0.026 0.126c0.084 0.062 0.174 0.115 0.272 0.154l0.087-0.090c0.073 0.026 0.148 0.046 0.224 0.057 0.018 0.084 0.089 0.147 0.176 0.147s0.159-0.063 0.176-0.147c0.072-0.012 0.144-0.030 0.211-0.054l-0.002-0.002c0.030-0.011 0.060-0.022 0.089-0.036l-0.054-0.104c0.055-0.026 0.109-0.055 0.159-0.090l0.054 0.102c-0.050 0.034-0.103 0.066-0.159 0.092-0.029 0.013-0.057 0.027-0.087 0.038l0.085 0.088c0.097-0.039 0.188-0.092 0.272-0.154l-0.024-0.126c0.060-0.050 0.116-0.107 0.165-0.168 0.057 0.018 0.123 0.008 0.172-0.036 0.076-0.067 0.086-0.185 0.022-0.263l-0.011-0.012c0.033-0.082 0.059-0.166 0.074-0.256l0.115-0.028 0.017-0.322-0.115-0.043v-0.19c0.073-0.024 0.126-0.094 0.126-0.178 0-0.012-0.002-0.024-0.004-0.036-0-0.001 0-0.002 0-0.002-0.014-0.066-0.063-0.117-0.124-0.137l0.002-0.294 0.115-0.036v-0.322l-0.115-0.036v-0.291c0.073-0.024 0.126-0.094 0.126-0.178 0-0.103-0.081-0.187-0.18-0.187-0.080 0-0.148 0.055-0.172 0.13h-0.306v0.116h-0.183v-0.116h-0.278c-0.024-0.075-0.091-0.13-0.172-0.13s-0.148 0.055-0.172 0.13h-0.274v0.116h-0.183v-0.116h-0.306c-0.023-0.075-0.091-0.13-0.172-0.13l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M14.197 18.344l-0.033 0.118h0.378l-0.033-0.118h-0.313zM15.282 18.344l-0.035 0.118h0.378l-0.033-0.118h-0.311zM13.787 18.441c0.043 0 0.078 0.036 0.078 0.081s-0.036 0.081-0.078 0.081c-0.043 0-0.078-0.036-0.078-0.081s0.036-0.081 0.078-0.081z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M13.967 18.583h0.204l0.033 0.121h0.313l0.033-0.121h0.178c0.018 0.058 0.062 0.103 0.117 0.121v0.137l-0.115 0.036v0.322l0.115 0.036v0.448c-0.006 0.002-0.014 0.006-0.020 0.009l-0.276-0.336 0.067-0.104-0.204-0.246-0.109 0.052-0.356-0.431c0.008-0.013 0.015-0.028 0.020-0.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M15.068 18.583h0.185l0.035 0.121h0.311l0.033-0.121h0.207c0.002 0.008 0.007 0.014 0.011 0.021l-0.361 0.443-0.111-0.050-0.2 0.246 0.067 0.104 0.065-0.078 0.115-0.145 0.087 0.076-0.18 0.223 0.109 0.050 0.202-0.246-0.067-0.104 0.352-0.434c0.008 0.004 0.015 0.009 0.024 0.012v0.291l-0.117 0.036v0.322l0.117 0.036v0.296c-0.055 0.019-0.098 0.063-0.115 0.121h-0.207l-0.035-0.121h-0.311l-0.033 0.121h-0.174c-0.005-0.016-0.009-0.031-0.017-0.045l0.272-0.334 0.063-0.081-0.085-0.073-0.335 0.415c-0.005-0.002-0.015-0.003-0.020-0.005v-0.55h-0.111v-0.187h0.113v0.291l0.115-0.036v-0.322l-0.115-0.036v-0.14c0.053-0.019 0.093-0.063 0.111-0.118v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M13.844 18.99v0.393l0.115-0.036v-0.322l-0.115-0.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M15.953 19.094h0.113v0.187h-0.113v-0.187zM14.368 19.134l0.117 0.142-0.085 0.076-0.12-0.145 0.087-0.073z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M13.787 19.771c0.030 0 0.054 0.017 0.067 0.040 0 0.001-0 0.002 0 0.002 0.005 0.012 0.009 0.023 0.009 0.036 0 0.044-0.033 0.081-0.076 0.081s-0.078-0.036-0.078-0.081c0-0.012 0.004-0.023 0.009-0.033 0-0.001-0-0.002 0-0.002 0.013-0.025 0.040-0.043 0.070-0.043zM16.008 19.771c0.030 0 0.055 0.019 0.067 0.045h0.002c0.004 0.011 0.007 0.022 0.007 0.033 0 0.044-0.033 0.081-0.076 0.081s-0.078-0.036-0.078-0.081c0-0.013 0.003-0.025 0.009-0.036 0.013-0.024 0.039-0.043 0.070-0.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M14.26 19.802h0.189v0.111h0.285c0.004 0.012 0.007 0.023 0.013 0.033l-0.265 0.32-0.111-0.052-0.202 0.246 0.067 0.104-0.22 0.265c-0.030-0.012-0.066-0.017-0.098-0.012-0.027-0.067-0.046-0.138-0.059-0.211-0.006-0.032-0.010-0.064-0.013-0.097h-0.113c-0.003-0.035-0.004-0.069-0.004-0.104v-0.085l0.115 0.002v0.083c0 0.035-0 0.070 0.002 0.104 0.002 0.033 0.007 0.065 0.013 0.097l0.115-0.040c0 0-0.014-0.215-0.011-0.161 0.002 0.046-0.004-0.161-0.004-0.161l-0.115-0.031v-0.182c0.053-0.019 0.093-0.064 0.111-0.118h0.304v-0.111zM15.348 19.802h0.183v0.111h0.304c0.018 0.055 0.060 0.1 0.113 0.118v0.182l-0.117 0.031c0 0-0.005 0.207-0.002 0.161 0.003-0.054-0.013 0.161-0.013 0.161l0.117 0.040c-0.013 0.073-0.034 0.143-0.061 0.211-0.032-0.005-0.065-0-0.096 0.012l-0.22-0.265 0.065-0.104-0.202-0.246-0.111 0.052-0.252-0.315c0.007-0.011 0.013-0.022 0.017-0.036l0.274-0.002v-0.111z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M16.059 20.32l-0-0.289c0.073-0.024 0.126-0.095 0.126-0.178s-0.054-0.155-0.127-0.179l0.001-0.396h-0.112l-0 0.398c-0.055 0.019-0.098 0.063-0.115 0.121l-0.303 0v0.116h0.305c0.018 0.055 0.059 0.098 0.112 0.117l0 0.291 0.113-0.001zM16.060 18.698l-0.001 0.391h-0.112v-0.392c-0.009-0.003-0.017-0.007-0.025-0.011l-0.415 0.509-0.086-0.074 0.423-0.519c-0.003-0.007-0.007-0.015-0.010-0.023h-0.307v-0.116h0.306c0.024-0.075 0.091-0.129 0.172-0.129 0.1 0 0.181 0.084 0.181 0.186 0 0.084-0.052 0.154-0.126 0.178zM14.953 18.697l-0.001 0.241h-0.112l0-0.239c-0.056-0.018-0.1-0.063-0.118-0.121h-0.274v-0.116h0.274c0.024-0.075 0.091-0.129 0.171-0.129s0.148 0.054 0.172 0.129h0.279v0.116h-0.28c-0.009 0.028-0.024 0.053-0.043 0.074s-0.043 0.036-0.069 0.045zM15.468 20.638l-0.111 0.051-0.203-0.245 0.066-0.104 0.247 0.298z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M14.546 18.58l-0.034 0.12h-0.312l-0.034-0.12h0.38zM14.546 18.464l-0.034-0.12h-0.312l-0.034 0.12h0.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M14.319 20.644l0.111 0.051 0.202-0.245-0.066-0.104-0.247 0.298zM14.233 20.568l-0.066-0.105 0.203-0.245 0.11 0.051-0.247 0.298z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M14.306 21.31l-0.055 0.104c-0.095-0.064-0.179-0.143-0.251-0.232-0.058 0.018-0.123 0.007-0.172-0.036-0.076-0.067-0.085-0.185-0.020-0.263l0.009-0.011c-0.046-0.113-0.077-0.234-0.087-0.361l0.113 0c0.009 0.106 0.033 0.21 0.072 0.308 0.033-0.005 0.066-0.001 0.096 0.012l0.283-0.341 0.085 0.075-0.281 0.341c0.038 0.063 0.036 0.144-0.007 0.206 0.062 0.075 0.134 0.142 0.214 0.198v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M14.228 21.236c0.098 0.083 0.211 0.15 0.334 0.193l0.026-0.122c-0.101-0.035-0.194-0.085-0.276-0.151l-0.083 0.080zM14.172 21.342c0.099 0.081 0.212 0.146 0.334 0.191l-0.087 0.088c-0.096-0.039-0.188-0.090-0.273-0.152l0.026-0.127z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M13.73 20.324l0-0.289c-0.073-0.024-0.126-0.095-0.126-0.178s0.054-0.155 0.127-0.179l-0.001-0.396h0.112l0 0.398c0.055 0.019 0.098 0.063 0.115 0.121l0.303 0v0.116h-0.305c-0.018 0.055-0.060 0.098-0.112 0.117l-0 0.291-0.113-0.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M13.747 20.612l-0.116-0.028-0.016-0.321 0.115-0.042 0 0.184c0 0.072 0.006 0.139 0.017 0.207h0zM13.844 20.214l0.116 0.030c0 0 0.006 0.206 0.003 0.16-0.003-0.054 0.013 0.161 0.013 0.161l-0.117 0.042c-0.012-0.066-0.016-0.133-0.016-0.202l0-0.191h0zM13.731 18.99l-0.116 0.036v0.322l0.116 0.035v-0.392zM13.844 18.99l0.116 0.036v0.322l-0.116 0.035v-0.392zM14.17 19.797l0.034-0.12h0.312l0.034 0.12h-0.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M14.167 19.917l0.034 0.12h0.312l0.034-0.12-0.38 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.073 21.48c0.089-0.015 0.171-0.042 0.252-0.079l0.056 0.103c-0.093 0.044-0.193 0.075-0.298 0.092-0.017 0.084-0.090 0.148-0.176 0.148s-0.159-0.062-0.177-0.146c-0.11-0.016-0.215-0.047-0.313-0.093l0.056-0.103c0.085 0.039 0.176 0.065 0.27 0.080 0.020-0.047 0.056-0.083 0.104-0.1l0.001-0.505h0.112l0.001 0.504c0.050 0.016 0.092 0.053 0.112 0.102h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.566 21.245c-0.098 0.083-0.211 0.15-0.334 0.193l-0.026-0.122c0.1-0.035 0.194-0.085 0.276-0.151l0.083 0.080zM15.622 21.35c-0.099 0.081-0.212 0.146-0.334 0.191l0.087 0.088c0.096-0.039 0.188-0.090 0.273-0.152l-0.026-0.127zM14.958 20.975l0.116-0.036v-0.321l-0.116-0.035v0.392zM14.845 20.975l-0.116-0.036v-0.321l0.116-0.035v0.392z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.25 18.58l0.034 0.12h0.312l0.034-0.12h-0.38zM15.25 18.464l0.034-0.12h0.312l0.034 0.12h-0.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M14.167 19.917l0.035 0.118h0.311l0.033-0.118h-0.378z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M15.25 19.917l0.033 0.118h0.311l0.035-0.118h-0.378z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M14.828 20.021c0.004 0.002 0.009 0.004 0.013 0.005v0.552l-0.115 0.036v0.32l0.115 0.036v0.408c-0.048 0.017-0.084 0.052-0.104 0.099-0.061-0.009-0.122-0.023-0.18-0.043l0.026-0.123c-0.101-0.035-0.194-0.086-0.276-0.152l-0.085 0.081c0.025 0.021 0.050 0.041 0.076 0.059-0.026-0.019-0.051-0.038-0.076-0.059-0.046-0.040-0.089-0.083-0.128-0.13 0.043-0.062 0.044-0.143 0.007-0.206l0.217-0.265 0.111 0.052 0.202-0.246-0.065-0.104 0.263-0.317zM14.97 20.023l0.317 0.393 0.085-0.073 0.117 0.142-0.085 0.076-0.117-0.145-0.065-0.078-0.067 0.104 0.202 0.246 0.111-0.052 0.22 0.265c-0.038 0.063-0.037 0.144 0.007 0.206-0.039 0.048-0.084 0.090-0.13 0.13-0.024 0.021-0.050 0.041-0.076 0.059 0.026-0.019 0.052-0.038 0.076-0.059l-0.085-0.081c-0.082 0.066-0.176 0.117-0.276 0.152l0.026 0.123c-0.052 0.018-0.105 0.033-0.161 0.043-0.021-0.049-0.063-0.086-0.113-0.102v-0.405l0.117-0.036v-0.32l-0.117-0.036v-0.547c0.006-0.002 0.009-0.005 0.015-0.007zM16.059 20.317v0.085c0 0.036-0.001 0.070-0.004 0.104h-0.113c0.003-0.034 0.004-0.069 0.004-0.104v-0.083l0.113-0.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M14.421 20.344l0.087 0.073-0.12 0.145-0.085-0.076 0.117-0.142zM14.849 20.683h0.113v0.187h-0.113v-0.187zM14.315 21.306c0.050 0.035 0.105 0.064 0.161 0.090l-0.056 0.104c-0.055-0.026-0.108-0.056-0.159-0.090l0.054-0.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M14.746 19.944c-0.006-0.010-0.010-0.021-0.014-0.033h-0.283v-0.116h0.281c0.003-0.010 0.008-0.019 0.012-0.029l-0.347-0.421 0.085-0.075 0.343 0.414c0.006-0.003 0.012-0.006 0.018-0.008l0-0.551h0.112v0.548c0.005 0.002 0.013 0.003 0.018 0.005l0.335-0.415 0.086 0.075-0.336 0.412c0.009 0.014 0.015 0.029 0.019 0.046h0.272v0.116l-0.274 0.001c-0.004 0.013-0.011 0.025-0.017 0.037l0.318 0.394-0.085 0.075-0.317-0.395c-0.006 0.002-0.009 0.005-0.015 0.007l-0.001 0.652h-0.112l-0-0.655c-0.005-0.002-0.009-0.004-0.013-0.006l-0.33 0.397-0.085-0.075 0.329-0.399z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M13.884 20.946c0.028-0.034 0.077-0.038 0.109-0.009s0.037 0.079 0.009 0.113c-0.028 0.034-0.077 0.038-0.109 0.009s-0.036-0.079-0.009-0.113zM13.708 19.851c0-0.044 0.035-0.080 0.077-0.080s0.077 0.036 0.077 0.080c0 0.044-0.035 0.080-0.077 0.080s-0.077-0.035-0.077-0.080z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.48 21.31l0.055 0.104c0.094-0.064 0.179-0.143 0.251-0.232 0.057 0.018 0.123 0.007 0.172-0.036 0.076-0.067 0.085-0.185 0.020-0.263l-0.010-0.011c0.046-0.113 0.077-0.234 0.087-0.361l-0.113 0c-0.009 0.108-0.034 0.212-0.072 0.308-0.032-0.005-0.066-0.001-0.096 0.012l-0.283-0.341-0.085 0.075 0.281 0.341c-0.038 0.063-0.036 0.144 0.007 0.206-0.062 0.075-0.134 0.142-0.214 0.198v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M15.897 20.945c-0.028-0.034-0.076-0.038-0.109-0.009s-0.037 0.079-0.009 0.113c0.028 0.034 0.077 0.038 0.109 0.009s0.036-0.079 0.008-0.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M16.047 20.612l0.116-0.028 0.016-0.321-0.115-0.042-0 0.184c0 0.072-0.006 0.139-0.017 0.207zM15.95 20.214l-0.116 0.030c0 0-0.006 0.206-0.004 0.16 0.003-0.054-0.013 0.161-0.013 0.161l0.117 0.042c0.012-0.066 0.016-0.133 0.016-0.202l-0-0.191zM15.951 18.99l-0.116 0.036v0.322l0.116 0.035v-0.392zM16.064 18.99l0.116 0.036v0.322l-0.116 0.035 0-0.392zM15.559 20.563l0.066-0.105-0.203-0.245-0.11 0.051 0.247 0.298z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M15.927 19.851c0-0.044 0.035-0.080 0.077-0.080s0.077 0.036 0.077 0.080c0 0.044-0.034 0.080-0.077 0.080s-0.077-0.035-0.077-0.080z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.63 19.797l-0.034-0.12h-0.312l-0.034 0.12h0.38zM15.63 19.913l-0.034 0.12h-0.312l-0.034-0.12h0.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M14.831 21.551c0-0.044 0.035-0.080 0.077-0.080s0.077 0.036 0.077 0.080c0 0.044-0.034 0.080-0.077 0.080s-0.077-0.036-0.077-0.080zM15.934 18.517c0-0.044 0.034-0.080 0.077-0.080s0.077 0.036 0.077 0.080c0 0.044-0.035 0.080-0.077 0.080s-0.077-0.036-0.077-0.080zM14.823 18.517c0-0.044 0.035-0.080 0.077-0.080s0.077 0.036 0.077 0.080c0 0.044-0.034 0.080-0.077 0.080s-0.077-0.036-0.077-0.080z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M13.866 18.696l0.417 0.509 0.085-0.075-0.42-0.507c0.008-0.014 0.014-0.028 0.019-0.044h0.305v-0.116h-0.305c-0.023-0.075-0.092-0.129-0.172-0.129-0.1 0-0.181 0.084-0.181 0.186 0 0.082 0.051 0.151 0.122 0.176l-0.001 0.393h0.112v-0.39c0.005-0.002 0.013-0.002 0.018-0.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M14.298 19.051l0.111-0.051 0.203 0.245-0.066 0.104-0.247-0.298zM14.212 19.127l-0.066 0.105 0.202 0.245 0.11-0.052-0.247-0.298z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M14.845 18.833l-0.116 0.036v0.322l0.116 0.035v-0.392zM14.957 18.833l0.116 0.036v0.322l-0.116 0.035v-0.392z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006f46",
    style: {
      fill: "var(--color14, #006f46)"
    },
    d: "M14.719 19.854c0-0.104 0.081-0.187 0.181-0.187s0.181 0.084 0.181 0.187c0 0.103-0.081 0.186-0.181 0.186s-0.181-0.083-0.181-0.186z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    style: {
      fill: "var(--color16, #c8b100)"
    },
    d: "M13.531 18.101h0.27v-0.070h-0.27v0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dead00",
    style: {
      fill: "var(--color18, #dead00)"
    },
    d: "M13.531 18.101h0.27v-0.070h-0.27v0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6cb7e",
    style: {
      fill: "var(--color24, #f6cb7e)"
    },
    d: "M13.5 21.367c0.13 0.043 0.195 0.148 0.195 0.271 0 0.161-0.143 0.283-0.329 0.283s-0.336-0.122-0.336-0.283c0-0.121 0.062-0.257 0.191-0.267 0 0-0.004-0.013-0.015-0.034-0.013-0.016-0.040-0.045-0.040-0.045s0.049-0.010 0.078 0.002c0.029 0.012 0.047 0.031 0.047 0.031s0.014-0.029 0.032-0.051c0.019-0.022 0.044-0.036 0.044-0.036s0.029 0.026 0.038 0.044c0.009 0.018 0.015 0.039 0.015 0.039s0.026-0.024 0.049-0.033c0.023-0.010 0.052-0.017 0.052-0.017s-0.008 0.031-0.014 0.047c-0.004 0.011-0.008 0.023-0.011 0.035l-0.006 0.011 0.008 0.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006f46",
    style: {
      fill: "var(--color14, #006f46)"
    },
    d: "M13.336 22.097c0 0-0.247-0.181-0.354-0.206-0.137-0.031-0.29-0.006-0.357-0.010 0.002 0.002 0.080 0.063 0.114 0.1s0.148 0.112 0.213 0.129c0.2 0.055 0.384-0.014 0.384-0.014zM13.406 22.113c0 0 0.158-0.179 0.323-0.204 0.196-0.030 0.323 0.018 0.399 0.039 0.002 0-0.063 0.033-0.097 0.059s-0.122 0.106-0.257 0.108c-0.135 0.002-0.284-0.015-0.308-0.011-0.020 0.003-0.040 0.006-0.061 0.010z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M13.331 21.861c-0.062-0.063-0.070-0.116-0.070-0.215s0.039-0.188 0.101-0.251c0.032 0.032 0.057 0.071 0.074 0.114s0.026 0.090 0.026 0.137c0 0.099-0.003 0.149-0.065 0.211l-0.034 0.026-0.032-0.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006f46",
    style: {
      fill: "var(--color14, #006f46)"
    },
    d: "M13.288 22.25c0 0 0.041-0.088 0.044-0.176 0.003-0.074-0.010-0.147-0.010-0.147h0.049c0 0 0.025 0.078 0.025 0.147s-0.011 0.16-0.011 0.16-0.034 0.006-0.046 0.012c-0.011 0.006-0.041 0.021-0.041 0.021l-0.018 0.005 0.007-0.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    style: {
      fill: "var(--color19, #b2b2b2)"
    },
    d: "M13.333 18.11h3.121v-3.766h-3.121v3.766z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M15.28 17.611c0 0-0.039 0.043-0.025 0.080s0.039 0.074 0.039 0.074-0.001-0.054 0.014-0.069c0.023-0.022 0.065-0.025 0.065-0.025s-0.033-0.032-0.044-0.036c-0.010-0.004-0.049-0.024-0.049-0.024zM15.473 17.674c0 0-0.019 0.052 0.018 0.087s0.068 0.038 0.068 0.038-0.028-0.055-0.019-0.083c0.009-0.030 0.033-0.049 0.033-0.049s-0.046-0.017-0.053-0.015c-0.007 0.002-0.047 0.022-0.047 0.022zM14.931 15.323l0.004-0.042 0.005-0.023c0 0-0.1 0.009-0.152-0.007s-0.1-0.040-0.149-0.085c-0.049-0.045-0.068-0.074-0.103-0.079-0.084-0.015-0.149 0.027-0.149 0.027s0.063 0.025 0.111 0.089c0.047 0.064 0.099 0.096 0.121 0.103 0.037 0.012 0.165 0.004 0.2 0.005s0.114 0.013 0.114 0.013v-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M14.75 15.391l0.021-0.036 0.021 0.033-0.042 0.003zM14.801 15.389l0.025-0.036 0.026 0.032-0.051 0.004zM14.778 15.167l0.051 0.020-0.046 0.025-0.005-0.045zM14.839 15.185l0.046 0.013-0.037 0.031-0.009-0.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d85aac",
    style: {
      fill: "var(--color25, #d85aac)"
    },
    d: "M15.403 15.178c0 0 0 0.049 0.005 0.095 0.004 0.045-0.013 0.084-0.007 0.108s0.010 0.045 0.019 0.063c0.008 0.018 0.013 0.064 0.013 0.064s-0.024-0.018-0.046-0.036c-0.012-0.010-0.025-0.020-0.037-0.030 0 0 0.005 0.049 0.007 0.070s0.014 0.060 0.032 0.084c0.018 0.023 0.054 0.060 0.065 0.090s0.009 0.097 0.009 0.097-0.029-0.051-0.054-0.060c-0.025-0.009-0.079-0.042-0.079-0.042s0.049 0.053 0.049 0.104c0 0.051-0.020 0.109-0.020 0.109s-0.022-0.046-0.051-0.076c-0.029-0.030-0.070-0.060-0.070-0.060s0.032 0.079 0.032 0.132c0 0.053-0.009 0.167-0.009 0.167s-0.025-0.044-0.049-0.065c-0.025-0.021-0.054-0.039-0.063-0.053s0.029 0.044 0.033 0.078c0.004 0.035 0.020 0.159 0.119 0.317 0.058 0.093 0.148 0.255 0.341 0.201s0.121-0.336 0.081-0.468c-0.040-0.132-0.061-0.278-0.058-0.329s0.036-0.201 0.031-0.229c-0.004-0.028-0.015-0.135 0.009-0.222 0.025-0.090 0.045-0.125 0.058-0.163s0.024-0.058 0.029-0.090c0.004-0.032 0.004-0.093 0.004-0.093s0.036 0.072 0.045 0.098c0.009 0.026 0.009 0.102 0.009 0.102s0.007-0.076 0.061-0.113c0.054-0.037 0.117-0.077 0.132-0.097s0.020-0.035 0.020-0.035-0.005 0.13-0.038 0.181c-0.022 0.033-0.11 0.141-0.11 0.141s0.045-0.019 0.076-0.021c0.031-0.003 0.054 0 0.054 0s-0.038 0.032-0.087 0.111c-0.049 0.079-0.029 0.086-0.065 0.15s-0.065 0.067-0.11 0.107c-0.067 0.059-0.031 0.294-0.022 0.329s0.126 0.322 0.128 0.392c0.002 0.070 0.014 0.225-0.099 0.324-0.072 0.065-0.191 0.065-0.218 0.084s-0.080 0.076-0.080 0.197c0 0.121 0.040 0.139 0.071 0.169s0.072 0.014 0.081 0.037c0.009 0.023 0.014 0.037 0.027 0.051s0.023 0.030 0.018 0.055c-0.004 0.026-0.056 0.084-0.074 0.126s-0.054 0.15-0.054 0.167c0 0.016-0.004 0.067 0.011 0.093 0 0 0.056 0.071 0.018 0.085-0.025 0.009-0.049-0.017-0.060-0.014-0.034 0.010-0.051 0.032-0.061 0.030-0.022-0.005-0.022-0.017-0.025-0.051s-0.001-0.049-0.011-0.049c-0.014 0-0.020 0.012-0.023 0.030s-0.002 0.060-0.018 0.060c-0.016 0-0.038-0.030-0.052-0.037s-0.052-0.014-0.054-0.032c-0.002-0.018 0.022-0.058 0.047-0.065s0.047-0.021 0.031-0.035-0.031-0.014-0.047 0c-0.016 0.014-0.049 0.002-0.047-0.019s0.007-0.046 0.004-0.058c-0.002-0.011-0.029-0.035 0.007-0.056s0.052 0.019 0.087 0.012c0.036-0.007 0.054-0.021 0.067-0.044s0.011-0.072-0.014-0.102c-0.025-0.030-0.049-0.035-0.058-0.054s-0.022-0.062-0.022-0.062 0.007 0.081 0.002 0.093c-0.004 0.012-0.002 0.060-0.002 0.060s-0.025-0.030-0.045-0.053c-0.020-0.023-0.040-0.093-0.040-0.093s-0.002 0.065-0.002 0.090c0 0.025 0.027 0.048 0.018 0.058s-0.052-0.049-0.063-0.058c-0.011-0.009-0.047-0.039-0.063-0.072s-0.027-0.078-0.031-0.095c-0.004-0.016-0.012-0.088-0.004-0.107 0.011-0.028 0.029-0.076 0.029-0.076h-0.088c-0.047 0-0.081-0.016-0.099 0.018s-0.009 0.104 0.013 0.195c0.023 0.090 0.036 0.134 0.029 0.15s-0.036 0.053-0.047 0.060c-0.011 0.007-0.043 0.005-0.056-0.002s-0.036-0.019-0.078-0.019c-0.043 0-0.070 0.002-0.085-0.002s-0.054-0.026-0.072-0.021c-0.018 0.005-0.049 0.022-0.040 0.049 0.014 0.042-0.013 0.051-0.031 0.049s-0.033-0.009-0.056-0.016c-0.022-0.007-0.056 0-0.052-0.028s0.014-0.030 0.025-0.051c0.011-0.021 0.016-0.035 0.003-0.036-0.016-0.002-0.032-0.004-0.044 0.007s-0.031 0.034-0.047 0.025c-0.016-0.009-0.028-0.029-0.028-0.073s-0.042-0.081-0.004-0.079c0.039 0.002 0.088 0.033 0.096 0.009s0.003-0.034-0.018-0.053c-0.021-0.018-0.047-0.029-0.019-0.052s0.035-0.023 0.046-0.036c0.011-0.012 0.026-0.053 0.045-0.043 0.039 0.020 0.002 0.049 0.040 0.096s0.063 0.064 0.128 0.056c0.065-0.007 0.083-0.016 0.083-0.036s-0.005-0.056-0.007-0.071c-0.002-0.014 0.009-0.067 0.009-0.067s-0.030 0.020-0.039 0.040c-0.008 0.020-0.026 0.054-0.026 0.054s-0.007-0.041-0.005-0.074c0.001-0.019 0.008-0.053 0.007-0.060-0.002-0.018-0.014-0.063-0.014-0.063s-0.011 0.049-0.017 0.063c-0.007 0.014-0.010 0.072-0.010 0.072s-0.041-0.039-0.030-0.105c0.009-0.051-0.007-0.118 0.007-0.139s0.047-0.11 0.128-0.114c0.081-0.003 0.144 0.004 0.172 0.002s0.128-0.022 0.128-0.022-0.184-0.103-0.226-0.134c-0.042-0.030-0.107-0.11-0.128-0.146s-0.040-0.107-0.040-0.107-0.033 0.002-0.063 0.020c-0.030 0.018-0.060 0.045-0.077 0.067s-0.046 0.071-0.046 0.071 0.005-0.063 0.005-0.083c0-0.019-0.004-0.058-0.004-0.058s-0.021 0.087-0.063 0.119c-0.042 0.033-0.091 0.078-0.091 0.078s0.005-0.048 0.005-0.059c0-0.011 0.011-0.067 0.011-0.067s-0.030 0.048-0.075 0.058c-0.046 0.009-0.112 0.007-0.118 0.038s0.012 0.072 0.002 0.094c-0.011 0.022-0.033 0.036-0.033 0.036s-0.026-0.024-0.049-0.025c-0.023-0.002-0.044 0.011-0.044 0.011s-0.019-0.027-0.012-0.045c0.007-0.018 0.042-0.045 0.033-0.056s-0.037 0.004-0.054 0.013c-0.017 0.009-0.054 0.018-0.051-0.013s0.012-0.049 0.004-0.071c-0.009-0.021-0.004-0.036 0.011-0.042s0.070 0.002 0.075-0.012c0.005-0.015-0.014-0.033-0.051-0.042s-0.054-0.033-0.035-0.053 0.025-0.025 0.033-0.043c0.009-0.018 0.012-0.051 0.046-0.034s0.026 0.056 0.061 0.069c0.035 0.013 0.117-0.005 0.135-0.016s0.074-0.056 0.093-0.067c0.019-0.011 0.1-0.076 0.1-0.076s-0.047-0.036-0.065-0.054c-0.017-0.018-0.049-0.061-0.064-0.070s-0.093-0.042-0.119-0.043-0.107-0.032-0.107-0.032c0 0 0.037-0.013 0.049-0.024s0.040-0.038 0.054-0.036c0.014 0.002 0.017 0.002 0.017 0.002s-0.075-0.004-0.091-0.009c-0.016-0.006-0.061-0.037-0.079-0.037s-0.053 0.007-0.053 0.007 0.047-0.033 0.086-0.040c0.039-0.007 0.068-0.006 0.068-0.006s-0.060-0.018-0.074-0.040c-0.014-0.022-0.028-0.054-0.039-0.069s-0.017-0.038-0.037-0.040c-0.019-0.002-0.053 0.025-0.072 0.024s-0.033-0.015-0.035-0.045c-0.001-0.031 0-0.020-0.007-0.036s-0.035-0.055-0.009-0.063c0.027-0.009 0.083 0.005 0.088-0.006s-0.030-0.043-0.053-0.056c-0.023-0.012-0.060-0.034-0.040-0.052s0.039-0.025 0.049-0.042c0.010-0.016 0.023-0.062 0.046-0.047s0.054 0.085 0.072 0.080c0.018-0.006 0.019-0.056 0.016-0.078s0-0.060 0.017-0.056c0.018 0.004 0.032 0.029 0.060 0.031s0.070-0.007 0.066 0.014c-0.004 0.022-0.019 0.049-0.039 0.072s-0.028 0.071-0.016 0.101c0.012 0.031 0.044 0.080 0.072 0.1s0.080 0.035 0.114 0.058c0.033 0.024 0.11 0.090 0.137 0.098s0.053 0.022 0.053 0.022 0.030-0.014 0.070-0.014c0.040 0 0.133 0.007 0.168-0.009s0.081-0.043 0.067-0.078c-0.014-0.034-0.091-0.065-0.084-0.092s0.035-0.029 0.082-0.031c0.047-0.002 0.112 0.009 0.124-0.063s0.016-0.114-0.050-0.13c-0.067-0.016-0.116-0.018-0.128-0.071s-0.025-0.065-0.011-0.080c0.014-0.014 0.039-0.022 0.088-0.025s0.105-0.004 0.121-0.017c0.016-0.012 0.019-0.047 0.038-0.062s0.095-0.027 0.095-0.027 0.090 0.048 0.174 0.116c0.075 0.061 0.143 0.151 0.143 0.151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color7, #000)"
    },
    d: "M14.755 15.124c0 0-0.011-0.033-0.012-0.042s-0.003-0.020-0.003-0.020 0.050-0 0.049 0.018c-0.002 0.018-0.018 0.018-0.021 0.025s-0.012 0.018-0.012 0.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color7, #000)"
    },
    d: "M15.004 15.029l-0.004-0.029c0 0 0.047 0 0.070 0.018 0.035 0.027 0.058 0.069 0.056 0.071-0.006 0.006-0.033-0.018-0.053-0.025 0 0-0.014 0.004-0.028 0.004s-0.021-0.007-0.023-0.014c-0.002-0.007 0.002-0.020 0.002-0.020l-0.021-0.003v-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    style: {
      fill: "var(--color26, #db4446)"
    },
    d: "M14.063 15.11c0 0 0.030 0.023 0.053 0.027s0.047 0.004 0.051 0.004c0.003 0 0.011-0.036 0.007-0.061-0.012-0.082-0.081-0.1-0.081-0.1s0.020 0.049 0.010 0.072c-0.014 0.033-0.040 0.058-0.040 0.058z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M14.063 15.11c0 0 0.030 0.023 0.053 0.027s0.047 0.004 0.051 0.004c0.003 0 0.011-0.036 0.007-0.061-0.012-0.082-0.081-0.1-0.081-0.1s0.020 0.049 0.010 0.072c-0.014 0.033-0.040 0.058-0.040 0.058z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    style: {
      fill: "var(--color26, #db4446)"
    },
    d: "M13.915 15.181c0 0-0.026-0.053-0.082-0.045s-0.093 0.055-0.093 0.055 0.062-0.002 0.077 0.009c0.023 0.016 0.030 0.058 0.030 0.058s0.034-0.022 0.044-0.036c0.010-0.015 0.024-0.040 0.024-0.040z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M13.915 15.181c0 0-0.026-0.053-0.082-0.045s-0.093 0.055-0.093 0.055 0.062-0.002 0.077 0.009c0.023 0.016 0.030 0.058 0.030 0.058s0.034-0.022 0.044-0.036c0.010-0.015 0.024-0.040 0.024-0.040z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    style: {
      fill: "var(--color26, #db4446)"
    },
    d: "M13.846 15.396c0 0-0.047 0.007-0.073 0.040s-0.023 0.094-0.023 0.094 0.031-0.036 0.060-0.036c0.028 0 0.072 0.011 0.072 0.011s-0.014-0.038-0.014-0.055c0-0.016-0.021-0.054-0.021-0.054z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M13.846 15.396c0 0-0.047 0.007-0.073 0.040s-0.023 0.094-0.023 0.094 0.031-0.036 0.060-0.036c0.028 0 0.072 0.011 0.072 0.011s-0.014-0.038-0.014-0.055c0-0.016-0.021-0.054-0.021-0.054z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    style: {
      fill: "var(--color26, #db4446)"
    },
    d: "M14.012 16.075c0 0-0.026-0.030-0.072-0.022s-0.075 0.065-0.075 0.065 0.039-0.011 0.061-0.006c0.023 0.006 0.039 0.031 0.039 0.031s0.021-0.020 0.028-0.031c0.007-0.011 0.019-0.038 0.019-0.038z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M14.012 16.075c0 0-0.026-0.030-0.072-0.022s-0.075 0.065-0.075 0.065 0.039-0.011 0.061-0.006c0.023 0.006 0.039 0.031 0.039 0.031s0.021-0.020 0.028-0.031c0.007-0.011 0.019-0.038 0.019-0.038h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    style: {
      fill: "var(--color26, #db4446)"
    },
    d: "M13.961 16.282c0 0-0.039-0.007-0.072 0.022s-0.035 0.085-0.035 0.085 0.032-0.029 0.056-0.025c0.024 0.003 0.054 0.018 0.054 0.018s0.005-0.035 0.007-0.043c0.005-0.025-0.010-0.056-0.010-0.056z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M13.961 16.282c0 0-0.039-0.007-0.072 0.022s-0.035 0.085-0.035 0.085 0.032-0.029 0.056-0.025c0.024 0.003 0.054 0.018 0.054 0.018s0.005-0.035 0.007-0.043c0.005-0.025-0.010-0.056-0.010-0.056z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    style: {
      fill: "var(--color26, #db4446)"
    },
    d: "M14.042 16.462c0 0-0.003 0.054 0.021 0.087 0.025 0.035 0.070 0.040 0.070 0.040s-0.015-0.036-0.018-0.054c-0.004-0.027 0.021-0.051 0.021-0.051s-0.023-0.025-0.045-0.025c-0.023 0-0.049 0.004-0.049 0.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M14.042 16.462c0 0-0.003 0.054 0.021 0.087 0.025 0.035 0.070 0.040 0.070 0.040s-0.015-0.036-0.018-0.054c-0.004-0.027 0.021-0.051 0.021-0.051s-0.023-0.025-0.045-0.025c-0.023 0-0.049 0.004-0.049 0.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    style: {
      fill: "var(--color26, #db4446)"
    },
    d: "M14.498 16.938c0 0-0.032-0.043-0.075-0.042s-0.090 0.047-0.090 0.047 0.055-0.005 0.068 0.015c0.014 0.020 0.028 0.045 0.028 0.045s0.024-0.014 0.035-0.023c0.010-0.009 0.033-0.041 0.033-0.041z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M14.498 16.938c0 0-0.032-0.043-0.075-0.042s-0.090 0.047-0.090 0.047 0.055-0.005 0.068 0.015c0.014 0.020 0.028 0.045 0.028 0.045s0.024-0.014 0.035-0.023c0.010-0.009 0.033-0.041 0.033-0.041z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    style: {
      fill: "var(--color26, #db4446)"
    },
    d: "M14.362 17.126c0 0-0.058-0.009-0.086 0.023s-0.026 0.092-0.026 0.092 0.035-0.041 0.066-0.038c0.032 0.004 0.067 0.022 0.067 0.022s-0.005-0.036-0.009-0.053c-0.004-0.016-0.012-0.047-0.012-0.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M14.362 17.126c0 0-0.058-0.009-0.086 0.023s-0.026 0.092-0.026 0.092 0.035-0.041 0.066-0.038c0.032 0.004 0.067 0.022 0.067 0.022s-0.005-0.036-0.009-0.053c-0.004-0.016-0.012-0.047-0.012-0.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    style: {
      fill: "var(--color26, #db4446)"
    },
    d: "M14.494 17.333c0 0-0.028 0.043-0.007 0.078s0.065 0.051 0.065 0.051-0.016-0.025-0.009-0.055c0.006-0.023 0.042-0.054 0.042-0.054l-0.091-0.020z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M14.494 17.333c0 0-0.028 0.043-0.007 0.078s0.065 0.051 0.065 0.051-0.016-0.025-0.009-0.055c0.006-0.023 0.042-0.054 0.042-0.054l-0.091-0.020v-0zM15.264 17.415c0 0-0.051-0.013-0.079 0.005s-0.051 0.094-0.051 0.094 0.046-0.042 0.079-0.037c0.033 0.006 0.058 0.020 0.058 0.020s0.005-0.031 0.002-0.052c-0.002-0.013-0.009-0.031-0.009-0.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M15.265 17.411c0 0-0.051-0.013-0.079 0.005s-0.051 0.094-0.051 0.094 0.046-0.042 0.079-0.037c0.033 0.006 0.058 0.020 0.058 0.020s0.005-0.031 0.002-0.052c-0.002-0.013-0.009-0.031-0.009-0.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.365 14.887l-0.018 0.001c-0.001 0.002-0.009 0.016-0.016 0.024-0.016 0.017-0.040 0.018-0.053 0.005-0.003-0.004-0.006-0.008-0.007-0.013s-0.002-0.010-0.001-0.015c-0.010 0.006-0.021 0.006-0.032-0-0.016-0.010-0.020-0.034-0.008-0.054 0.002-0.004 0.004-0.009 0.007-0.012l-0.001-0.022-0.022 0.005-0.006 0.013c-0.013 0.017-0.033 0.021-0.043 0.011-0.005-0.005-0.006-0.008-0.008-0.018-0.005 0.005-0.005 0.006-0.011 0.007-0.033 0.009-0.046-0.071-0.047-0.091l-0.011 0.017c0 0 0.010 0.048 0.005 0.088s-0.018 0.081-0.018 0.081c0.046 0.013 0.116 0.054 0.184 0.112s0.123 0.12 0.145 0.164c0 0 0.036-0.022 0.073-0.035s0.084-0.014 0.084-0.014l0.013-0.014c-0.020 0.003-0.098 0.007-0.096-0.029 0-0.005-0.001-0.006 0.006-0.014-0.012 0-0.014 0.001-0.020-0.003-0.011-0.008-0.011-0.029 0.001-0.046l0.011-0.009 0.001-0.023-0.021 0.003c-0.002 0.003-0.007 0.006-0.009 0.009-0.016 0.016-0.040 0.017-0.053 0.002-0.008-0.008-0.010-0.020-0.007-0.031-0.010 0.003-0.020 0.002-0.028-0.003-0.016-0.011-0.019-0.035-0.007-0.054 0.006-0.009 0.017-0.020 0.019-0.022l-0.004-0.020z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.285 14.98l-0.020-0.017c-0.004-0.003-0.005-0.008-0.002-0.011s0.007-0.003 0.011 0l0.020 0.017 0.021 0.017c0.004 0.003 0.005 0.008 0.003 0.011s-0.007 0.002-0.011-0l-0.021-0.017zM15.177 14.899l-0.016-0.010c-0.004-0.003-0.006-0.008-0.004-0.011s0.007-0.004 0.010-0.002l0.016 0.010 0.016 0.010c0.004 0.002 0.006 0.007 0.004 0.011s-0.006 0.004-0.011 0.001l-0.016-0.010z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.332 15.034c0.006 0.004 0.013 0.004 0.016-0s0.001-0.011-0.005-0.016c-0.006-0.004-0.013-0.004-0.016 0s-0.001 0.011 0.005 0.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.381 15.079l0.013 0.014c0.003 0.003 0.008 0.005 0.011 0.002s0.002-0.007-0.001-0.011l-0.013-0.014-0.014-0.014c-0.003-0.003-0.008-0.004-0.011-0.002s-0.003 0.007 0.001 0.011l0.013 0.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.429 15.126c0.004 0.006 0.011 0.008 0.015 0.005s0.004-0.010 0-0.017c-0.004-0.006-0.011-0.008-0.015-0.005s-0.004 0.010-0 0.017z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.273 14.729l-0.037 0.001-0.007 0.059 0.004 0.009 0.010-0.001 0.047-0.034c-0.005-0.012-0.011-0.023-0.017-0.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.168 14.758l-0.001 0.037 0.057 0.008 0.009-0.004-0.001-0.010-0.033-0.048c-0.011 0.005-0.021 0.011-0.031 0.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.294 14.836l-0.030 0.018-0.033-0.048-0.001-0.010 0.009-0.004 0.057 0.007c0.001 0.012 0 0.024-0.002 0.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.227 14.813c0.011 0 0.019-0.009 0.019-0.021s-0.009-0.021-0.019-0.021c-0.011 0-0.019 0.009-0.019 0.021s0.009 0.021 0.019 0.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.082 14.729c-0.001 0-0.008-0.031-0.016-0.048-0.005-0.012-0.024-0.029-0.024-0.029 0.002-0.004 0.026-0.013 0.054 0.006 0.023 0.021-0.002 0.059-0.002 0.059s-0.006 0.009-0.012 0.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.141 14.744l-0.026 0.024-0.042-0.040 0.004-0.006 0.002-0.010 0.057-0.005c0.002 0.012 0.004 0.024 0.006 0.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.073 14.727c0-0.011 0.006-0.019 0.013-0.019s0.012 0.009 0.012 0.019c-0 0.011-0.006 0.019-0.013 0.019s-0.012-0.009-0.012-0.019zM15.41 14.823l-0.037-0.004-0.015 0.057 0.003 0.010 0.010 0 0.051-0.027c-0.004-0.012-0.008-0.024-0.012-0.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.308 14.837l-0.006 0.036 0.055 0.016 0.009-0.003 0.001-0.010-0.026-0.053c-0.011 0.004-0.022 0.009-0.033 0.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.413 14.926l-0.033 0.014-0.026-0.053 0.001-0.010 0.009-0.003 0.055 0.016c-0.002 0.012-0.004 0.024-0.006 0.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.363 14.906c0.011 0 0.019-0.009 0.019-0.021s-0.009-0.021-0.019-0.021c-0.011 0-0.019 0.009-0.019 0.021s0.009 0.021 0.019 0.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.537 14.947l0.007 0.038-0.054 0.020-0.010-0.002-0.001-0.010 0.023-0.055c0.012 0.003 0.024 0.006 0.036 0.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.523 15.048l-0.035 0.008-0.019-0.056 0.002-0.010 0.010-0.001 0.053 0.024c-0.004 0.012-0.007 0.024-0.011 0.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.428 14.946l-0.011 0.035 0.053 0.023 0.010-0.001 0.002-0.010-0.019-0.056c-0.011 0.003-0.023 0.006-0.034 0.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.477 15.021c0.011 0 0.019-0.009 0.019-0.021s-0.009-0.021-0.019-0.021c-0.011 0-0.019 0.009-0.019 0.021s0.009 0.021 0.019 0.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.573 15.139c-0 0.001 0.031 0.002 0.049 0.006 0.013 0.003 0.033 0.019 0.033 0.019 0.004-0.003 0.007-0.029-0.017-0.053-0.024-0.019-0.055 0.014-0.055 0.014s-0.007 0.008-0.009 0.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.539 15.074l-0.018 0.031 0.047 0.035 0.006-0.006 0.008-0.003-0.007-0.059c-0.012 0.001-0.024 0.001-0.035 0.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.573 15.141c0.010-0.002 0.017-0.010 0.015-0.016s-0.011-0.011-0.021-0.009c-0.010 0.002-0.016 0.009-0.015 0.017s0.011 0.011 0.020 0.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color2, #fff)"
    },
    d: "M15.034 15.042c0 0 0.004 0.006 0.003 0.009s-0.006 0.005-0.006 0.005c0.011 0.004 0.017 0.001 0.021-0.002-0.001-0.008-0.006-0.010-0.011-0.012-0.002-0.001-0.007-0-0.007-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.114 14.868c0.006 0.004 0.013 0.004 0.016-0.001s0.001-0.012-0.005-0.015c-0.006-0.004-0.013-0.004-0.016 0.001s-0.001 0.012 0.005 0.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M15.229 14.951c0.006 0.004 0.013 0.004 0.016-0.001s0.001-0.012-0.005-0.015c-0.006-0.004-0.013-0.004-0.016 0.001s-0.001 0.012 0.005 0.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    style: {
      fill: "var(--color9, #ce1126)"
    },
    d: "M12.333 18.091c0-0.683 0.451-1.237 1.008-1.237s1.008 0.554 1.008 1.237-0.451 1.237-1.008 1.237c-0.557 0-1.008-0.554-1.008-1.237z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b50027",
    style: {
      fill: "var(--color12, #b50027)"
    },
    d: "M12.333 18.091c0-0.683 0.451-1.237 1.008-1.237s1.008 0.554 1.008 1.237-0.451 1.237-1.008 1.237c-0.557 0-1.008-0.554-1.008-1.237z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    style: {
      fill: "var(--color20, #005bbf)"
    },
    opacity: 0.941,
    d: "M12.635 18.084c0-0.501 0.317-0.907 0.709-0.907s0.709 0.406 0.709 0.907c0 0.501-0.317 0.907-0.709 0.907s-0.709-0.406-0.709-0.907z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0044ad",
    style: {
      fill: "var(--color15, #0044ad)"
    },
    d: "M12.635 18.084c0-0.501 0.317-0.907 0.709-0.907s0.709 0.406 0.709 0.907c0 0.501-0.317 0.907-0.709 0.907s-0.709-0.406-0.709-0.907h-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M13.010 17.469c0 0-0.084 0.101-0.084 0.194s0.036 0.171 0.036 0.171c-0.013-0.037-0.047-0.064-0.088-0.064-0.051 0-0.093 0.043-0.093 0.096 0 0.015 0.009 0.039 0.015 0.053l0.030 0.067c0.010-0.025 0.034-0.038 0.061-0.038 0.037 0 0.066 0.030 0.066 0.068 0 0.006-0.001 0.012-0.002 0.017l-0.076 0v0.070h0.067l-0.050 0.108 0.066-0.028 0.050 0.062 0.052-0.062 0.066 0.028-0.050-0.108h0.067v-0.070l-0.076-0c-0.001-0.005-0.002-0.011-0.002-0.017 0-0.038 0.029-0.068 0.066-0.068 0.027 0 0.051 0.014 0.061 0.038l0.030-0.067c0.007-0.013 0.015-0.037 0.015-0.053 0-0.053-0.041-0.096-0.093-0.096-0.040 0-0.075 0.027-0.087 0.064 0 0 0.035-0.078 0.035-0.171s-0.086-0.194-0.086-0.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M12.875 18.103h0.27v-0.070h-0.27v0.070zM13.668 17.469c0 0-0.084 0.101-0.084 0.194s0.035 0.171 0.035 0.171c-0.013-0.037-0.047-0.064-0.087-0.064-0.051 0-0.093 0.043-0.093 0.096 0 0.015 0.009 0.039 0.015 0.053l0.030 0.067c0.010-0.025 0.034-0.038 0.061-0.038 0.037 0 0.066 0.030 0.066 0.068 0 0.006-0 0.012-0.002 0.017l-0.076 0v0.070h0.067l-0.050 0.108 0.066-0.028 0.050 0.062 0.052-0.062 0.067 0.028-0.050-0.108h0.067v-0.070l-0.076-0c-0.001-0.005-0.002-0.011-0.002-0.017 0-0.038 0.030-0.068 0.066-0.068 0.027 0 0.051 0.014 0.061 0.038l0.030-0.067c0.007-0.013 0.015-0.037 0.015-0.053 0-0.053-0.042-0.096-0.093-0.096-0.040 0-0.075 0.027-0.088 0.064 0 0 0.036-0.078 0.036-0.171s-0.086-0.194-0.086-0.194zM13.338 18.087c0 0-0.084 0.101-0.084 0.194s0.036 0.171 0.036 0.171c-0.013-0.037-0.047-0.064-0.088-0.064-0.051 0-0.093 0.043-0.093 0.096 0 0.016 0.009 0.039 0.015 0.053l0.030 0.067c0.010-0.024 0.033-0.038 0.061-0.038 0.037 0 0.067 0.031 0.067 0.069 0 0.006-0.001 0.012-0.002 0.017l-0.076 0v0.070h0.068l-0.050 0.109 0.066-0.029 0.050 0.062 0.052-0.062 0.066 0.029-0.050-0.109h0.068v-0.070l-0.076-0c-0.001-0.006-0.002-0.011-0.002-0.017 0-0.038 0.030-0.069 0.066-0.069 0.027 0 0.051 0.014 0.061 0.038l0.030-0.067c0.006-0.013 0.015-0.037 0.015-0.053 0-0.053-0.042-0.096-0.093-0.096-0.040 0-0.075 0.027-0.088 0.064 0 0 0.036-0.078 0.036-0.171s-0.086-0.194-0.086-0.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M13.208 18.72h0.27v-0.070h-0.27v0.070zM13.538 18.101h0.27v-0.070h-0.27v0.070z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M18.671 21h-1.421v0.394h1.421v-0.394z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f7e00",
    style: {
      fill: "var(--color13, #9f7e00)"
    },
    d: "M9.421 21h-1.421v0.394h1.421v-0.394z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-norway",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e31d1c",
    style: {
      fill: "var(--color2, #e31d1c)"
    },
    d: "M0 0v32h42.667v-32h-42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e42a5",
    style: {
      fill: "var(--color3, #2e42a5)",
      stroke: "var(--color4, #f7fcff)"
    },
    stroke: "#f7fcff",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M20-1.333v13.333h24v8h-24v13.333h-8v-13.333h-13.333v-8h13.333v-13.333h8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-netherlands",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M0 0v32h42.667v-32h-42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e31d1c",
    style: {
      fill: "var(--color2, #e31d1c)"
    },
    d: "M0 0v10.667h42.667v-10.667h-42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d58db",
    style: {
      fill: "var(--color5, #3d58db)"
    },
    d: "M0 21.333v10.667h42.667v-10.667h-42.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-denmark",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    style: {
      fill: "var(--color6, #333)"
    },
    d: "M0 0h42.667v32h-42.667v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c51918",
    style: {
      fill: "var(--color7, #c51918)"
    },
    d: "M0 0v32h42.667v-32h-42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M13.333 0h5.333v13.333h24v5.333h-24v13.333h-5.333v-13.333h-13.333v-5.333h13.333v-13.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-finland",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M0 0v32h42.667v-32h-42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e42a5",
    style: {
      fill: "var(--color3, #2e42a5)"
    },
    d: "M13.333 0h5.333v13.333h24v5.333h-24v13.333h-5.333v-13.333h-13.333v-5.333h13.333v-13.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-austria",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    style: {
      fill: "var(--color8, #ebebeb)"
    },
    opacity: 0.76,
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    style: {
      fill: "var(--color8, #ebebeb)"
    },
    d: "M0 0v32h42.667v-32h-42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c51918",
    style: {
      fill: "var(--color7, #c51918)"
    },
    d: "M0 0v10.667h42.667v-10.667h-42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c51918",
    style: {
      fill: "var(--color7, #c51918)"
    },
    d: "M0 21.333v10.667h42.667v-10.667h-42.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-sweden",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d58db",
    style: {
      fill: "var(--color5, #3d58db)"
    },
    d: "M0 0v32h42.667v-32h-42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#feca00",
    style: {
      fill: "var(--color9, #feca00)"
    },
    d: "M13.333 0h5.333v13.333h24v5.333h-24v13.333h-5.333v-13.333h-13.333v-5.333h13.333v-13.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-ukraine",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3195f9",
    style: {
      fill: "var(--color10, #3195f9)"
    },
    d: "M0 0v32h42.667v-32h-42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#feca00",
    style: {
      fill: "var(--color9, #feca00)"
    },
    d: "M0 16v16h42.667v-16h-42.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-poland",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M0 0v32h42.667v-32h-42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c51918",
    style: {
      fill: "var(--color7, #c51918)"
    },
    d: "M0 16v16h42.667v-16h-42.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-italy",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c51918",
    style: {
      fill: "var(--color7, #c51918)"
    },
    d: "M29.333 0h13.333v32h-13.333v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5eaa22",
    style: {
      fill: "var(--color11, #5eaa22)"
    },
    d: "M0 0h16v32h-16v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M13.333 0h16v32h-16v-32z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-france",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    style: {
      fill: "var(--color8, #ebebeb)"
    },
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f50100",
    style: {
      fill: "var(--color13, #f50100)"
    },
    d: "M29.333 0h13.333v32h-13.333v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e42a5",
    style: {
      fill: "var(--color3, #2e42a5)"
    },
    d: "M0 0h16v32h-16v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    style: {
      fill: "var(--color8, #ebebeb)"
    },
    d: "M13.333 0h16v32h-16v-32z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-belgium",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#feca00",
    style: {
      fill: "var(--color9, #feca00)"
    },
    d: "M13.333 0h14.667v32h-14.667v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e31d1c",
    style: {
      fill: "var(--color2, #e31d1c)"
    },
    d: "M28 0h14.667v32h-14.667v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1d",
    style: {
      fill: "var(--color14, #1d1d1d)"
    },
    d: "M0 0h14.667v32h-14.667v-32z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-portugal",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef0000",
    style: {
      fill: "var(--color15, #ef0000)"
    },
    d: "M10.667 0h32v32h-32v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f8d00",
    style: {
      fill: "var(--color16, #2f8d00)"
    },
    d: "M0 0h16v32h-16v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe017",
    style: {
      fill: "var(--color17, #ffe017)"
    },
    d: "M15.229 5.333h1.333v3.598h-1.333v-3.598z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe017",
    style: {
      fill: "var(--color17, #ffe017)"
    },
    d: "M15.229 23.333h1.333v3.341h-1.333v-3.341z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe017",
    style: {
      fill: "var(--color17, #ffe017)"
    },
    d: "M5.748 16.544l-0.373-0.956c4.114-1.642 7.218-2.701 9.325-3.179 3.091-0.7 6.487-1.218 10.189-1.555l0.091 1.024c-3.659 0.332-7.012 0.844-10.057 1.534-2.044 0.463-5.106 1.507-9.174 3.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe017",
    style: {
      fill: "var(--color17, #ffe017)"
    },
    d: "M25.52 10.217l-0.302 0.981c-3.109-0.982-5.642-1.403-7.588-1.273l-0.067-1.026c2.090-0.14 4.74 0.301 7.958 1.317z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe017",
    style: {
      fill: "var(--color17, #ffe017)"
    },
    d: "M26.592 15.708l-0.575 0.848c-1.585-1.1-3.537-1.653-5.871-1.653v-1.028c2.53 0 4.683 0.609 6.446 1.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe017",
    style: {
      fill: "var(--color17, #ffe017)"
    },
    d: "M25.736 16.021l0.263 0.993c-3.417 0.925-6.625 1.451-9.624 1.574-3.020 0.124-6.54-0.402-10.562-1.577l0.282-0.988c3.925 1.146 7.339 1.657 10.24 1.538 2.921-0.12 6.055-0.633 9.403-1.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe017",
    style: {
      fill: "var(--color17, #ffe017)"
    },
    d: "M25.347 20.852l-1.606 1.646c-3.052-3.049-5.738-5.229-8.043-6.539-2.344-1.332-5.402-2.685-9.167-4.053l0.772-2.177c3.877 1.408 7.046 2.811 9.514 4.213 2.507 1.425 5.345 3.727 8.53 6.909z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe017",
    style: {
      fill: "var(--color17, #ffe017)"
    },
    d: "M7.274 21.787l-0.608-0.824c0.085-0.064 0.236-0.171 0.445-0.307 0.345-0.224 0.727-0.447 1.139-0.656 1.134-0.575 2.271-0.934 3.356-0.967 0.053-0.002 0.106-0.002 0.158-0.002v1.028c-0.042 0-0.085 0.001-0.128 0.002-0.914 0.028-1.918 0.345-2.931 0.859-0.378 0.192-0.729 0.397-1.045 0.602-0.11 0.071-0.207 0.137-0.29 0.196-0.049 0.034-0.081 0.058-0.096 0.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe017",
    style: {
      fill: "var(--color17, #ffe017)"
    },
    d: "M7.75 22.141l0.256-0.995c3.387 0.892 5.998 1.336 7.82 1.336 1.815 0 4.518-0.524 8.089-1.576l0.284 0.987c-3.656 1.077-6.441 1.617-8.373 1.617-1.925 0-4.613-0.458-8.076-1.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe017",
    style: {
      fill: "var(--color17, #ffe017)"
    },
    d: "M6.427 12.934l1.609-1.643 2.356 2.365-1.609 1.643-2.356-2.365z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe017",
    style: {
      fill: "var(--color17, #ffe017)"
    },
    d: "M19.781 21.137l1.197-1.971 3.738 2.326-1.197 1.971-3.738-2.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9e813",
    style: {
      fill: "var(--color18, #f9e813)"
    },
    d: "M15.87 5.594c5.68 0 10.283 4.66 10.284 10.409s-4.604 10.411-10.284 10.411c-5.681 0-10.286-4.662-10.286-10.411s4.606-10.409 10.286-10.409zM15.995 7.135c-4.909 0.001-8.888 4.029-8.888 8.997s3.98 8.994 8.888 8.995c4.909 0 8.89-4.027 8.891-8.995s-3.981-8.997-8.891-8.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M10.208 9.583v8.348c0.55 3.304 2.401 4.956 5.554 4.956s5.004-1.652 5.554-4.956v-8.348h-11.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c51918",
    style: {
      fill: "var(--color7, #c51918)"
    },
    d: "M8.115 8h14.765v9.897l-0.012 0.069c-0.713 3.954-3.242 6.035-7.37 6.035s-6.657-2.080-7.37-6.035l-0.012-0.069v-9.897z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9e813",
    style: {
      fill: "var(--color18, #f9e813)"
    },
    d: "M12.068 12.943h-2.401v-2.401h2.401v2.401zM21.401 12.943h-2.401v-2.401h2.401v2.401z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9e813",
    style: {
      fill: "var(--color18, #f9e813)"
    },
    d: "M19.169 22.201h-2.401v-2.401h2.401v2.401zM21.534 18.313h-2.401v-2.398h2.401v2.398zM12.068 18.276h-2.401v-2.401h2.401v2.401z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9e813",
    style: {
      fill: "var(--color18, #f9e813)"
    },
    d: "M11.531 19.792h2.4v2.4h-2.4v-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M11.802 11.615h7.92v5.921c0 0-0.588 3.058-3.96 3.058s-3.96-3.058-3.96-3.058v-5.921z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#013399",
    style: {
      fill: "var(--color19, #013399)"
    },
    d: "M14.99 12.271h1.76v1.282c0 0-0.131 0.662-0.88 0.662s-0.88-0.662-0.88-0.662v-1.282z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#013399",
    style: {
      fill: "var(--color19, #013399)"
    },
    d: "M14.99 15.104h1.76v1.282c0 0-0.131 0.662-0.88 0.662s-0.88-0.662-0.88-0.662v-1.282z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#013399",
    style: {
      fill: "var(--color19, #013399)"
    },
    d: "M17.271 15.104h1.76v1.282c0 0-0.131 0.662-0.88 0.662s-0.88-0.662-0.88-0.662v-1.282z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#013399",
    style: {
      fill: "var(--color19, #013399)"
    },
    d: "M12.698 15.104h1.76v1.282c0 0-0.131 0.662-0.88 0.662s-0.88-0.662-0.88-0.662v-1.282z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#013399",
    style: {
      fill: "var(--color19, #013399)"
    },
    d: "M14.99 17.927h1.76v1.282c0 0-0.131 0.662-0.88 0.662s-0.88-0.662-0.88-0.662v-1.282z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-brazil",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093",
    style: {
      fill: "var(--color20, #093)"
    },
    d: "M0 0v32h42.667v-32h-42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd221",
    style: {
      fill: "var(--color21, #ffd221)"
    },
    d: "M21.236 4.939l16.269 11.338-16.49 10.618-15.936-10.838 16.157-11.118z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color22, #000)"
    },
    d: "M21.236 4.939l16.269 11.338-16.49 10.618-15.936-10.838 16.157-11.118z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e42a5",
    style: {
      fill: "var(--color3, #2e42a5)"
    },
    d: "M21.333 22.938c3.682 0 6.667-2.985 6.667-6.667s-2.985-6.667-6.667-6.667c-3.682 0-6.667 2.985-6.667 6.667s2.985 6.667 6.667 6.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M19.173 19.427l-0.298 0.157 0.057-0.332-0.241-0.235 0.333-0.048 0.149-0.302 0.149 0.302 0.333 0.048-0.241 0.235 0.057 0.332-0.298-0.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M21.84 19.427l-0.298 0.157 0.057-0.332-0.241-0.235 0.333-0.048 0.149-0.302 0.149 0.302 0.333 0.048-0.241 0.235 0.057 0.332-0.298-0.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M21.84 21.031l-0.298 0.157 0.057-0.332-0.241-0.235 0.333-0.048 0.149-0.302 0.149 0.302 0.333 0.048-0.241 0.235 0.057 0.332-0.298-0.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M20.507 15.427l-0.298 0.157 0.057-0.332-0.241-0.235 0.333-0.048 0.149-0.302 0.149 0.302 0.333 0.048-0.241 0.235 0.057 0.332-0.298-0.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M20.507 18.093l-0.298 0.157 0.057-0.332-0.241-0.235 0.333-0.048 0.149-0.302 0.149 0.302 0.333 0.048-0.241 0.235 0.057 0.332-0.298-0.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M18.642 16.76l-0.298 0.157 0.057-0.332-0.241-0.235 0.333-0.048 0.149-0.302 0.149 0.302 0.333 0.048-0.241 0.235 0.057 0.332-0.298-0.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M16.777 17.823l-0.298 0.157 0.057-0.332-0.241-0.235 0.333-0.048 0.149-0.302 0.149 0.302 0.333 0.048-0.241 0.235 0.057 0.332-0.298-0.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M22.902 13.291l-0.298 0.157 0.057-0.332-0.241-0.235 0.333-0.048 0.149-0.302 0.149 0.302 0.333 0.048-0.241 0.235 0.057 0.332-0.298-0.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M13.229 14.659l0.2-2.659c6.397 0.482 11.446 2.586 15.084 6.327l-1.912 1.859c-3.153-3.243-7.589-5.091-13.373-5.527z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-united-states",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    style: {
      fill: "var(--color8, #ebebeb)"
    },
    d: "M8 0h26.667c4.418 0 8 3.582 8 8v16c0 4.418-3.582 8-8 8h-26.667c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e31d1c",
    style: {
      fill: "var(--color2, #e31d1c)"
    },
    d: "M0 0h42.667v32h-42.667v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    style: {
      fill: "var(--color8, #ebebeb)"
    },
    d: "M42.667 29.333v2.667h-42.667v-2.667h42.667zM42.667 26.667h-42.667v-2.667h42.667v2.667zM42.667 21.333h-42.667v-2.667h42.667v2.667zM42.667 16h-42.667v-2.667h42.667v2.667zM42.667 10.667h-42.667v-2.667h42.667v2.667zM42.667 5.333h-42.667v-2.667h42.667v2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e42a5",
    style: {
      fill: "var(--color3, #2e42a5)"
    },
    d: "M0 0h24v18.667h-24v-18.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    style: {
      fill: "var(--color8, #ebebeb)"
    },
    d: "M20.833 2.94h1.398l-1.099 1.109 0.424 1.753-1.367-0.984-1.13 0.789h0.505l-1.099 1.109 0.378 1.557h0.797l0.549-1.43 0.643 1.43h1.398l-1.099 1.109 0.424 1.753-1.367-0.984-1.13 0.789h0.505l-1.099 1.109 0.378 1.557h0.797l0.549-1.43 0.643 1.43h1.398l-1.099 1.109 0.424 1.753-1.367-0.984-1.411 0.984 0.477-1.753-1.255-1.109h0.62l-1.096-0.789-1.13 0.789h0.505l-1.099 1.109 0.424 1.753-1.367-0.984-1.411 0.984 0.477-1.753-1.255-1.109h0.62l-1.096-0.789-1.13 0.789h0.505l-1.099 1.109 0.424 1.753-1.367-0.984-1.411 0.984 0.477-1.753-1.255-1.109h0.62l-1.096-0.789-1.13 0.789h0.505l-1.099 1.109 0.424 1.753-1.367-0.984-1.411 0.984 0.477-1.753-1.255-1.109h1.641l0.55-1.43 0.643 1.43h0.664l0.424-1.557-1.255-1.109h0.62l-1.096-0.789-1.411 0.984 0.477-1.753-1.255-1.109h1.641l0.55-1.43 0.643 1.43h0.664l0.424-1.557-1.255-1.109h0.62l-1.096-0.789-1.411 0.984 0.477-1.753-1.255-1.109h1.641l0.55-1.43 0.643 1.43h1.398l-1.099 1.109 0.378 1.557h0.797l0.55-1.43 0.643 1.43h0.664l0.424-1.557-1.255-1.109h1.641l0.55-1.43 0.643 1.43h1.398l-1.099 1.109 0.378 1.557h0.797l0.55-1.43 0.643 1.43h0.664l0.424-1.557-1.255-1.109h1.641l0.55-1.43 0.643 1.43h1.398l-1.099 1.109 0.378 1.557h0.797l0.549-1.43 0.643 1.43h0.664l0.424-1.557-1.255-1.109h1.641l0.549-1.43 0.643 1.43zM13.727 10.94h0.505l-1.099 1.109 0.378 1.557h0.797l0.55-1.43 0.643 1.43h0.664l0.424-1.557-1.255-1.109h0.62l-1.096-0.789-1.13 0.789zM8.393 10.94h0.505l-1.099 1.109 0.378 1.557h0.797l0.55-1.43 0.643 1.43h0.664l0.424-1.557-1.255-1.109h0.62l-1.096-0.789-1.13 0.789zM16.393 8.273h0.505l-1.099 1.109 0.378 1.557h0.797l0.549-1.43 0.643 1.43h0.664l0.424-1.557-1.255-1.109h0.62l-1.096-0.789-1.13 0.789zM5.727 8.273h0.505l-1.099 1.109 0.378 1.557h0.797l0.55-1.43 0.643 1.43h0.664l0.424-1.557-1.255-1.109h0.62l-1.096-0.789-1.13 0.789zM11.060 8.273h0.505l-1.099 1.109 0.378 1.557h0.797l0.55-1.43 0.643 1.43h0.664l0.424-1.557-1.255-1.109h0.62l-1.096-0.789-1.13 0.789zM8.393 5.607h0.505l-1.099 1.109 0.378 1.557h0.797l0.55-1.43 0.643 1.43h0.664l0.424-1.557-1.255-1.109h0.62l-1.096-0.789-1.13 0.789zM13.727 5.607h0.505l-1.099 1.109 0.378 1.557h0.797l0.55-1.43 0.643 1.43h0.664l0.424-1.557-1.255-1.109h0.62l-1.096-0.789-1.13 0.789z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-flag-canada",
    viewBox: "0 0 43 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color1, #fff)"
    },
    d: "M0 0h42.667v32h-42.667v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fcff",
    style: {
      fill: "var(--color4, #f7fcff)"
    },
    d: "M10.667 0h22.667v32h-22.667v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e31d1c",
    style: {
      fill: "var(--color2, #e31d1c)"
    },
    d: "M21.333 26.667h-0.914l0.56-4.62c-0.091 0.017-6.141 1.124-5.641 0.56 0.505-0.566 0.798-1.601 0.802-1.615l-5.474-3.729c0.003-0 0.864-0.012 1.565-0.438 0.7-0.425-0.69-2.937-0.7-2.956l2.763 0.411 1.044-1.161 2.086 2.229h0.938l-0.938-5.104 1.68 0.958 2.193-3.203 0.036 18.667zM23.563 11.203l1.68-0.958-0.938 5.104h0.938l2.086-2.229 1.044 1.161 2.763-0.411c-0.010 0.019-1.401 2.531-0.701 2.956 0.701 0.425 1.562 0.437 1.565 0.438l-5.474 3.729c0.004 0.014 0.297 1.049 0.802 1.615 0.501 0.564-5.549-0.543-5.64-0.56l0.56 4.62h-0.914v-18.667l2.229 3.203z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e31d1c",
    style: {
      fill: "var(--color2, #e31d1c)"
    },
    d: "M32 0h10.667v32h-10.667v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e31d1c",
    style: {
      fill: "var(--color2, #e31d1c)"
    },
    d: "M0 0h10.667v32h-10.667v-32z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ai-video",
    viewBox: "0 0 32 32"
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.533 0h14.933c4.713 0 8.533 3.821 8.533 8.533v14.933c0 4.713-3.82 8.533-8.533 8.533h-14.933c-4.713 0-8.533-3.82-8.533-8.533v-14.933c0-4.713 3.821-8.533 8.533-8.533z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    style: {
      fill: "var(--color2, #595959)"
    },
    d: "M20.937 7.771c1.767 0 3.2 1.433 3.2 3.2v5.211c0 0-0.364-0.302-0.64-0.411-0.27-0.107-0.731-0.137-0.731-0.137v-4.663c0-1.010-0.819-1.829-1.829-1.829h-9.966c-1.010 0-1.829 0.819-1.829 1.829v9.966c0 1.010 0.819 1.829 1.829 1.829h5.824c0.104 0.512 0.331 0.98 0.647 1.371l-6.554-0.001c-1.729-0.044-3.117-1.459-3.117-3.199v-9.966c0-1.767 1.433-3.2 3.2-3.2h9.966z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    style: {
      fill: "var(--color2, #595959)"
    },
    d: "M18.697 15.12c0.61 0.352 0.61 1.232 0 1.584l-3.497 2.019c-0.571 0.33-1.277-0.036-1.363-0.663l-0.009-0.129v-4.038l0.009-0.129c0.086-0.627 0.791-0.993 1.363-0.663l3.497 2.019zM15.109 14.527v2.771l2.4-1.386-2.4-1.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    style: {
      fill: "var(--color2, #595959)"
    },
    d: "M24.579 21.978l-1.037-1.201-4.133 3.57c-0.467 0.403 0.57 1.604 1.037 1.201l4.133-3.57zM26.156 20.616l-1.371 1.184-1.034-1.203 1.368-1.182c0.465-0.402 1.502 0.799 1.037 1.201zM28.795 22.256l-0.412 0.095c-0.341 0.078-0.621 0.32-0.748 0.646l-0.154 0.394c-0.025 0.063-0.116 0.056-0.131-0.010l-0.095-0.412c-0.078-0.341-0.32-0.621-0.646-0.748l-0.394-0.154c-0.063-0.025-0.056-0.116 0.010-0.131l0.412-0.095c0.341-0.078 0.621-0.32 0.748-0.646l0.154-0.394c0.025-0.063 0.116-0.056 0.131 0.010l0.095 0.412c0.078 0.341 0.32 0.621 0.646 0.748l0.394 0.154c0.063 0.025 0.056 0.116-0.009 0.131zM23.93 18.88l-0.252 0.058c-0.208 0.048-0.379 0.196-0.457 0.395l-0.094 0.241c-0.015 0.038-0.071 0.034-0.080-0.006l-0.058-0.252c-0.048-0.208-0.195-0.379-0.394-0.457l-0.241-0.094c-0.039-0.015-0.034-0.071 0.006-0.080l0.252-0.058c0.208-0.048 0.379-0.196 0.457-0.395l0.094-0.241c0.015-0.039 0.071-0.035 0.080 0.006l0.058 0.252c0.048 0.208 0.196 0.379 0.394 0.457l0.241 0.094c0.039 0.015 0.034 0.071-0.006 0.080zM26.46 17.552l-0.313 0.072c-0.258 0.059-0.471 0.243-0.567 0.49l-0.117 0.299c-0.019 0.048-0.088 0.043-0.099-0.007l-0.072-0.313c-0.059-0.259-0.243-0.471-0.49-0.567l-0.299-0.117c-0.048-0.019-0.043-0.088 0.007-0.099l0.313-0.072c0.259-0.059 0.471-0.243 0.567-0.49l0.117-0.299c0.019-0.048 0.088-0.043 0.099 0.007l0.072 0.313c0.059 0.258 0.243 0.471 0.49 0.567l0.299 0.117c0.048 0.019 0.043 0.088-0.007 0.099z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ai-image",
    viewBox: "0 0 32 32"
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.533 0h14.933c4.713 0 8.533 3.821 8.533 8.533v14.933c0 4.713-3.82 8.533-8.533 8.533h-14.933c-4.713 0-8.533-3.82-8.533-8.533v-14.933c0-4.713 3.821-8.533 8.533-8.533z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    style: {
      fill: "var(--color2, #595959)"
    },
    d: "M11.936 14.877c0.739-0.514 1.72-0.513 2.458 0.003l4.787 3.346c0.31 0.217 0.386 0.644 0.169 0.955s-0.644 0.386-0.955 0.17l-4.787-3.347c-0.267-0.186-0.622-0.187-0.889-0.001l-3.825 2.663c-0.311 0.216-0.738 0.139-0.954-0.171s-0.14-0.738 0.171-0.954l3.826-2.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    style: {
      fill: "var(--color2, #595959)"
    },
    d: "M20.114 12.937c0 0.682-0.553 1.234-1.234 1.234s-1.234-0.553-1.234-1.234c0-0.682 0.553-1.234 1.234-1.234s1.234 0.553 1.234 1.234z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    style: {
      fill: "var(--color2, #595959)"
    },
    d: "M20.937 7.771c1.767 0 3.2 1.433 3.2 3.2v5.211c0 0-0.364-0.302-0.64-0.411-0.27-0.107-0.731-0.137-0.731-0.137v-4.663c0-1.010-0.819-1.829-1.829-1.829h-9.966c-1.010 0-1.829 0.819-1.829 1.829v9.966c0 1.010 0.819 1.829 1.829 1.829h5.824c0.104 0.512 0.331 0.98 0.647 1.371l-6.554-0.001c-1.729-0.044-3.117-1.459-3.117-3.199v-9.966c0-1.767 1.433-3.2 3.2-3.2h9.966z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    style: {
      fill: "var(--color2, #595959)"
    },
    d: "M24.58 21.978l-1.037-1.201-4.133 3.57c-0.453 0.391 0.533 1.636 1.037 1.201l4.133-3.57zM26.157 20.616l-1.371 1.184-1.034-1.203 1.368-1.181c0.465-0.402 1.502 0.799 1.037 1.201zM28.795 22.255l-0.412 0.095c-0.341 0.078-0.621 0.32-0.748 0.646l-0.154 0.394c-0.025 0.063-0.116 0.056-0.131-0.010l-0.095-0.412c-0.078-0.341-0.32-0.621-0.646-0.748l-0.394-0.154c-0.063-0.025-0.056-0.116 0.010-0.131l0.412-0.095c0.341-0.078 0.621-0.32 0.748-0.646l0.154-0.394c0.025-0.063 0.116-0.056 0.131 0.010l0.095 0.412c0.078 0.341 0.32 0.621 0.646 0.748l0.394 0.154c0.063 0.025 0.056 0.116-0.009 0.131zM23.93 18.88l-0.252 0.058c-0.208 0.048-0.379 0.195-0.457 0.394l-0.094 0.241c-0.015 0.039-0.071 0.034-0.080-0.006l-0.058-0.252c-0.048-0.208-0.196-0.379-0.394-0.457l-0.241-0.094c-0.039-0.015-0.034-0.071 0.006-0.080l0.252-0.058c0.208-0.048 0.379-0.196 0.457-0.394l0.094-0.241c0.015-0.039 0.071-0.034 0.080 0.006l0.058 0.252c0.048 0.208 0.195 0.379 0.394 0.457l0.241 0.094c0.039 0.015 0.034 0.071-0.006 0.080zM26.46 17.551l-0.313 0.072c-0.258 0.060-0.471 0.243-0.567 0.49l-0.117 0.299c-0.019 0.048-0.088 0.043-0.099-0.007l-0.072-0.313c-0.059-0.258-0.243-0.471-0.49-0.567l-0.299-0.117c-0.048-0.019-0.043-0.088 0.007-0.099l0.313-0.072c0.259-0.059 0.471-0.243 0.567-0.49l0.117-0.299c0.019-0.048 0.088-0.043 0.099 0.007l0.072 0.313c0.059 0.259 0.243 0.471 0.49 0.567l0.299 0.117c0.048 0.019 0.043 0.088-0.007 0.099z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-rose-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2cad9",
    style: {
      fill: "var(--color1, #f2cad9)"
    },
    d: "M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    style: {
      fill: "var(--color2, #595959)"
    },
    d: "M9.6 16c0-0.728 0.59-1.318 1.318-1.318h3.765v-3.765c0-0.728 0.59-1.318 1.318-1.318s1.318 0.59 1.318 1.318v3.765h3.765c0.728 0 1.318 0.59 1.318 1.318s-0.59 1.318-1.318 1.318h-3.765v3.765c0 0.728-0.59 1.318-1.318 1.318s-1.318-0.59-1.318-1.318v-3.765h-3.765c-0.728 0-1.318-0.59-1.318-1.318z"
  })), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-exclamation_mark",
    viewBox: "0 0 35 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.639 25.58l-13.454-23.304c-0.748-1.296-2.088-2.070-3.584-2.070s-2.836 0.774-3.585 2.070l-13.454 23.304c-0.748 1.296-0.748 2.843 0 4.139s2.088 2.069 3.585 2.069h26.909c1.496 0 2.836-0.774 3.585-2.069s0.748-2.843 0-4.139zM32.853 28.688c-0.375 0.65-1.048 1.038-1.799 1.038h-26.909c-0.751 0-1.423-0.388-1.799-1.038s-0.375-1.427 0-2.077l13.454-23.304c0.375-0.65 1.048-1.038 1.799-1.038s1.423 0.388 1.799 1.038l13.454 23.304c0.375 0.65 0.375 1.427-0 2.077z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.631 10.501h-2.062v10.311h2.062v-10.311z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 22.875c-0.758 0-1.375 0.617-1.375 1.375s0.617 1.375 1.375 1.375c0.758 0 1.375-0.617 1.375-1.375s-0.617-1.375-1.375-1.375z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-google",
    viewBox: "0 0 31 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    style: {
      fill: "var(--color1, #4285f4)"
    },
    d: "M16 13.091v6.196h8.611c-0.378 1.993-1.513 3.68-3.215 4.815l5.193 4.029c3.026-2.793 4.771-6.895 4.771-11.767 0-1.134-0.102-2.226-0.291-3.273l-15.069-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    style: {
      fill: "var(--color2, #34a853)"
    },
    d: "M7.033 19.046l-1.171 0.897-4.146 3.229c2.633 5.222 8.029 8.829 14.283 8.829 4.32 0 7.942-1.425 10.589-3.869l-5.193-4.029c-1.425 0.96-3.244 1.542-5.396 1.542-4.16 0-7.694-2.807-8.96-6.589l-0.007-0.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    style: {
      fill: "var(--color3, #fbbc05)"
    },
    d: "M1.716 8.829c-1.091 2.153-1.716 4.582-1.716 7.171s0.625 5.018 1.716 7.171c0 0.014 5.324-4.131 5.324-4.131-0.32-0.96-0.509-1.978-0.509-3.040s0.189-2.080 0.509-3.040l-5.324-4.131z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    style: {
      fill: "var(--color4, #ea4335)"
    },
    d: "M16 6.371c2.356 0 4.451 0.815 6.124 2.385l4.582-4.582c-2.778-2.589-6.386-4.175-10.706-4.175-6.255 0-11.651 3.593-14.284 8.829l5.324 4.131c1.265-3.782 4.8-6.589 8.96-6.589z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgSprite);
export default __webpack_public_path__ + "static/media/svgSprite.92c101183f9a310c217639fa0803c9b7.svg";
export { ForwardRef as ReactComponent };